//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, c = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, l = /* @__PURE__ */ ((n, r, o) => (o = n == null ? {} : e(i(n)), c(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)))((/* @__PURE__ */ o(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n ||= self, n.JSBI = r());
	})(e, function() {
		var e = Math.imul, t = Math.clz32;
		function n(e, t) {
			(t == null || t > e.length) && (t = e.length);
			for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
			return r;
		}
		function r(e) {
			if (Array.isArray(e)) return e;
		}
		function i(e) {
			if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
			return e;
		}
		function a(e, t, n) {
			return t = d(t), _(e, m() ? Reflect.construct(t, n || [], d(e).constructor) : t.apply(e, n));
		}
		function o(e, t) {
			if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
		}
		function s(e, t, n) {
			if (m()) return Reflect.construct.apply(null, arguments);
			var r = [null];
			r.push.apply(r, t);
			var i = new (e.bind.apply(e, r))();
			return n && v(i, n.prototype), i;
		}
		function c(e, t) {
			for (var n, r = 0; r < t.length; r++) n = t[r], n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b(n.key), n);
		}
		function l(e, t, n) {
			return t && c(e.prototype, t), n && c(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
		}
		function u(e, t) {
			var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
			if (!n) {
				if (Array.isArray(e) || (n = te(e)) || t && e && typeof e.length == "number") {
					n && (e = n);
					var r = 0, i = function() {};
					return {
						s: i,
						n: function() {
							return r >= e.length ? { done: !0 } : {
								done: !1,
								value: e[r++]
							};
						},
						e: function(e) {
							throw e;
						},
						f: i
					};
				}
				throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
			}
			var a, o = !0, s = !1;
			return {
				s: function() {
					n = n.call(e);
				},
				n: function() {
					var e = n.next();
					return o = e.done, e;
				},
				e: function(e) {
					s = !0, a = e;
				},
				f: function() {
					try {
						o || n.return == null || n.return();
					} finally {
						if (s) throw a;
					}
				}
			};
		}
		function d(e) {
			return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
				return e.__proto__ || Object.getPrototypeOf(e);
			}, d(e);
		}
		function f(e, t) {
			if (typeof t != "function" && t !== null) throw TypeError("Super expression must either be null or a function");
			e.prototype = Object.create(t && t.prototype, { constructor: {
				value: e,
				writable: !0,
				configurable: !0
			} }), Object.defineProperty(e, "prototype", { writable: !1 }), t && v(e, t);
		}
		function p(e) {
			try {
				return Function.toString.call(e).indexOf("[native code]") !== -1;
			} catch {
				return typeof e == "function";
			}
		}
		function m() {
			try {
				var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
			} catch {}
			return (m = function() {
				return !!e;
			})();
		}
		function h(e, t) {
			var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
			if (n != null) {
				var r, i, a, o, s = [], c = !0, l = !1;
				try {
					if (a = (n = n.call(e)).next, t === 0) {
						if (Object(n) !== n) return;
						c = !1;
					} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
				} catch (e) {
					l = !0, i = e;
				} finally {
					try {
						if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
					} finally {
						if (l) throw i;
					}
				}
				return s;
			}
		}
		function g() {
			throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function _(e, t) {
			if (t && (typeof t == "object" || typeof t == "function")) return t;
			if (t !== void 0) throw TypeError("Derived constructors may only return object or undefined");
			return i(e);
		}
		function v(e, t) {
			return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
				return e.__proto__ = t, e;
			}, v(e, t);
		}
		function y(e, t) {
			return r(e) || h(e, t) || te(e, t) || g();
		}
		function ee(e, t) {
			if (typeof e != "object" || !e) return e;
			var n = e[Symbol.toPrimitive];
			if (n !== void 0) {
				var r = n.call(e, t || "default");
				if (typeof r != "object") return r;
				throw TypeError("@@toPrimitive must return a primitive value.");
			}
			return (t === "string" ? String : Number)(e);
		}
		function b(e) {
			var t = ee(e, "string");
			return typeof t == "symbol" ? t : t + "";
		}
		function x(e) {
			"@babel/helpers - typeof";
			return x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
				return typeof e;
			} : function(e) {
				return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
			}, x(e);
		}
		function te(e, t) {
			if (e) {
				if (typeof e == "string") return n(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
			}
		}
		function ne(e) {
			var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
			return ne = function(e) {
				function n() {
					return s(e, arguments, d(this).constructor);
				}
				if (e === null || !p(e)) return e;
				if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
				if (t !== void 0) {
					if (t.has(e)) return t.get(e);
					t.set(e, n);
				}
				return n.prototype = Object.create(e.prototype, { constructor: {
					value: n,
					enumerable: !1,
					writable: !0,
					configurable: !0
				} }), v(n, e);
			}, ne(e);
		}
		var S = function(e) {
			var t = Math.abs, n = Math.max, r = Math.floor;
			function i(e, t) {
				var n;
				if (o(this, i), n = a(this, i, [e]), n.sign = t, Object.setPrototypeOf(n, i.prototype), e > i.__kMaxLength) throw RangeError("Maximum BigInt size exceeded");
				return n;
			}
			return f(i, e), l(i, [
				{
					key: "toDebugString",
					value: function() {
						var e, t = ["BigInt["], n = u(this);
						try {
							for (n.s(); !(e = n.n()).done;) {
								var r = e.value;
								t.push((r && (r >>> 0).toString(16)) + ", ");
							}
						} catch (e) {
							n.e(e);
						} finally {
							n.f();
						}
						return t.push("]"), t.join("");
					}
				},
				{
					key: "toString",
					value: function() {
						var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : 10;
						if (2 > e || 36 < e) throw RangeError("toString() radix argument must be between 2 and 36");
						return this.length === 0 ? "0" : e & e - 1 ? i.__toStringGeneric(this, e, !1) : i.__toStringBasePowerOfTwo(this, e);
					}
				},
				{
					key: "valueOf",
					value: function() {
						throw Error("Convert JSBI instances to native numbers using `toNumber`.");
					}
				},
				{
					key: "__copy",
					value: function() {
						for (var e = new i(this.length, this.sign), t = 0; t < this.length; t++) e[t] = this[t];
						return e;
					}
				},
				{
					key: "__trim",
					value: function() {
						for (var e = this.length, t = this[e - 1]; t === 0;) e--, t = this[e - 1], this.pop();
						return e === 0 && (this.sign = !1), this;
					}
				},
				{
					key: "__initializeDigits",
					value: function() {
						for (var e = 0; e < this.length; e++) this[e] = 0;
					}
				},
				{
					key: "__clzmsd",
					value: function() {
						return i.__clz30(this.__digit(this.length - 1));
					}
				},
				{
					key: "__inplaceMultiplyAdd",
					value: function(e, t, n) {
						n > this.length && (n = this.length);
						for (var r = 32767 & e, a = e >>> 15, o = 0, s = t, c = 0; c < n; c++) {
							var l = this.__digit(c), u = 32767 & l, d = l >>> 15, f = i.__imul(u, r), p = i.__imul(u, a), m = i.__imul(d, r), h = i.__imul(d, a), g = s + f + o;
							o = g >>> 30, g &= 1073741823, g += ((32767 & p) << 15) + ((32767 & m) << 15), o += g >>> 30, s = h + (p >>> 15) + (m >>> 15), this.__setDigit(c, 1073741823 & g);
						}
						if (o !== 0 || s !== 0) throw Error("implementation bug");
					}
				},
				{
					key: "__inplaceAdd",
					value: function(e, t, n) {
						for (var r, i = 0, a = 0; a < n; a++) r = this.__halfDigit(t + a) + e.__halfDigit(a) + i, i = r >>> 15, this.__setHalfDigit(t + a, 32767 & r);
						return i;
					}
				},
				{
					key: "__inplaceSub",
					value: function(e, t, n) {
						var r = n - 1 >>> 1, i = 0;
						if (1 & t) {
							t >>= 1;
							for (var a = this.__digit(t), o = 32767 & a, s = 0; s < r; s++) {
								var c = e.__digit(s), l = (a >>> 15) - (32767 & c) - i;
								i = 1 & l >>> 15, this.__setDigit(t + s, (32767 & l) << 15 | 32767 & o), a = this.__digit(t + s + 1), o = (32767 & a) - (c >>> 15) - i, i = 1 & o >>> 15;
							}
							var u = e.__digit(s), d = (a >>> 15) - (32767 & u) - i;
							i = 1 & d >>> 15, this.__setDigit(t + s, (32767 & d) << 15 | 32767 & o);
							var f = u >>> 15;
							if (t + s + 1 >= this.length) throw RangeError("out of bounds");
							!(1 & n) && (a = this.__digit(t + s + 1), o = (32767 & a) - f - i, i = 1 & o >>> 15, this.__setDigit(t + e.length, 1073709056 & a | 32767 & o));
						} else {
							t >>= 1;
							for (var p = 0; p < e.length - 1; p++) {
								var m = this.__digit(t + p), h = e.__digit(p), g = (32767 & m) - (32767 & h) - i;
								i = 1 & g >>> 15;
								var _ = (m >>> 15) - (h >>> 15) - i;
								i = 1 & _ >>> 15, this.__setDigit(t + p, (32767 & _) << 15 | 32767 & g);
							}
							var v = this.__digit(t + p), y = e.__digit(p), ee = (32767 & v) - (32767 & y) - i;
							i = 1 & ee >>> 15;
							var b = 0;
							!(1 & n) && (b = (v >>> 15) - (y >>> 15) - i, i = 1 & b >>> 15), this.__setDigit(t + p, (32767 & b) << 15 | 32767 & ee);
						}
						return i;
					}
				},
				{
					key: "__inplaceRightShift",
					value: function(e) {
						if (e !== 0) {
							for (var t, n = this.__digit(0) >>> e, r = this.length - 1, i = 0; i < r; i++) t = this.__digit(i + 1), this.__setDigit(i, 1073741823 & t << 30 - e | n), n = t >>> e;
							this.__setDigit(r, n);
						}
					}
				},
				{
					key: "__digit",
					value: function(e) {
						return this[e];
					}
				},
				{
					key: "__unsignedDigit",
					value: function(e) {
						return this[e] >>> 0;
					}
				},
				{
					key: "__setDigit",
					value: function(e, t) {
						this[e] = 0 | t;
					}
				},
				{
					key: "__setDigitGrow",
					value: function(e, t) {
						this[e] = 0 | t;
					}
				},
				{
					key: "__halfDigitLength",
					value: function() {
						var e = this.length;
						return 32767 >= this.__unsignedDigit(e - 1) ? 2 * e - 1 : 2 * e;
					}
				},
				{
					key: "__halfDigit",
					value: function(e) {
						return 32767 & this[e >>> 1] >>> 15 * (1 & e);
					}
				},
				{
					key: "__setHalfDigit",
					value: function(e, t) {
						var n = e >>> 1, r = this.__digit(n), i = 1 & e ? 32767 & r | t << 15 : 1073709056 & r | 32767 & t;
						this.__setDigit(n, i);
					}
				}
			], [
				{
					key: "BigInt",
					value: function(e) {
						var t = Number.isFinite;
						if (typeof e == "number") {
							if (e === 0) return i.__zero();
							if (i.__isOneDigitInt(e)) return 0 > e ? i.__oneDigit(-e, !0) : i.__oneDigit(e, !1);
							if (!t(e) || r(e) !== e) throw RangeError("The number " + e + " cannot be converted to BigInt because it is not an integer");
							return i.__fromDouble(e);
						}
						if (typeof e == "string") {
							var n = i.__fromString(e);
							if (n === null) throw SyntaxError("Cannot convert " + e + " to a BigInt");
							return n;
						}
						if (typeof e == "boolean") return !0 === e ? i.__oneDigit(1, !1) : i.__zero();
						if (x(e) === "object") {
							if (e.constructor === i) return e;
							var a = i.__toPrimitive(e);
							return i.BigInt(a);
						}
						throw TypeError("Cannot convert " + e + " to a BigInt");
					}
				},
				{
					key: "toNumber",
					value: function(e) {
						var t = e.length;
						if (t === 0) return 0;
						if (t === 1) {
							var n = e.__unsignedDigit(0);
							return e.sign ? -n : n;
						}
						var r = e.__digit(t - 1), a = i.__clz30(r), o = 30 * t - a;
						if (1024 < o) return e.sign ? -Infinity : 1 / 0;
						var s = o - 1, c = r, l = t - 1, u = a + 3, d = u === 32 ? 0 : c << u;
						d >>>= 12;
						var f = u - 12, p = 12 <= u ? 0 : c << 20 + u, m = 20 + u;
						for (0 < f && 0 < l && (l--, c = e.__digit(l), d |= c >>> 30 - f, p = c << f + 2, m = f + 2); 0 < m && 0 < l;) l--, c = e.__digit(l), p |= 30 <= m ? c << m - 30 : c >>> 30 - m, m -= 30;
						var h = i.__decideRounding(e, m, l, c);
						if ((h === 1 || h === 0 && (1 & p) == 1) && (p = p + 1 >>> 0, p === 0 && (d++, d >>> 20 && (d = 0, s++, 1023 < s)))) return e.sign ? -Infinity : 1 / 0;
						var g = e.sign ? -2147483648 : 0;
						return s = s + 1023 << 20, i.__kBitConversionInts[i.__kBitConversionIntHigh] = g | s | d, i.__kBitConversionInts[i.__kBitConversionIntLow] = p, i.__kBitConversionDouble[0];
					}
				},
				{
					key: "unaryMinus",
					value: function(e) {
						if (e.length === 0) return e;
						var t = e.__copy();
						return t.sign = !e.sign, t;
					}
				},
				{
					key: "bitwiseNot",
					value: function(e) {
						return e.sign ? i.__absoluteSubOne(e).__trim() : i.__absoluteAddOne(e, !0);
					}
				},
				{
					key: "exponentiate",
					value: function(e, t) {
						if (t.sign) throw RangeError("Exponent must be positive");
						if (t.length === 0) return i.__oneDigit(1, !1);
						if (e.length === 0) return e;
						if (e.length === 1 && e.__digit(0) === 1) return e.sign && !(1 & t.__digit(0)) ? i.unaryMinus(e) : e;
						if (1 < t.length) throw RangeError("BigInt too big");
						var n = t.__unsignedDigit(0);
						if (n === 1) return e;
						if (n >= i.__kMaxLengthBits) throw RangeError("BigInt too big");
						if (e.length === 1 && e.__digit(0) === 2) {
							var r = 1 + (0 | n / 30), a = new i(r, e.sign && !!(1 & n));
							a.__initializeDigits();
							var o = 1 << n % 30;
							return a.__setDigit(r - 1, o), a;
						}
						var s = null, c = e;
						for (1 & n && (s = e), n >>= 1; n !== 0; n >>= 1) c = i.multiply(c, c), 1 & n && (s = s === null ? c : i.multiply(s, c));
						return s;
					}
				},
				{
					key: "multiply",
					value: function(e, t) {
						if (e.length === 0) return e;
						if (t.length === 0) return t;
						var n = e.length + t.length;
						30 <= e.__clzmsd() + t.__clzmsd() && n--;
						var r = new i(n, e.sign !== t.sign);
						r.__initializeDigits();
						for (var a = 0; a < e.length; a++) i.__multiplyAccumulate(t, e.__digit(a), r, a);
						return r.__trim();
					}
				},
				{
					key: "divide",
					value: function(e, t) {
						if (t.length === 0) throw RangeError("Division by zero");
						if (0 > i.__absoluteCompare(e, t)) return i.__zero();
						var n, r = e.sign !== t.sign, a = t.__unsignedDigit(0);
						if (t.length === 1 && 32767 >= a) {
							if (a === 1) return r === e.sign ? e : i.unaryMinus(e);
							n = i.__absoluteDivSmall(e, a, null);
						} else n = i.__absoluteDivLarge(e, t, !0, !1);
						return n.sign = r, n.__trim();
					}
				},
				{
					key: "remainder",
					value: function(e, t) {
						if (t.length === 0) throw RangeError("Division by zero");
						if (0 > i.__absoluteCompare(e, t)) return e;
						var n = t.__unsignedDigit(0);
						if (t.length === 1 && 32767 >= n) {
							if (n === 1) return i.__zero();
							var r = i.__absoluteModSmall(e, n);
							return r === 0 ? i.__zero() : i.__oneDigit(r, e.sign);
						}
						var a = i.__absoluteDivLarge(e, t, !1, !0);
						return a.sign = e.sign, a.__trim();
					}
				},
				{
					key: "add",
					value: function(e, t) {
						var n = e.sign;
						return n === t.sign ? i.__absoluteAdd(e, t, n) : 0 <= i.__absoluteCompare(e, t) ? i.__absoluteSub(e, t, n) : i.__absoluteSub(t, e, !n);
					}
				},
				{
					key: "subtract",
					value: function(e, t) {
						var n = e.sign;
						return n === t.sign ? 0 <= i.__absoluteCompare(e, t) ? i.__absoluteSub(e, t, n) : i.__absoluteSub(t, e, !n) : i.__absoluteAdd(e, t, n);
					}
				},
				{
					key: "leftShift",
					value: function(e, t) {
						return t.length === 0 || e.length === 0 ? e : t.sign ? i.__rightShiftByAbsolute(e, t) : i.__leftShiftByAbsolute(e, t);
					}
				},
				{
					key: "signedRightShift",
					value: function(e, t) {
						return t.length === 0 || e.length === 0 ? e : t.sign ? i.__leftShiftByAbsolute(e, t) : i.__rightShiftByAbsolute(e, t);
					}
				},
				{
					key: "unsignedRightShift",
					value: function() {
						throw TypeError("BigInts have no unsigned right shift; use >> instead");
					}
				},
				{
					key: "lessThan",
					value: function(e, t) {
						return 0 > i.__compareToBigInt(e, t);
					}
				},
				{
					key: "lessThanOrEqual",
					value: function(e, t) {
						return 0 >= i.__compareToBigInt(e, t);
					}
				},
				{
					key: "greaterThan",
					value: function(e, t) {
						return 0 < i.__compareToBigInt(e, t);
					}
				},
				{
					key: "greaterThanOrEqual",
					value: function(e, t) {
						return 0 <= i.__compareToBigInt(e, t);
					}
				},
				{
					key: "equal",
					value: function(e, t) {
						if (e.sign !== t.sign || e.length !== t.length) return !1;
						for (var n = 0; n < e.length; n++) if (e.__digit(n) !== t.__digit(n)) return !1;
						return !0;
					}
				},
				{
					key: "notEqual",
					value: function(e, t) {
						return !i.equal(e, t);
					}
				},
				{
					key: "bitwiseAnd",
					value: function(e, t) {
						if (!e.sign && !t.sign) return i.__absoluteAnd(e, t).__trim();
						if (e.sign && t.sign) {
							var r = n(e.length, t.length) + 1, a = i.__absoluteSubOne(e, r), o = i.__absoluteSubOne(t);
							return a = i.__absoluteOr(a, o, a), i.__absoluteAddOne(a, !0, a).__trim();
						}
						if (e.sign) {
							var s = [t, e];
							e = s[0], t = s[1];
						}
						return i.__absoluteAndNot(e, i.__absoluteSubOne(t)).__trim();
					}
				},
				{
					key: "bitwiseXor",
					value: function(e, t) {
						if (!e.sign && !t.sign) return i.__absoluteXor(e, t).__trim();
						if (e.sign && t.sign) {
							var r = n(e.length, t.length), a = i.__absoluteSubOne(e, r), o = i.__absoluteSubOne(t);
							return i.__absoluteXor(a, o, a).__trim();
						}
						var s = n(e.length, t.length) + 1;
						if (e.sign) {
							var c = [t, e];
							e = c[0], t = c[1];
						}
						var l = i.__absoluteSubOne(t, s);
						return l = i.__absoluteXor(l, e, l), i.__absoluteAddOne(l, !0, l).__trim();
					}
				},
				{
					key: "bitwiseOr",
					value: function(e, t) {
						var r = n(e.length, t.length);
						if (!e.sign && !t.sign) return i.__absoluteOr(e, t).__trim();
						if (e.sign && t.sign) {
							var a = i.__absoluteSubOne(e, r), o = i.__absoluteSubOne(t);
							return a = i.__absoluteAnd(a, o, a), i.__absoluteAddOne(a, !0, a).__trim();
						}
						if (e.sign) {
							var s = [t, e];
							e = s[0], t = s[1];
						}
						var c = i.__absoluteSubOne(t, r);
						return c = i.__absoluteAndNot(c, e, c), i.__absoluteAddOne(c, !0, c).__trim();
					}
				},
				{
					key: "asIntN",
					value: function(e, t) {
						if (t.length === 0) return t;
						if (e = r(e), 0 > e) throw RangeError("Invalid value: not (convertible to) a safe integer");
						if (e === 0) return i.__zero();
						if (e >= i.__kMaxLengthBits) return t;
						var n = 0 | (e + 29) / 30;
						if (t.length < n) return t;
						var a = t.__unsignedDigit(n - 1), o = 1 << (e - 1) % 30;
						if (t.length === n && a < o) return t;
						if ((a & o) !== o) return i.__truncateToNBits(e, t);
						if (!t.sign) return i.__truncateAndSubFromPowerOfTwo(e, t, !0);
						if (!(a & o - 1)) {
							for (var s = n - 2; 0 <= s; s--) if (t.__digit(s) !== 0) return i.__truncateAndSubFromPowerOfTwo(e, t, !1);
							return t.length === n && a === o ? t : i.__truncateToNBits(e, t);
						}
						return i.__truncateAndSubFromPowerOfTwo(e, t, !1);
					}
				},
				{
					key: "asUintN",
					value: function(e, t) {
						if (t.length === 0) return t;
						if (e = r(e), 0 > e) throw RangeError("Invalid value: not (convertible to) a safe integer");
						if (e === 0) return i.__zero();
						if (t.sign) {
							if (e > i.__kMaxLengthBits) throw RangeError("BigInt too big");
							return i.__truncateAndSubFromPowerOfTwo(e, t, !1);
						}
						if (e >= i.__kMaxLengthBits) return t;
						var n = 0 | (e + 29) / 30;
						if (t.length < n) return t;
						var a = e % 30;
						return t.length == n && (a === 0 || !(t.__digit(n - 1) >>> a)) ? t : i.__truncateToNBits(e, t);
					}
				},
				{
					key: "ADD",
					value: function(e, t) {
						if (e = i.__toPrimitive(e), t = i.__toPrimitive(t), typeof e == "string") return typeof t != "string" && (t = t.toString()), e + t;
						if (typeof t == "string") return e.toString() + t;
						if (e = i.__toNumeric(e), t = i.__toNumeric(t), i.__isBigInt(e) && i.__isBigInt(t)) return i.add(e, t);
						if (typeof e == "number" && typeof t == "number") return e + t;
						throw TypeError("Cannot mix BigInt and other types, use explicit conversions");
					}
				},
				{
					key: "LT",
					value: function(e, t) {
						return i.__compare(e, t, 0);
					}
				},
				{
					key: "LE",
					value: function(e, t) {
						return i.__compare(e, t, 1);
					}
				},
				{
					key: "GT",
					value: function(e, t) {
						return i.__compare(e, t, 2);
					}
				},
				{
					key: "GE",
					value: function(e, t) {
						return i.__compare(e, t, 3);
					}
				},
				{
					key: "EQ",
					value: function(e, t) {
						for (;;) {
							if (i.__isBigInt(e)) return i.__isBigInt(t) ? i.equal(e, t) : i.EQ(t, e);
							if (typeof e == "number") {
								if (i.__isBigInt(t)) return i.__equalToNumber(t, e);
								if (x(t) !== "object") return e == t;
								t = i.__toPrimitive(t);
							} else if (typeof e == "string") {
								if (i.__isBigInt(t)) return e = i.__fromString(e), e !== null && i.equal(e, t);
								if (x(t) !== "object") return e == t;
								t = i.__toPrimitive(t);
							} else if (typeof e == "boolean") {
								if (i.__isBigInt(t)) return i.__equalToNumber(t, +e);
								if (x(t) !== "object") return e == t;
								t = i.__toPrimitive(t);
							} else if (x(e) === "symbol") {
								if (i.__isBigInt(t)) return !1;
								if (x(t) !== "object") return e == t;
								t = i.__toPrimitive(t);
							} else if (x(e) === "object") {
								if (x(t) === "object" && t.constructor !== i) return e == t;
								e = i.__toPrimitive(e);
							} else return e == t;
						}
					}
				},
				{
					key: "NE",
					value: function(e, t) {
						return !i.EQ(e, t);
					}
				},
				{
					key: "DataViewGetBigInt64",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 && arguments[2];
						return i.asIntN(64, i.DataViewGetBigUint64(e, t, n));
					}
				},
				{
					key: "DataViewGetBigUint64",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 && arguments[2], r = y(n ? [4, 0] : [0, 4], 2), a = r[0], o = r[1], s = e.getUint32(t + a, n), c = e.getUint32(t + o, n), l = new i(3, !1);
						return l.__setDigit(0, 1073741823 & c), l.__setDigit(1, (268435455 & s) << 2 | c >>> 30), l.__setDigit(2, s >>> 28), l.__trim();
					}
				},
				{
					key: "DataViewSetBigInt64",
					value: function(e, t, n) {
						var r = 3 < arguments.length && arguments[3] !== void 0 && arguments[3];
						i.DataViewSetBigUint64(e, t, n, r);
					}
				},
				{
					key: "DataViewSetBigUint64",
					value: function(e, t, n) {
						var r = 3 < arguments.length && arguments[3] !== void 0 && arguments[3];
						n = i.asUintN(64, n);
						var a = 0, o = 0;
						if (0 < n.length && (o = n.__digit(0), 1 < n.length)) {
							var s = n.__digit(1);
							o |= s << 30, a = s >>> 2, 2 < n.length && (a |= n.__digit(2) << 28);
						}
						var c = y(r ? [4, 0] : [0, 4], 2), l = c[0], u = c[1];
						e.setUint32(t + l, a, r), e.setUint32(t + u, o, r);
					}
				},
				{
					key: "__zero",
					value: function() {
						return new i(0, !1);
					}
				},
				{
					key: "__oneDigit",
					value: function(e, t) {
						var n = new i(1, t);
						return n.__setDigit(0, e), n;
					}
				},
				{
					key: "__decideRounding",
					value: function(e, t, n, r) {
						if (0 < t) return -1;
						var i;
						if (0 > t) i = -t - 1;
						else {
							if (n === 0) return -1;
							n--, r = e.__digit(n), i = 29;
						}
						var a = 1 << i;
						if ((r & a) == 0) return -1;
						if (--a, (r & a) != 0) return 1;
						for (; 0 < n;) if (n--, e.__digit(n) !== 0) return 1;
						return 0;
					}
				},
				{
					key: "__fromDouble",
					value: function(e) {
						var t = 0 > e;
						i.__kBitConversionDouble[0] = e;
						var n, r = (2047 & i.__kBitConversionInts[i.__kBitConversionIntHigh] >>> 20) - 1023, a = (0 | r / 30) + 1, o = new i(a, t), s = 1048575 & i.__kBitConversionInts[i.__kBitConversionIntHigh] | 1048576, c = i.__kBitConversionInts[i.__kBitConversionIntLow], l = 20, u = r % 30, d = 0;
						if (u < l) {
							var f = l - u;
							d = f + 32, n = s >>> f, s = s << 32 - f | c >>> f, c <<= 32 - f;
						} else if (u === l) d = 32, n = s, s = c, c = 0;
						else {
							var p = u - l;
							d = 32 - p, n = s << p | c >>> 32 - p, s = c << p, c = 0;
						}
						o.__setDigit(a - 1, n);
						for (var m = a - 2; 0 <= m; m--) 0 < d ? (d -= 30, n = s >>> 2, s = s << 30 | c >>> 2, c <<= 30) : n = 0, o.__setDigit(m, n);
						return o.__trim();
					}
				},
				{
					key: "__isWhitespace",
					value: function(e) {
						return 13 >= e && 9 <= e || (159 >= e ? e == 32 : 131071 >= e ? e == 160 || e == 5760 : 196607 >= e ? (e &= 131071, 10 >= e || e == 40 || e == 41 || e == 47 || e == 95 || e == 4096) : e == 65279);
					}
				},
				{
					key: "__fromString",
					value: function(e) {
						var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 0, n = 0, r = e.length, a = 0;
						if (a === r) return i.__zero();
						for (var o = e.charCodeAt(a); i.__isWhitespace(o);) {
							if (++a === r) return i.__zero();
							o = e.charCodeAt(a);
						}
						if (o === 43) {
							if (++a === r) return null;
							o = e.charCodeAt(a), n = 1;
						} else if (o === 45) {
							if (++a === r) return null;
							o = e.charCodeAt(a), n = -1;
						}
						if (t === 0) {
							if (t = 10, o === 48) {
								if (++a === r) return i.__zero();
								if (o = e.charCodeAt(a), o === 88 || o === 120) {
									if (t = 16, ++a === r) return null;
									o = e.charCodeAt(a);
								} else if (o === 79 || o === 111) {
									if (t = 8, ++a === r) return null;
									o = e.charCodeAt(a);
								} else if (o === 66 || o === 98) {
									if (t = 2, ++a === r) return null;
									o = e.charCodeAt(a);
								}
							}
						} else if (t === 16 && o === 48) {
							if (++a === r) return i.__zero();
							if (o = e.charCodeAt(a), o === 88 || o === 120) {
								if (++a === r) return null;
								o = e.charCodeAt(a);
							}
						}
						if (n !== 0 && t !== 10) return null;
						for (; o === 48;) {
							if (++a === r) return i.__zero();
							o = e.charCodeAt(a);
						}
						var s = r - a, c = i.__kMaxBitsPerChar[t], l = i.__kBitsPerCharTableMultiplier - 1;
						if (s > 1073741824 / c) return null;
						var u = new i(0 | ((c * s + l >>> i.__kBitsPerCharTableShift) + 29) / 30, !1), d = 10 > t ? t : 10, f = 10 < t ? t - 10 : 0;
						if (t & t - 1) {
							u.__initializeDigits();
							var p = !1, m = 0;
							do {
								for (var h, g = 0, _ = 1;;) {
									if (h = void 0, o - 48 >>> 0 < d) h = o - 48;
									else if ((32 | o) - 97 >>> 0 < f) h = (32 | o) - 87;
									else {
										p = !0;
										break;
									}
									var v = _ * t;
									if (1073741823 < v) break;
									if (_ = v, g = g * t + h, m++, ++a === r) {
										p = !0;
										break;
									}
									o = e.charCodeAt(a);
								}
								l = 30 * i.__kBitsPerCharTableMultiplier - 1;
								var y = 0 | (c * m + l >>> i.__kBitsPerCharTableShift) / 30;
								u.__inplaceMultiplyAdd(_, g, y);
							} while (!p);
						} else {
							c >>= i.__kBitsPerCharTableShift;
							var ee = [], b = [], x = !1;
							do {
								for (var te, ne = 0, S = 0;;) {
									if (te = void 0, o - 48 >>> 0 < d) te = o - 48;
									else if ((32 | o) - 97 >>> 0 < f) te = (32 | o) - 87;
									else {
										x = !0;
										break;
									}
									if (S += c, ne = ne << c | te, ++a === r) {
										x = !0;
										break;
									}
									if (o = e.charCodeAt(a), 30 < S + c) break;
								}
								ee.push(ne), b.push(S);
							} while (!x);
							i.__fillFromParts(u, ee, b);
						}
						if (a !== r) {
							if (!i.__isWhitespace(o)) return null;
							for (a++; a < r; a++) if (o = e.charCodeAt(a), !i.__isWhitespace(o)) return null;
						}
						return u.sign = n === -1, u.__trim();
					}
				},
				{
					key: "__fillFromParts",
					value: function(e, t, n) {
						for (var r = 0, i = 0, a = 0, o = t.length - 1; 0 <= o; o--) {
							var s = t[o], c = n[o];
							i |= s << a, a += c, a === 30 ? (e.__setDigit(r++, i), a = 0, i = 0) : 30 < a && (e.__setDigit(r++, 1073741823 & i), a -= 30, i = s >>> c - a);
						}
						if (i !== 0) {
							if (r >= e.length) throw Error("implementation bug");
							e.__setDigit(r++, i);
						}
						for (; r < e.length; r++) e.__setDigit(r, 0);
					}
				},
				{
					key: "__toStringBasePowerOfTwo",
					value: function(e, t) {
						var n = e.length, r = t - 1;
						r = (85 & r >>> 1) + (85 & r), r = (51 & r >>> 2) + (51 & r), r = (15 & r >>> 4) + (15 & r);
						var a = r, o = t - 1, s = e.__digit(n - 1), c = i.__clz30(s), l = 0 | (30 * n - c + a - 1) / a;
						if (e.sign && l++, 268435456 < l) throw Error("string too long");
						for (var u = Array(l), d = l - 1, f = 0, p = 0, m = 0; m < n - 1; m++) {
							var h = e.__digit(m), g = (f | h << p) & o;
							u[d--] = i.__kConversionChars[g];
							var _ = a - p;
							for (f = h >>> _, p = 30 - _; p >= a;) u[d--] = i.__kConversionChars[f & o], f >>>= a, p -= a;
						}
						var v = (f | s << p) & o;
						for (u[d--] = i.__kConversionChars[v], f = s >>> a - p; f !== 0;) u[d--] = i.__kConversionChars[f & o], f >>>= a;
						if (e.sign && (u[d--] = "-"), d !== -1) throw Error("implementation bug");
						return u.join("");
					}
				},
				{
					key: "__toStringGeneric",
					value: function(e, t, n) {
						var r = e.length;
						if (r === 0) return "";
						if (r === 1) {
							var a = e.__unsignedDigit(0).toString(t);
							return !1 === n && e.sign && (a = "-" + a), a;
						}
						var o = 30 * r - i.__clz30(e.__digit(r - 1)), s = i.__kMaxBitsPerChar[t] - 1, c = o * i.__kBitsPerCharTableMultiplier;
						c += s - 1, c = 0 | c / s;
						var l, u, d = c + 1 >> 1, f = i.exponentiate(i.__oneDigit(t, !1), i.__oneDigit(d, !1)), p = f.__unsignedDigit(0);
						if (f.length === 1 && 32767 >= p) {
							l = new i(e.length, !1), l.__initializeDigits();
							for (var m, h = 0, g = 2 * e.length - 1; 0 <= g; g--) m = h << 15 | e.__halfDigit(g), l.__setHalfDigit(g, 0 | m / p), h = 0 | m % p;
							u = h.toString(t);
						} else {
							var _ = i.__absoluteDivLarge(e, f, !0, !0);
							l = _.quotient;
							var v = _.remainder.__trim();
							u = i.__toStringGeneric(v, t, !0);
						}
						l.__trim();
						for (var y = i.__toStringGeneric(l, t, !0); u.length < d;) u = "0" + u;
						return !1 === n && e.sign && (y = "-" + y), y + u;
					}
				},
				{
					key: "__unequalSign",
					value: function(e) {
						return e ? -1 : 1;
					}
				},
				{
					key: "__absoluteGreater",
					value: function(e) {
						return e ? -1 : 1;
					}
				},
				{
					key: "__absoluteLess",
					value: function(e) {
						return e ? 1 : -1;
					}
				},
				{
					key: "__compareToBigInt",
					value: function(e, t) {
						var n = e.sign;
						if (n !== t.sign) return i.__unequalSign(n);
						var r = i.__absoluteCompare(e, t);
						return 0 < r ? i.__absoluteGreater(n) : 0 > r ? i.__absoluteLess(n) : 0;
					}
				},
				{
					key: "__compareToNumber",
					value: function(e, n) {
						if (i.__isOneDigitInt(n)) {
							var r = e.sign, a = 0 > n;
							if (r !== a) return i.__unequalSign(r);
							if (e.length === 0) {
								if (a) throw Error("implementation bug");
								return n === 0 ? 0 : -1;
							}
							if (1 < e.length) return i.__absoluteGreater(r);
							var o = t(n), s = e.__unsignedDigit(0);
							return s > o ? i.__absoluteGreater(r) : s < o ? i.__absoluteLess(r) : 0;
						}
						return i.__compareToDouble(e, n);
					}
				},
				{
					key: "__compareToDouble",
					value: function(e, t) {
						if (t !== t) return t;
						if (t === 1 / 0) return -1;
						if (t === -Infinity) return 1;
						var n = e.sign;
						if (n !== 0 > t) return i.__unequalSign(n);
						if (t === 0) throw Error("implementation bug: should be handled elsewhere");
						if (e.length === 0) return -1;
						i.__kBitConversionDouble[0] = t;
						var r = 2047 & i.__kBitConversionInts[i.__kBitConversionIntHigh] >>> 20;
						if (r == 2047) throw Error("implementation bug: handled elsewhere");
						var a = r - 1023;
						if (0 > a) return i.__absoluteGreater(n);
						var o = e.length, s = e.__digit(o - 1), c = i.__clz30(s), l = 30 * o - c, u = a + 1;
						if (l < u) return i.__absoluteLess(n);
						if (l > u) return i.__absoluteGreater(n);
						var d = 1048576 | 1048575 & i.__kBitConversionInts[i.__kBitConversionIntHigh], f = i.__kBitConversionInts[i.__kBitConversionIntLow], p = 20, m = 29 - c;
						if (m !== (0 | (l - 1) % 30)) throw Error("implementation bug");
						var h, g = 0;
						if (m < p) {
							var _ = p - m;
							g = _ + 32, h = d >>> _, d = d << 32 - _ | f >>> _, f <<= 32 - _;
						} else if (m === p) g = 32, h = d, d = f, f = 0;
						else {
							var v = m - p;
							g = 32 - v, h = d << v | f >>> 32 - v, d = f << v, f = 0;
						}
						if (s >>>= 0, h >>>= 0, s > h) return i.__absoluteGreater(n);
						if (s < h) return i.__absoluteLess(n);
						for (var y = o - 2; 0 <= y; y--) {
							0 < g ? (g -= 30, h = d >>> 2, d = d << 30 | f >>> 2, f <<= 30) : h = 0;
							var ee = e.__unsignedDigit(y);
							if (ee > h) return i.__absoluteGreater(n);
							if (ee < h) return i.__absoluteLess(n);
						}
						if (d !== 0 || f !== 0) {
							if (g === 0) throw Error("implementation bug");
							return i.__absoluteLess(n);
						}
						return 0;
					}
				},
				{
					key: "__equalToNumber",
					value: function(e, n) {
						return i.__isOneDigitInt(n) ? n === 0 ? e.length === 0 : e.length === 1 && e.sign === 0 > n && e.__unsignedDigit(0) === t(n) : i.__compareToDouble(e, n) === 0;
					}
				},
				{
					key: "__comparisonResultToBool",
					value: function(e, t) {
						return t === 0 ? 0 > e : t === 1 ? 0 >= e : t === 2 ? 0 < e : t === 3 ? 0 <= e : void 0;
					}
				},
				{
					key: "__compare",
					value: function(e, t, n) {
						if (e = i.__toPrimitive(e), t = i.__toPrimitive(t), typeof e == "string" && typeof t == "string") switch (n) {
							case 0: return e < t;
							case 1: return e <= t;
							case 2: return e > t;
							case 3: return e >= t;
						}
						if (i.__isBigInt(e) && typeof t == "string") return t = i.__fromString(t), t !== null && i.__comparisonResultToBool(i.__compareToBigInt(e, t), n);
						if (typeof e == "string" && i.__isBigInt(t)) return e = i.__fromString(e), e !== null && i.__comparisonResultToBool(i.__compareToBigInt(e, t), n);
						if (e = i.__toNumeric(e), t = i.__toNumeric(t), i.__isBigInt(e)) {
							if (i.__isBigInt(t)) return i.__comparisonResultToBool(i.__compareToBigInt(e, t), n);
							if (typeof t != "number") throw Error("implementation bug");
							return i.__comparisonResultToBool(i.__compareToNumber(e, t), n);
						}
						if (typeof e != "number") throw Error("implementation bug");
						if (i.__isBigInt(t)) return i.__comparisonResultToBool(i.__compareToNumber(t, e), 2 ^ n);
						if (typeof t != "number") throw Error("implementation bug");
						return n === 0 ? e < t : n === 1 ? e <= t : n === 2 ? e > t : n === 3 ? e >= t : void 0;
					}
				},
				{
					key: "__absoluteAdd",
					value: function(e, t, n) {
						if (e.length < t.length) return i.__absoluteAdd(t, e, n);
						if (e.length === 0) return e;
						if (t.length === 0) return e.sign === n ? e : i.unaryMinus(e);
						var r = e.length;
						(e.__clzmsd() === 0 || t.length === e.length && t.__clzmsd() === 0) && r++;
						for (var a, o = new i(r, n), s = 0, c = 0; c < t.length; c++) a = e.__digit(c) + t.__digit(c) + s, s = a >>> 30, o.__setDigit(c, 1073741823 & a);
						for (; c < e.length; c++) {
							var l = e.__digit(c) + s;
							s = l >>> 30, o.__setDigit(c, 1073741823 & l);
						}
						return c < o.length && o.__setDigit(c, s), o.__trim();
					}
				},
				{
					key: "__absoluteSub",
					value: function(e, t, n) {
						if (e.length === 0) return e;
						if (t.length === 0) return e.sign === n ? e : i.unaryMinus(e);
						for (var r, a = new i(e.length, n), o = 0, s = 0; s < t.length; s++) r = e.__digit(s) - t.__digit(s) - o, o = 1 & r >>> 30, a.__setDigit(s, 1073741823 & r);
						for (; s < e.length; s++) {
							var c = e.__digit(s) - o;
							o = 1 & c >>> 30, a.__setDigit(s, 1073741823 & c);
						}
						return a.__trim();
					}
				},
				{
					key: "__absoluteAddOne",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, r = e.length;
						n === null ? n = new i(r, t) : n.sign = t;
						for (var a, o = 1, s = 0; s < r; s++) a = e.__digit(s) + o, o = a >>> 30, n.__setDigit(s, 1073741823 & a);
						return o !== 0 && n.__setDigitGrow(r, 1), n;
					}
				},
				{
					key: "__absoluteSubOne",
					value: function(e, t) {
						var n = e.length;
						t ||= n;
						for (var r, a = new i(t, !1), o = 1, s = 0; s < n; s++) r = e.__digit(s) - o, o = 1 & r >>> 30, a.__setDigit(s, 1073741823 & r);
						if (o !== 0) throw Error("implementation bug");
						for (var c = n; c < t; c++) a.__setDigit(c, 0);
						return a;
					}
				},
				{
					key: "__absoluteAnd",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, r = e.length, a = t.length, o = a;
						if (r < a) {
							o = r;
							var s = e, c = r;
							e = t, r = a, t = s, a = c;
						}
						var l = o;
						n === null ? n = new i(l, !1) : l = n.length;
						for (var u = 0; u < o; u++) n.__setDigit(u, e.__digit(u) & t.__digit(u));
						for (; u < l; u++) n.__setDigit(u, 0);
						return n;
					}
				},
				{
					key: "__absoluteAndNot",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, r = e.length, a = t.length, o = a;
						r < a && (o = r);
						var s = r;
						n === null ? n = new i(s, !1) : s = n.length;
						for (var c = 0; c < o; c++) n.__setDigit(c, e.__digit(c) & ~t.__digit(c));
						for (; c < r; c++) n.__setDigit(c, e.__digit(c));
						for (; c < s; c++) n.__setDigit(c, 0);
						return n;
					}
				},
				{
					key: "__absoluteOr",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, r = e.length, a = t.length, o = a;
						if (r < a) {
							o = r;
							var s = e, c = r;
							e = t, r = a, t = s, a = c;
						}
						var l = r;
						n === null ? n = new i(l, !1) : l = n.length;
						for (var u = 0; u < o; u++) n.__setDigit(u, e.__digit(u) | t.__digit(u));
						for (; u < r; u++) n.__setDigit(u, e.__digit(u));
						for (; u < l; u++) n.__setDigit(u, 0);
						return n;
					}
				},
				{
					key: "__absoluteXor",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, r = e.length, a = t.length, o = a;
						if (r < a) {
							o = r;
							var s = e, c = r;
							e = t, r = a, t = s, a = c;
						}
						var l = r;
						n === null ? n = new i(l, !1) : l = n.length;
						for (var u = 0; u < o; u++) n.__setDigit(u, e.__digit(u) ^ t.__digit(u));
						for (; u < r; u++) n.__setDigit(u, e.__digit(u));
						for (; u < l; u++) n.__setDigit(u, 0);
						return n;
					}
				},
				{
					key: "__absoluteCompare",
					value: function(e, t) {
						var n = e.length - t.length;
						if (n != 0) return n;
						for (var r = e.length - 1; 0 <= r && e.__digit(r) === t.__digit(r);) r--;
						return 0 > r ? 0 : e.__unsignedDigit(r) > t.__unsignedDigit(r) ? 1 : -1;
					}
				},
				{
					key: "__multiplyAccumulate",
					value: function(e, t, n, r) {
						if (t !== 0) {
							for (var a = 32767 & t, o = t >>> 15, s = 0, c = 0, l = 0; l < e.length; l++, r++) {
								var u = n.__digit(r), d = e.__digit(l), f = 32767 & d, p = d >>> 15, m = i.__imul(f, a), h = i.__imul(f, o), g = i.__imul(p, a), _ = i.__imul(p, o);
								u += c + m + s, s = u >>> 30, u &= 1073741823, u += ((32767 & h) << 15) + ((32767 & g) << 15), s += u >>> 30, c = _ + (h >>> 15) + (g >>> 15), n.__setDigit(r, 1073741823 & u);
							}
							for (; s !== 0 || c !== 0; r++) {
								var v = n.__digit(r);
								v += s + c, c = 0, s = v >>> 30, n.__setDigit(r, 1073741823 & v);
							}
						}
					}
				},
				{
					key: "__internalMultiplyAdd",
					value: function(e, t, n, r, a) {
						for (var o = n, s = 0, c = 0; c < r; c++) {
							var l = e.__digit(c), u = i.__imul(32767 & l, t), d = i.__imul(l >>> 15, t), f = u + ((32767 & d) << 15) + s + o;
							o = f >>> 30, s = d >>> 15, a.__setDigit(c, 1073741823 & f);
						}
						if (a.length > r) for (a.__setDigit(r++, o + s); r < a.length;) a.__setDigit(r++, 0);
						else if (o + s !== 0) throw Error("implementation bug");
					}
				},
				{
					key: "__absoluteDivSmall",
					value: function(e, t) {
						var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
						n === null && (n = new i(e.length, !1));
						for (var r = 0, a = 2 * e.length - 1; 0 <= a; a -= 2) {
							var o = (r << 15 | e.__halfDigit(a)) >>> 0, s = 0 | o / t;
							r = 0 | o % t, o = (r << 15 | e.__halfDigit(a - 1)) >>> 0;
							var c = 0 | o / t;
							r = 0 | o % t, n.__setDigit(a >>> 1, s << 15 | c);
						}
						return n;
					}
				},
				{
					key: "__absoluteModSmall",
					value: function(e, t) {
						for (var n, r = 0, i = 2 * e.length - 1; 0 <= i; i--) n = (r << 15 | e.__halfDigit(i)) >>> 0, r = 0 | n % t;
						return r;
					}
				},
				{
					key: "__absoluteDivLarge",
					value: function(e, t, n, r) {
						var a = t.__halfDigitLength(), o = t.length, s = e.__halfDigitLength() - a, c = null;
						n && (c = new i(s + 2 >>> 1, !1), c.__initializeDigits());
						var l = new i(a + 2 >>> 1, !1);
						l.__initializeDigits();
						var u = i.__clz15(t.__halfDigit(a - 1));
						0 < u && (t = i.__specialLeftShift(t, u, 0));
						for (var d = i.__specialLeftShift(e, u, 1), f = t.__halfDigit(a - 1), p = 0, m = s; 0 <= m; m--) {
							var h = 32767, g = d.__halfDigit(m + a);
							if (g !== f) {
								var _ = (g << 15 | d.__halfDigit(m + a - 1)) >>> 0;
								h = 0 | _ / f;
								for (var v = 0 | _ % f, y = t.__halfDigit(a - 2), ee = d.__halfDigit(m + a - 2); i.__imul(h, y) >>> 0 > (v << 16 | ee) >>> 0 && (h--, v += f, !(32767 < v)););
							}
							i.__internalMultiplyAdd(t, h, 0, o, l);
							var b = d.__inplaceSub(l, m, a + 1);
							b !== 0 && (b = d.__inplaceAdd(t, m, a), d.__setHalfDigit(m + a, 32767 & d.__halfDigit(m + a) + b), h--), n && (1 & m ? p = h << 15 : c.__setDigit(m >>> 1, p | h));
						}
						if (r) return d.__inplaceRightShift(u), n ? {
							quotient: c,
							remainder: d
						} : d;
						if (n) return c;
						throw Error("unreachable");
					}
				},
				{
					key: "__clz15",
					value: function(e) {
						return i.__clz30(e) - 15;
					}
				},
				{
					key: "__specialLeftShift",
					value: function(e, t, n) {
						var r = e.length, a = new i(r + n, !1);
						if (t === 0) {
							for (var o = 0; o < r; o++) a.__setDigit(o, e.__digit(o));
							return 0 < n && a.__setDigit(r, 0), a;
						}
						for (var s, c = 0, l = 0; l < r; l++) s = e.__digit(l), a.__setDigit(l, 1073741823 & s << t | c), c = s >>> 30 - t;
						return 0 < n && a.__setDigit(r, c), a;
					}
				},
				{
					key: "__leftShiftByAbsolute",
					value: function(e, t) {
						var n = i.__toShiftAmount(t);
						if (0 > n) throw RangeError("BigInt too big");
						var r = 0 | n / 30, a = n % 30, o = e.length, s = a !== 0 && !!(e.__digit(o - 1) >>> 30 - a), c = o + r + +!!s, l = new i(c, e.sign);
						if (a === 0) {
							for (var u = 0; u < r; u++) l.__setDigit(u, 0);
							for (; u < c; u++) l.__setDigit(u, e.__digit(u - r));
						} else {
							for (var d = 0, f = 0; f < r; f++) l.__setDigit(f, 0);
							for (var p, m = 0; m < o; m++) p = e.__digit(m), l.__setDigit(m + r, 1073741823 & p << a | d), d = p >>> 30 - a;
							if (s) l.__setDigit(o + r, d);
							else if (d !== 0) throw Error("implementation bug");
						}
						return l.__trim();
					}
				},
				{
					key: "__rightShiftByAbsolute",
					value: function(e, t) {
						var n = e.length, r = e.sign, a = i.__toShiftAmount(t);
						if (0 > a) return i.__rightShiftByMaximum(r);
						var o = 0 | a / 30, s = a % 30, c = n - o;
						if (0 >= c) return i.__rightShiftByMaximum(r);
						var l = !1;
						if (r) {
							var u = (1 << s) - 1;
							if ((e.__digit(o) & u) != 0) l = !0;
							else for (var d = 0; d < o; d++) if (e.__digit(d) !== 0) {
								l = !0;
								break;
							}
						}
						l && s === 0 && ~e.__digit(n - 1) == 0 && c++;
						var f = new i(c, r);
						if (s === 0) {
							f.__setDigit(c - 1, 0);
							for (var p = o; p < n; p++) f.__setDigit(p - o, e.__digit(p));
						} else {
							for (var m, h = e.__digit(o) >>> s, g = n - o - 1, _ = 0; _ < g; _++) m = e.__digit(_ + o + 1), f.__setDigit(_, 1073741823 & m << 30 - s | h), h = m >>> s;
							f.__setDigit(g, h);
						}
						return l && (f = i.__absoluteAddOne(f, !0, f)), f.__trim();
					}
				},
				{
					key: "__rightShiftByMaximum",
					value: function(e) {
						return e ? i.__oneDigit(1, !0) : i.__zero();
					}
				},
				{
					key: "__toShiftAmount",
					value: function(e) {
						if (1 < e.length) return -1;
						var t = e.__unsignedDigit(0);
						return t > i.__kMaxLengthBits ? -1 : t;
					}
				},
				{
					key: "__toPrimitive",
					value: function(e) {
						var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "default";
						if (x(e) !== "object" || e.constructor === i) return e;
						if (typeof Symbol < "u" && x(Symbol.toPrimitive) === "symbol" && e[Symbol.toPrimitive]) {
							var n = e[Symbol.toPrimitive](t);
							if (x(n) !== "object") return n;
							throw TypeError("Cannot convert object to primitive value");
						}
						var r = e.valueOf;
						if (r) {
							var a = r.call(e);
							if (x(a) !== "object") return a;
						}
						var o = e.toString;
						if (o) {
							var s = o.call(e);
							if (x(s) !== "object") return s;
						}
						throw TypeError("Cannot convert object to primitive value");
					}
				},
				{
					key: "__toNumeric",
					value: function(e) {
						return i.__isBigInt(e) ? e : +e;
					}
				},
				{
					key: "__isBigInt",
					value: function(e) {
						return x(e) === "object" && e !== null && e.constructor === i;
					}
				},
				{
					key: "__truncateToNBits",
					value: function(e, t) {
						for (var n = 0 | (e + 29) / 30, r = new i(n, t.sign), a = n - 1, o = 0; o < a; o++) r.__setDigit(o, t.__digit(o));
						var s = t.__digit(a);
						if (e % 30 != 0) {
							var c = 32 - e % 30;
							s = s << c >>> c;
						}
						return r.__setDigit(a, s), r.__trim();
					}
				},
				{
					key: "__truncateAndSubFromPowerOfTwo",
					value: function(e, t, n) {
						for (var r = Math.min, a, o = 0 | (e + 29) / 30, s = new i(o, n), c = 0, l = o - 1, u = 0, d = r(l, t.length); c < d; c++) a = 0 - t.__digit(c) - u, u = 1 & a >>> 30, s.__setDigit(c, 1073741823 & a);
						for (; c < l; c++) s.__setDigit(c, 0 | 1073741823 & -u);
						var f, p = l < t.length ? t.__digit(l) : 0, m = e % 30;
						if (m === 0) f = 0 - p - u, f &= 1073741823;
						else {
							var h = 32 - m;
							p = p << h >>> h;
							var g = 1 << 32 - h;
							f = g - p - u, f &= g - 1;
						}
						return s.__setDigit(l, f), s.__trim();
					}
				},
				{
					key: "__digitPow",
					value: function(e, t) {
						for (var n = 1; 0 < t;) 1 & t && (n *= e), t >>>= 1, e *= e;
						return n;
					}
				},
				{
					key: "__detectBigEndian",
					value: function() {
						return i.__kBitConversionDouble[0] = -0, i.__kBitConversionInts[0] !== 0;
					}
				},
				{
					key: "__isOneDigitInt",
					value: function(e) {
						return (1073741823 & e) === e;
					}
				}
			]);
		}(ne(Array));
		return S.__kMaxLength = 33554432, S.__kMaxLengthBits = S.__kMaxLength << 5, S.__kMaxBitsPerChar = [
			0,
			0,
			32,
			51,
			64,
			75,
			83,
			90,
			96,
			102,
			107,
			111,
			115,
			119,
			122,
			126,
			128,
			131,
			134,
			136,
			139,
			141,
			143,
			145,
			147,
			149,
			151,
			153,
			154,
			156,
			158,
			159,
			160,
			162,
			163,
			165,
			166
		], S.__kBitsPerCharTableShift = 5, S.__kBitsPerCharTableMultiplier = 1 << S.__kBitsPerCharTableShift, S.__kConversionChars = /* @__PURE__ */ "0123456789abcdefghijklmnopqrstuvwxyz".split(""), S.__kBitConversionBuffer = /* @__PURE__ */ new ArrayBuffer(8), S.__kBitConversionDouble = new Float64Array(S.__kBitConversionBuffer), S.__kBitConversionInts = new Int32Array(S.__kBitConversionBuffer), S.__kBitConversionIntHigh = +!S.__detectBigEndian(), S.__kBitConversionIntLow = +!!S.__detectBigEndian(), S.__clz30 = t ? function(e) {
			return t(e) - 2;
		} : function(e) {
			var t = Math.LN2, n = Math.log;
			return e === 0 ? 30 : 0 | 29 - (0 | n(e >>> 0) / t);
		}, S.__imul = e || function(e, t) {
			return 0 | e * t;
		}, S;
	});
})))(), 1), u = l.default.BigInt(0), d = l.default.BigInt(1), f = l.default.BigInt(2), p = l.default.BigInt(10), m = l.default.BigInt(24), h = l.default.BigInt(60), g = l.default.BigInt(1e3), _ = l.default.BigInt(1e6), v = l.default.BigInt(1e9), y = l.default.multiply(l.default.BigInt(3600), v), ee = l.default.multiply(h, v), b = l.default.multiply(y, m);
function x(e) {
	return typeof e == "bigint" ? l.default.BigInt(e.toString(10)) : e;
}
function te(e) {
	return l.default.equal(l.default.remainder(e, f), u);
}
function ne(e) {
	return l.default.lessThan(e, u) ? l.default.unaryMinus(e) : e;
}
function S(e, t) {
	return l.default.lessThan(e, t) ? -1 : +!!l.default.greaterThan(e, t);
}
function re(e, t) {
	return {
		quotient: l.default.divide(e, t),
		remainder: l.default.remainder(e, t)
	};
}
var ie, ae, C = "slot-epochNanoSeconds", w = "slot-iso-date", T = "slot-iso-date-time", E = "slot-time", D = "slot-calendar", oe = "slot-date-brand", se = "slot-year-month-brand", ce = "slot-month-day-brand", O = "slot-time-zone", le = "slot-years", ue = "slot-months", de = "slot-weeks", k = "slot-days", A = "slot-hours", fe = "slot-minutes", pe = "slot-seconds", me = "slot-milliseconds", he = "slot-microseconds", ge = "slot-nanoseconds", _e = "date", ve = "ym", ye = "md", be = "time", xe = "datetime", Se = "instant", Ce = "original", we = "timezone-canonical", Te = "timezone-original", Ee = "calendar-id", De = "locale", Oe = "options", ke = /* @__PURE__ */ new WeakMap(), Ae = Symbol.for("@@Temporal__GetSlots");
(ie = globalThis)[Ae] || (ie[Ae] = function(e) {
	return ke.get(e);
});
var je = globalThis[Ae], Me = Symbol.for("@@Temporal__CreateSlots");
(ae = globalThis)[Me] || (ae[Me] = function(e) {
	ke.set(e, Object.create(null));
});
var Ne = globalThis[Me];
function Pe(e, ...t) {
	if (!e || typeof e != "object") return !1;
	let n = je(e);
	return !!n && t.every(((e) => e in n));
}
function j(e, t) {
	let n = je(e)?.[t];
	if (n === void 0) throw TypeError(`Missing internal slot ${t}`);
	return n;
}
function M(e, t, n) {
	let r = je(e);
	if (r === void 0) throw TypeError("Missing slots for the given container");
	if (r[t]) throw TypeError(`${t} already has set`);
	r[t] = n;
}
var Fe = {};
function Ie(e, t) {
	Object.defineProperty(e.prototype, Symbol.toStringTag, {
		value: t,
		writable: !1,
		enumerable: !1,
		configurable: !0
	});
	let n = Object.getOwnPropertyNames(e);
	for (let t = 0; t < n.length; t++) {
		let r = n[t], i = Object.getOwnPropertyDescriptor(e, r);
		i.configurable && i.enumerable && (i.enumerable = !1, Object.defineProperty(e, r, i));
	}
	let r = Object.getOwnPropertyNames(e.prototype);
	for (let t = 0; t < r.length; t++) {
		let n = r[t], i = Object.getOwnPropertyDescriptor(e.prototype, n);
		i.configurable && i.enumerable && (i.enumerable = !1, Object.defineProperty(e.prototype, n, i));
	}
	Le(t, e), Le(`${t}.prototype`, e.prototype);
}
function Le(e, t) {
	let n = `%${e}%`;
	if (Fe[n] !== void 0) throw Error(`intrinsic ${e} already exists`);
	Fe[n] = t;
}
function N(e) {
	return Fe[e];
}
function Re(e, t) {
	let n = e;
	if (n === 0) return {
		div: n,
		mod: n
	};
	let r = Math.sign(n);
	n = Math.abs(n);
	let i = Math.trunc(1 + Math.log10(n));
	if (t >= i) return {
		div: 0 * r,
		mod: r * n
	};
	if (t === 0) return {
		div: r * n,
		mod: 0 * r
	};
	let a = n.toPrecision(i);
	return {
		div: r * Number.parseInt(a.slice(0, i - t), 10),
		mod: r * Number.parseInt(a.slice(i - t), 10)
	};
}
function ze(e, t, n) {
	let r = e, i = n;
	if (r === 0) return i;
	let a = Math.sign(r) || Math.sign(i);
	r = Math.abs(r), i = Math.abs(i);
	let o = r.toPrecision(Math.trunc(1 + Math.log10(r)));
	if (i === 0) return a * Number.parseInt(o + "0".repeat(t), 10);
	let s = o + i.toPrecision(Math.trunc(1 + Math.log10(i))).padStart(t, "0");
	return a * Number.parseInt(s, 10);
}
function Be(e, t) {
	let n = t === "negative";
	switch (e) {
		case "ceil": return n ? "zero" : "infinity";
		case "floor": return n ? "infinity" : "zero";
		case "expand": return "infinity";
		case "trunc": return "zero";
		case "halfCeil": return n ? "half-zero" : "half-infinity";
		case "halfFloor": return n ? "half-infinity" : "half-zero";
		case "halfExpand": return "half-infinity";
		case "halfTrunc": return "half-zero";
		case "halfEven": return "half-even";
	}
}
function Ve(e, t, n, r, i) {
	return i === "zero" ? e : i === "infinity" ? t : n < 0 ? e : n > 0 ? t : i === "half-zero" ? e : i === "half-infinity" ? t : r ? e : t;
}
var P = class e {
	constructor(e) {
		this.totalNs = x(e), this.sec = l.default.toNumber(l.default.divide(this.totalNs, v)), this.subsec = l.default.toNumber(l.default.remainder(this.totalNs, v));
	}
	static validateNew(t, n) {
		if (l.default.greaterThan(ne(t), e.MAX)) throw RangeError(`${n} of duration time units cannot exceed ${e.MAX} s`);
		return new e(t);
	}
	static fromEpochNsDiff(t, n) {
		let r = l.default.subtract(x(t), x(n));
		return new e(r);
	}
	static fromComponents(t, n, r, i, a, o) {
		let s = l.default.add(l.default.add(l.default.add(l.default.add(l.default.add(l.default.BigInt(o), l.default.multiply(l.default.BigInt(a), g)), l.default.multiply(l.default.BigInt(i), _)), l.default.multiply(l.default.BigInt(r), v)), l.default.multiply(l.default.BigInt(n), ee)), l.default.multiply(l.default.BigInt(t), y));
		return e.validateNew(s, "total");
	}
	abs() {
		return new e(ne(this.totalNs));
	}
	add(t) {
		return e.validateNew(l.default.add(this.totalNs, t.totalNs), "sum");
	}
	add24HourDays(t) {
		return e.validateNew(l.default.add(this.totalNs, l.default.multiply(l.default.BigInt(t), b)), "sum");
	}
	addToEpochNs(e) {
		return l.default.add(x(e), this.totalNs);
	}
	cmp(e) {
		return S(this.totalNs, e.totalNs);
	}
	divmod(t) {
		let { quotient: n, remainder: r } = re(this.totalNs, l.default.BigInt(t));
		return {
			quotient: l.default.toNumber(n),
			remainder: new e(r)
		};
	}
	fdiv(e) {
		let t = x(e), n = l.default.BigInt(t), { quotient: r, remainder: i } = re(this.totalNs, n), a = [], o, s = (l.default.lessThan(this.totalNs, u) ? -1 : 1) * Math.sign(l.default.toNumber(t));
		for (; !l.default.equal(i, u) && a.length < 50;) i = l.default.multiply(i, p), {quotient: o, remainder: i} = re(i, n), a.push(Math.abs(l.default.toNumber(o)));
		return s * Number(ne(r).toString() + "." + a.join(""));
	}
	isZero() {
		return l.default.equal(this.totalNs, u);
	}
	round(t, n) {
		let r = x(t);
		if (l.default.equal(r, d)) return this;
		let { quotient: i, remainder: a } = re(this.totalNs, r), o = l.default.lessThan(this.totalNs, u) ? "negative" : "positive", s = l.default.multiply(ne(i), r), c = l.default.add(s, r), p = S(ne(l.default.multiply(a, f)), r), m = Be(n, o), h = l.default.equal(ne(this.totalNs), s) ? s : Ve(s, c, p, te(i), m), g = o === "positive" ? h : l.default.unaryMinus(h);
		return e.validateNew(g, "rounding");
	}
	sign() {
		return this.cmp(new e(u));
	}
	subtract(t) {
		return e.validateNew(l.default.subtract(this.totalNs, t.totalNs), "difference");
	}
};
P.MAX = l.default.BigInt("9007199254740991999999999"), P.ZERO = new P(u);
var He = /[A-Za-z._][A-Za-z._0-9+-]*/, Ue = RegExp(`(?:(?:[+-](?:[01][0-9]|2[0-3])(?::?[0-5][0-9])?)|(?:${He.source})(?:\\/(?:${He.source}))*)`), We = /(?:[+-]\d{6}|\d{4})/, Ge = /(?:0[1-9]|1[0-2])/, Ke = /(?:0[1-9]|[12]\d|3[01])/, qe = RegExp(`(${We.source})(?:-(${Ge.source})-(${Ke.source})|(${Ge.source})(${Ke.source}))`), Je = /(\d{2})(?::(\d{2})(?::(\d{2})(?:[.,](\d{1,9}))?)?|(\d{2})(?:(\d{2})(?:[.,](\d{1,9}))?)?)?/, Ye = /((?:[+-])(?:[01][0-9]|2[0-3])(?::?(?:[0-5][0-9])(?::?(?:[0-5][0-9])(?:[.,](?:\d{1,9}))?)?)?)/, Xe = RegExp(`([zZ])|${Ye.source}?`), Ze = /\[(!)?([a-z_][a-z0-9_-]*)=([A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)\]/g, Qe = new RegExp([
	`^${qe.source}`,
	`(?:(?:[tT]|\\s+)${Je.source}(?:${Xe.source})?)?`,
	`(?:\\[!?(${Ue.source})\\])?`,
	`((?:${Ze.source})*)$`
].join("")), $e = new RegExp([
	`^[tT]?${Je.source}`,
	`(?:${Xe.source})?`,
	`(?:\\[!?${Ue.source}\\])?`,
	`((?:${Ze.source})*)$`
].join("")), et = RegExp(`^(${We.source})-?(${Ge.source})(?:\\[!?${Ue.source}\\])?((?:${Ze.source})*)$`), tt = RegExp(`^(?:--)?(${Ge.source})-?(${Ke.source})(?:\\[!?${Ue.source}\\])?((?:${Ze.source})*)$`), nt = /(\d+)(?:[.,](\d{1,9}))?/, rt = RegExp(`(?:${nt.source}H)?(?:${nt.source}M)?(?:${nt.source}S)?`), it = RegExp(`^([+-])?P(?:(\\d+)Y)?(?:(\\d+)M)?(?:(\\d+)W)?(?:(\\d+)D)?(?:T(?!$)${rt.source})?$`, "i"), at = 864e5, ot = 1e6 * at, st = 6e10, ct = 1e8 * at, lt = Gi(ct), ut = l.default.unaryMinus(lt), dt = l.default.add(l.default.subtract(ut, b), d), ft = l.default.subtract(l.default.add(lt, b), d), pt = 146097 * at, mt = -271821, ht = 275760, gt = Date.UTC(1847, 0, 1), _t = [
	"iso8601",
	"hebrew",
	"islamic",
	"islamic-umalqura",
	"islamic-tbla",
	"islamic-civil",
	"islamic-rgsa",
	"islamicc",
	"persian",
	"ethiopic",
	"ethioaa",
	"ethiopic-amete-alem",
	"coptic",
	"chinese",
	"dangi",
	"roc",
	"indian",
	"buddhist",
	"japanese",
	"gregory"
], vt = /* @__PURE__ */ new Set([
	"ACT",
	"AET",
	"AGT",
	"ART",
	"AST",
	"BET",
	"BST",
	"CAT",
	"CNT",
	"CST",
	"CTT",
	"EAT",
	"ECT",
	"IET",
	"IST",
	"JST",
	"MIT",
	"NET",
	"NST",
	"PLT",
	"PNT",
	"PRT",
	"PST",
	"SST",
	"VST"
]);
function F(e) {
	return typeof e == "object" && !!e || typeof e == "function";
}
function yt(e) {
	if (typeof e == "bigint") throw TypeError("Cannot convert BigInt to number");
	return Number(e);
}
function bt(e) {
	if (typeof e == "symbol") throw TypeError("Cannot convert a Symbol value to a String");
	return String(e);
}
function I(e) {
	let t = yt(e);
	if (t === 0) return 0;
	if (Number.isNaN(t) || t === 1 / 0 || t === -1 / 0) throw RangeError("invalid number value");
	let n = Math.trunc(t);
	return n === 0 ? 0 : n;
}
function xt(e, t) {
	let n = I(e);
	if (n <= 0) throw RangeError(t === void 0 ? "Cannot convert a number less than one to a positive integer" : `property '${t}' cannot be a a number less than one`);
	return n;
}
function St(e) {
	let t = yt(e);
	if (Number.isNaN(t)) throw RangeError("not a number");
	if (t === 1 / 0 || t === -1 / 0) throw RangeError("infinity is out of range");
	if (!function(e) {
		if (typeof e != "number" || Number.isNaN(e) || e === 1 / 0 || e === -1 / 0) return !1;
		let t = Math.abs(e);
		return Math.floor(t) === t;
	}(t)) throw RangeError(`unsupported fractional value ${e}`);
	return t === 0 ? 0 : t;
}
function Ct(e, t) {
	return String(e).padStart(t, "0");
}
function L(e) {
	if (typeof e != "string") throw TypeError(`expected a string, not ${String(e)}`);
	return e;
}
function wt(e, t) {
	if (F(e)) {
		let t = e?.toString();
		if (typeof t == "string" || typeof t == "number") return t;
		throw TypeError("Cannot convert object to primitive value");
	}
	return e;
}
var Tt = [
	"era",
	"eraYear",
	"year",
	"month",
	"monthCode",
	"day",
	"hour",
	"minute",
	"second",
	"millisecond",
	"microsecond",
	"nanosecond",
	"offset",
	"timeZone"
], Et = {
	era: bt,
	eraYear: I,
	year: I,
	month: xt,
	monthCode: function(e) {
		let t = L(wt(e));
		if (t.length < 3 || t.length > 4 || t[0] !== "M" || "0123456789".indexOf(t[1]) === -1 || "0123456789".indexOf(t[2]) === -1 || t[1] + t[2] === "00" && t[3] !== "L" || t[3] !== "L" && t[3] !== void 0) throw RangeError(`bad month code ${t}; must match M01-M99 or M00L-M99L`);
		return t;
	},
	day: xt,
	hour: I,
	minute: I,
	second: I,
	millisecond: I,
	microsecond: I,
	nanosecond: I,
	offset: function(e) {
		let t = L(wt(e));
		return br(t), t;
	},
	timeZone: $n
}, Dt = {
	hour: 0,
	minute: 0,
	second: 0,
	millisecond: 0,
	microsecond: 0,
	nanosecond: 0
}, Ot = [
	[
		"years",
		"year",
		"date"
	],
	[
		"months",
		"month",
		"date"
	],
	[
		"weeks",
		"week",
		"date"
	],
	[
		"days",
		"day",
		"date"
	],
	[
		"hours",
		"hour",
		"time"
	],
	[
		"minutes",
		"minute",
		"time"
	],
	[
		"seconds",
		"second",
		"time"
	],
	[
		"milliseconds",
		"millisecond",
		"time"
	],
	[
		"microseconds",
		"microsecond",
		"time"
	],
	[
		"nanoseconds",
		"nanosecond",
		"time"
	]
], kt = Object.fromEntries(Ot.map(((e) => [e[0], e[1]]))), At = Object.fromEntries(Ot.map((([e, t]) => [t, e]))), jt = Ot.map((([, e]) => e)), Mt = {
	day: ot,
	hour: 36e11,
	minute: 6e10,
	second: 1e9,
	millisecond: 1e6,
	microsecond: 1e3,
	nanosecond: 1
}, Nt = [
	"days",
	"hours",
	"microseconds",
	"milliseconds",
	"minutes",
	"months",
	"nanoseconds",
	"seconds",
	"weeks",
	"years"
], Pt = Intl.DateTimeFormat, Ft = /* @__PURE__ */ new Map();
function It(e) {
	let t = $i(e), n = Ft.get(t);
	return n === void 0 && (n = new Pt("en-us", {
		timeZone: t,
		hour12: !1,
		era: "short",
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric"
	}), Ft.set(t, n)), n;
}
function R(e) {
	return Pe(e, C) && !Pe(e, O, D);
}
function z(e) {
	return Pe(e, le, ue, k, A, fe, pe, me, he, ge);
}
function B(e) {
	return Pe(e, oe);
}
function V(e) {
	return Pe(e, E);
}
function H(e) {
	return Pe(e, T);
}
function U(e) {
	return Pe(e, se);
}
function Lt(e) {
	return Pe(e, ce);
}
function W(e) {
	return Pe(e, C, O, D);
}
function G(e, t) {
	if (!t(e)) throw TypeError("invalid receiver: method called with the wrong type of this-object");
}
function Rt(e) {
	if (Pe(e, D) || Pe(e, O)) throw TypeError("with() does not support a calendar or timeZone property");
	if (V(e)) throw TypeError("with() does not accept Temporal.PlainTime, use withPlainTime() instead");
	if (e.calendar !== void 0) throw TypeError("with() does not support a calendar property");
	if (e.timeZone !== void 0) throw TypeError("with() does not support a timeZone property");
}
function zt(e, t) {
	return t === "never" || t === "auto" && e === "iso8601" ? "" : `[${t === "critical" ? "!" : ""}u-ca=${e}]`;
}
function Bt(e) {
	let t, n, r = !1;
	for (Ze.lastIndex = 0; n = Ze.exec(e);) {
		let { 1: i, 2: a, 3: o } = n;
		if (a === "u-ca") {
			if (t === void 0) t = o, r = i === "!";
			else if (i === "!" || r) throw RangeError(`Invalid annotations in ${e}: more than one u-ca present with critical flag`);
		} else if (i === "!") throw RangeError(`Unrecognized annotation: !${a}=${o}`);
	}
	return t;
}
function Vt(e) {
	let t = Qe.exec(e);
	if (!t) throw RangeError(`invalid RFC 9557 string: ${e}`);
	let n = Bt(t[16]), r = t[1];
	if (r === "-000000") throw RangeError(`invalid RFC 9557 string: ${e}`);
	let i = +r, a = +(t[2] ?? t[4] ?? 1), o = +(t[3] ?? t[5] ?? 1), s = t[6] !== void 0, c = +(t[6] ?? 0), l = +(t[7] ?? t[10] ?? 0), u = +(t[8] ?? t[11] ?? 0);
	u === 60 && (u = 59);
	let d = (t[9] ?? t[12] ?? "") + "000000000", f = +d.slice(0, 3), p = +d.slice(3, 6), m = +d.slice(6, 9), h, g = !1;
	t[13] ? (h = void 0, g = !0) : t[14] && (h = t[14]);
	let _ = t[15];
	return Yr(i, a, o, c, l, u, f, p, m), {
		year: i,
		month: a,
		day: o,
		time: s ? {
			hour: c,
			minute: l,
			second: u,
			millisecond: f,
			microsecond: p,
			nanosecond: m
		} : "start-of-day",
		tzAnnotation: _,
		offset: h,
		z: g,
		calendar: n
	};
}
function Ht(e) {
	let t = $e.exec(e), n, r, i, a, o, s, c;
	if (t) {
		c = Bt(t[10]), n = +(t[1] ?? 0), r = +(t[2] ?? t[5] ?? 0), i = +(t[3] ?? t[6] ?? 0), i === 60 && (i = 59);
		let e = (t[4] ?? t[7] ?? "") + "000000000";
		if (a = +e.slice(0, 3), o = +e.slice(3, 6), s = +e.slice(6, 9), t[8]) throw RangeError("Z designator not supported for PlainTime");
	} else {
		let t, l;
		if ({time: t, z: l, calendar: c} = Vt(e), t === "start-of-day") throw RangeError(`time is missing in string: ${e}`);
		if (l) throw RangeError("Z designator not supported for PlainTime");
		({hour: n, minute: r, second: i, millisecond: a, microsecond: o, nanosecond: s} = t);
	}
	if (Jr(n, r, i, a, o, s), /[tT ][0-9][0-9]/.test(e)) return {
		hour: n,
		minute: r,
		second: i,
		millisecond: a,
		microsecond: o,
		nanosecond: s,
		calendar: c
	};
	try {
		let { month: t, day: n } = Wt(e);
		Kr(1972, t, n);
	} catch {
		try {
			let { year: t, month: n } = Ut(e);
			Kr(t, n, 1);
		} catch {
			return {
				hour: n,
				minute: r,
				second: i,
				millisecond: a,
				microsecond: o,
				nanosecond: s,
				calendar: c
			};
		}
	}
	throw RangeError(`invalid RFC 9557 time-only string ${e}; may need a T prefix`);
}
function Ut(e) {
	let t = et.exec(e), n, r, i, a;
	if (t) {
		i = Bt(t[3]);
		let o = t[1];
		if (o === "-000000") throw RangeError(`invalid RFC 9557 string: ${e}`);
		if (n = +o, r = +t[2], a = 1, i !== void 0 && i !== "iso8601") throw RangeError("YYYY-MM format is only valid with iso8601 calendar");
	} else {
		let t;
		if ({year: n, month: r, calendar: i, day: a, z: t} = Vt(e), t) throw RangeError("Z designator not supported for PlainYearMonth");
	}
	return {
		year: n,
		month: r,
		calendar: i,
		referenceISODay: a
	};
}
function Wt(e) {
	let t = tt.exec(e), n, r, i, a;
	if (t) {
		if (i = Bt(t[3]), n = +t[1], r = +t[2], i !== void 0 && i !== "iso8601") throw RangeError("MM-DD format is only valid with iso8601 calendar");
	} else {
		let t;
		if ({month: n, day: r, calendar: i, year: a, z: t} = Vt(e), t) throw RangeError("Z designator not supported for PlainMonthDay");
	}
	return {
		month: n,
		day: r,
		calendar: i,
		referenceISOYear: a
	};
}
var Gt = RegExp(`^${Ue.source}$`, "i"), Kt = /* @__PURE__ */ RegExp("^([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])?)?$");
function qt(e) {
	let t = ta.test(e) ? "Seconds not allowed in offset time zone" : "Invalid time zone";
	throw RangeError(`${t}: ${e}`);
}
function Jt(e) {
	return Gt.test(e) || qt(e), Kt.test(e) ? { offsetMinutes: br(e) / 6e10 } : { tzName: e };
}
function Yt(e, t, n, r) {
	let i = e, a = t, o = n;
	switch (r) {
		case "reject":
			Kr(i, a, o);
			break;
		case "constrain": ({year: i, month: a, day: o} = Gr(i, a, o));
	}
	return {
		year: i,
		month: a,
		day: o
	};
}
function Xt(e, t, n, r, i, a, o) {
	let s = e, c = t, l = n, u = r, d = i, f = a;
	switch (o) {
		case "reject":
			Jr(s, c, l, u, d, f);
			break;
		case "constrain": s = Wr(s, 0, 23), c = Wr(c, 0, 59), l = Wr(l, 0, 59), u = Wr(u, 0, 999), d = Wr(d, 0, 999), f = Wr(f, 0, 999);
	}
	return {
		hour: s,
		minute: c,
		second: l,
		millisecond: u,
		microsecond: d,
		nanosecond: f
	};
}
function Zt(e) {
	if (!F(e)) throw TypeError("invalid duration-like");
	let t = {
		years: void 0,
		months: void 0,
		weeks: void 0,
		days: void 0,
		hours: void 0,
		minutes: void 0,
		seconds: void 0,
		milliseconds: void 0,
		microseconds: void 0,
		nanoseconds: void 0
	}, n = !1;
	for (let r = 0; r < Nt.length; r++) {
		let i = Nt[r], a = e[i];
		a !== void 0 && (n = !0, t[i] = St(a));
	}
	if (!n) throw TypeError("invalid duration-like");
	return t;
}
function K({ years: e, months: t, weeks: n, days: r }, i, a, o) {
	return {
		years: e,
		months: o ?? t,
		weeks: a ?? n,
		days: i ?? r
	};
}
function q(e, t) {
	return {
		isoDate: e,
		time: t
	};
}
function J(e) {
	return Zi(e, "overflow", ["constrain", "reject"], "constrain");
}
function Qt(e) {
	return Zi(e, "disambiguation", [
		"compatible",
		"earlier",
		"later",
		"reject"
	], "compatible");
}
function $t(e, t) {
	return Zi(e, "roundingMode", [
		"ceil",
		"floor",
		"expand",
		"trunc",
		"halfCeil",
		"halfFloor",
		"halfExpand",
		"halfTrunc",
		"halfEven"
	], t);
}
function en(e, t) {
	return Zi(e, "offset", [
		"prefer",
		"use",
		"ignore",
		"reject"
	], t);
}
function tn(e) {
	return Zi(e, "calendarName", [
		"auto",
		"always",
		"never",
		"critical"
	], "auto");
}
function nn(e) {
	let t = e.roundingIncrement;
	if (t === void 0) return 1;
	let n = I(t);
	if (n < 1 || n > 1e9) throw RangeError(`roundingIncrement must be at least 1 and at most 1e9, not ${t}`);
	return n;
}
function rn(e, t, n) {
	let r = n ? t : t - 1;
	if (e > r) throw RangeError(`roundingIncrement must be at least 1 and less than ${r}, not ${e}`);
	if (t % e != 0) throw RangeError(`Rounding increment must divide evenly into ${t}`);
}
function an(e) {
	let t = e.fractionalSecondDigits;
	if (t === void 0) return "auto";
	if (typeof t != "number") {
		if (bt(t) !== "auto") throw RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
		return "auto";
	}
	let n = Math.floor(t);
	if (!Number.isFinite(n) || n < 0 || n > 9) throw RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
	return n;
}
function on(e, t) {
	switch (e) {
		case "minute": return {
			precision: "minute",
			unit: "minute",
			increment: 1
		};
		case "second": return {
			precision: 0,
			unit: "second",
			increment: 1
		};
		case "millisecond": return {
			precision: 3,
			unit: "millisecond",
			increment: 1
		};
		case "microsecond": return {
			precision: 6,
			unit: "microsecond",
			increment: 1
		};
		case "nanosecond": return {
			precision: 9,
			unit: "nanosecond",
			increment: 1
		};
	}
	switch (t) {
		case "auto": return {
			precision: t,
			unit: "nanosecond",
			increment: 1
		};
		case 0: return {
			precision: t,
			unit: "second",
			increment: 1
		};
		case 1:
		case 2:
		case 3: return {
			precision: t,
			unit: "millisecond",
			increment: 10 ** (3 - t)
		};
		case 4:
		case 5:
		case 6: return {
			precision: t,
			unit: "microsecond",
			increment: 10 ** (6 - t)
		};
		case 7:
		case 8:
		case 9: return {
			precision: t,
			unit: "nanosecond",
			increment: 10 ** (9 - t)
		};
		default: throw RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
	}
}
var sn = Symbol("~required~");
function cn(e, t, n, r, i = []) {
	let a = [];
	for (let e = 0; e < Ot.length; e++) {
		let t = Ot[e], r = t[1], i = t[2];
		n !== "datetime" && n !== i || a.push(r);
	}
	a = a.concat(i);
	let o = r;
	o === sn ? o = void 0 : o !== void 0 && a.push(o);
	let s = [];
	s = s.concat(a);
	for (let e = 0; e < a.length; e++) {
		let t = At[a[e]];
		t !== void 0 && s.push(t);
	}
	let c = Zi(e, t, s, o);
	if (c === void 0 && r === sn) throw RangeError(`${t} is required`);
	return c && c in kt ? kt[c] : c;
}
function ln(e) {
	let t = e.relativeTo;
	if (t === void 0) return {};
	let n, r, i, a, o, s = "option", c = !1;
	if (F(t)) {
		if (W(t)) return { zonedRelativeTo: t };
		if (B(t)) return { plainRelativeTo: t };
		if (H(t)) return { plainRelativeTo: jn(j(t, T).isoDate, j(t, D)) };
		i = Jn(t);
		let e = _n(i, t, [
			"year",
			"month",
			"monthCode",
			"day"
		], [
			"hour",
			"minute",
			"second",
			"millisecond",
			"microsecond",
			"nanosecond",
			"offset",
			"timeZone"
		], []);
		({isoDate: n, time: r} = bn(i, e, "constrain")), {offset: o, timeZone: a} = e, o === void 0 && (s = "wall");
	} else {
		let e, l, u, d, f;
		if ({year: u, month: d, day: f, time: r, calendar: i, tzAnnotation: e, offset: o, z: l} = Vt(L(t)), e) a = $n(e), l ? s = "exact" : o || (s = "wall"), c = !0;
		else if (l) throw RangeError("Z designator not supported for PlainDate relativeTo; either remove the Z or add a bracketed time zone");
		i ||= "iso8601", i = Qi(i), n = {
			year: u,
			month: d,
			day: f
		};
	}
	return a === void 0 ? { plainRelativeTo: jn(n, i) } : { zonedRelativeTo: Y(On(n, r, s, s === "option" ? br(o) : 0, a, "compatible", "reject", c), a, i) };
}
function un(e) {
	return j(e, le) === 0 ? j(e, ue) === 0 ? j(e, de) === 0 ? j(e, k) === 0 ? j(e, A) === 0 ? j(e, fe) === 0 ? j(e, pe) === 0 ? j(e, me) === 0 ? j(e, he) === 0 ? "nanosecond" : "microsecond" : "millisecond" : "second" : "minute" : "hour" : "day" : "week" : "month" : "year";
}
function dn(e, t) {
	return jt.indexOf(e) > jt.indexOf(t) ? t : e;
}
function fn(e) {
	return e === "year" || e === "month" || e === "week";
}
function pn(e) {
	return fn(e) || e === "day" ? "date" : "time";
}
function mn(e) {
	return N("%calendarImpl%")(e);
}
function hn(e) {
	return N("%calendarImpl%")(j(e, D));
}
function gn(e, t, n = "date") {
	let r = Object.create(null), i = mn(e).isoToDate(t, {
		year: !0,
		monthCode: !0,
		day: !0
	});
	return r.monthCode = i.monthCode, n !== "month-day" && n !== "date" || (r.day = i.day), n !== "year-month" && n !== "date" || (r.year = i.year), r;
}
function _n(e, t, n, r, i) {
	let a = mn(e).extraFields(n), o = n.concat(r, a), s = Object.create(null), c = !1;
	o.sort();
	for (let e = 0; e < o.length; e++) {
		let n = o[e], r = t[n];
		if (r !== void 0) c = !0, s[n] = (0, Et[n])(r);
		else if (i !== "partial") {
			if (i.includes(n)) throw TypeError(`required property '${n}' missing or undefined`);
			s[n] = Dt[n];
		}
	}
	if (i === "partial" && !c) throw TypeError("no supported properties found");
	return s;
}
function vn(e, t = "complete") {
	let n = [
		"hour",
		"microsecond",
		"millisecond",
		"minute",
		"nanosecond",
		"second"
	], r = !1, i = Object.create(null);
	for (let a = 0; a < n.length; a++) {
		let o = n[a], s = e[o];
		s === void 0 ? t === "complete" && (i[o] = 0) : (i[o] = I(s), r = !0);
	}
	if (!r) throw TypeError("invalid time-like");
	return i;
}
function yn(e, t) {
	if (F(e)) {
		if (B(e)) return J($(t)), jn(j(e, w), j(e, D));
		if (W(e)) {
			let n = rr(j(e, O), j(e, C));
			return J($(t)), jn(n.isoDate, j(e, D));
		}
		if (H(e)) return J($(t)), jn(j(e, T).isoDate, j(e, D));
		let n = Jn(e);
		return jn(Xn(n, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [], []), J($(t))), n);
	}
	let { year: n, month: r, day: i, calendar: a, z: o } = Vt(L(e));
	if (o) throw RangeError("Z designator not supported for PlainDate");
	return a ||= "iso8601", a = Qi(a), J($(t)), jn({
		year: n,
		month: r,
		day: i
	}, a);
}
function bn(e, t, n) {
	return q(Xn(e, t, n), Xt(t.hour, t.minute, t.second, t.millisecond, t.microsecond, t.nanosecond, n));
}
function xn(e, t) {
	let n, r, i;
	if (F(e)) {
		if (H(e)) return J($(t)), Nn(j(e, T), j(e, D));
		if (W(e)) {
			let n = rr(j(e, O), j(e, C));
			return J($(t)), Nn(n, j(e, D));
		}
		if (B(e)) return J($(t)), Nn(q(j(e, w), {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		}), j(e, D));
		i = Jn(e);
		let a = _n(i, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [
			"hour",
			"minute",
			"second",
			"millisecond",
			"microsecond",
			"nanosecond"
		], []), o = J($(t));
		({isoDate: n, time: r} = bn(i, a, o));
	} else {
		let a, o, s, c;
		if ({year: o, month: s, day: c, time: r, calendar: i, z: a} = Vt(L(e)), a) throw RangeError("Z designator not supported for PlainDateTime");
		r === "start-of-day" && (r = {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		}), Yr(o, s, c, r.hour, r.minute, r.second, r.millisecond, r.microsecond, r.nanosecond), i ||= "iso8601", i = Qi(i), J($(t)), n = {
			year: o,
			month: s,
			day: c
		};
	}
	return Nn(q(n, r), i);
}
function Sn(e) {
	let t = N("%Temporal.Duration%");
	if (z(e)) return new t(j(e, le), j(e, ue), j(e, de), j(e, k), j(e, A), j(e, fe), j(e, pe), j(e, me), j(e, he), j(e, ge));
	if (!F(e)) return function(e) {
		let { years: t, months: n, weeks: r, days: i, hours: a, minutes: o, seconds: s, milliseconds: c, microseconds: l, nanoseconds: u } = function(e) {
			let t = it.exec(e);
			if (!t || t.every(((e, t) => t < 2 || e === void 0))) throw RangeError(`invalid duration: ${e}`);
			let n = t[1] === "-" ? -1 : 1, r = t[2] === void 0 ? 0 : I(t[2]) * n, i = t[3] === void 0 ? 0 : I(t[3]) * n, a = t[4] === void 0 ? 0 : I(t[4]) * n, o = t[5] === void 0 ? 0 : I(t[5]) * n, s = t[6] === void 0 ? 0 : I(t[6]) * n, c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = 0, m = 0, h = 0;
			if (c !== void 0) {
				if (l ?? u ?? d ?? f) throw RangeError("only the smallest unit can be fractional");
				h = 3600 * I((c + "000000000").slice(0, 9)) * n;
			} else if (p = l === void 0 ? 0 : I(l) * n, u !== void 0) {
				if (d ?? f) throw RangeError("only the smallest unit can be fractional");
				h = 60 * I((u + "000000000").slice(0, 9)) * n;
			} else m = d === void 0 ? 0 : I(d) * n, f !== void 0 && (h = I((f + "000000000").slice(0, 9)) * n);
			let g = h % 1e3, _ = Math.trunc(h / 1e3) % 1e3, v = Math.trunc(h / 1e6) % 1e3;
			return m += Math.trunc(h / 1e9) % 60, p += Math.trunc(h / 6e10), ei(r, i, a, o, s, p, m, v, _, g), {
				years: r,
				months: i,
				weeks: a,
				days: o,
				hours: s,
				minutes: p,
				seconds: m,
				milliseconds: v,
				microseconds: _,
				nanoseconds: g
			};
		}(e);
		return new (N("%Temporal.Duration%"))(t, n, r, i, a, o, s, c, l, u);
	}(L(e));
	let n = {
		years: 0,
		months: 0,
		weeks: 0,
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
		milliseconds: 0,
		microseconds: 0,
		nanoseconds: 0
	}, r = Zt(e);
	for (let e = 0; e < Nt.length; e++) {
		let t = Nt[e], i = r[t];
		i !== void 0 && (n[t] = i);
	}
	return new t(n.years, n.months, n.weeks, n.days, n.hours, n.minutes, n.seconds, n.milliseconds, n.microseconds, n.nanoseconds);
}
function Cn(e) {
	let t;
	if (F(e)) {
		if (R(e) || W(e)) return Vn(j(e, C));
		t = wt(e);
	} else t = e;
	let { year: n, month: r, day: i, time: a, offset: o, z: s } = function(e) {
		let t = Vt(e);
		if (!t.z && !t.offset) throw RangeError("Temporal.Instant requires a time zone offset");
		return t;
	}(L(t)), { hour: c = 0, minute: l = 0, second: u = 0, millisecond: d = 0, microsecond: f = 0, nanosecond: p = 0 } = a === "start-of-day" ? {} : a, m = Br(n, r, i, c, l, u, d, f, p - (s ? 0 : br(o)));
	return si(m.isoDate), Vn(Z(m));
}
function wn(e, t) {
	if (F(e)) {
		if (Lt(e)) return J($(t)), Fn(j(e, w), j(e, D));
		let n;
		return Pe(e, D) ? n = j(e, D) : (n = e.calendar, n === void 0 && (n = "iso8601"), n = qn(n)), Fn(Qn(n, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [], []), J($(t))), n);
	}
	let { month: n, day: r, referenceISOYear: i, calendar: a } = Wt(L(e));
	if (a === void 0 && (a = "iso8601"), a = Qi(a), J($(t)), a === "iso8601") return Fn({
		year: 1972,
		month: n,
		day: r
	}, a);
	let o = {
		year: i,
		month: n,
		day: r
	};
	return qr(o), o = Qn(a, gn(a, o, "month-day"), "constrain"), Fn(o, a);
}
function Tn(e, t) {
	let n;
	if (F(e)) {
		if (V(e)) return J($(t)), Ln(j(e, E));
		if (H(e)) return J($(t)), Ln(j(e, T).time);
		if (W(e)) {
			let n = rr(j(e, O), j(e, C));
			return J($(t)), Ln(n.time);
		}
		let { hour: r, minute: i, second: a, millisecond: o, microsecond: s, nanosecond: c } = vn(e);
		n = Xt(r, i, a, o, s, c, J($(t)));
	} else n = Ht(L(e)), J($(t));
	return Ln(n);
}
function En(e) {
	return e === void 0 ? {
		deltaDays: 0,
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0,
		microsecond: 0,
		nanosecond: 0
	} : j(Tn(e), E);
}
function Dn(e, t) {
	if (F(e)) {
		if (U(e)) return J($(t)), zn(j(e, w), j(e, D));
		let n = Jn(e);
		return zn(Zn(n, _n(n, e, [
			"year",
			"month",
			"monthCode"
		], [], []), J($(t))), n);
	}
	let { year: n, month: r, referenceISODay: i, calendar: a } = Ut(L(e));
	a === void 0 && (a = "iso8601"), a = Qi(a), J($(t));
	let o = {
		year: n,
		month: r,
		day: i
	};
	return $r(o), o = Zn(a, gn(a, o, "year-month"), "constrain"), zn(o, a);
}
function On(e, t, n, r, i, a, o, s) {
	if (t === "start-of-day") return or(i, e);
	let c = q(e, t);
	if (n === "wall" || o === "ignore") return X(i, c, a);
	if (n === "exact" || o === "use") {
		let n = Br(e.year, e.month, e.day, t.hour, t.minute, t.second, t.millisecond, t.microsecond, t.nanosecond - r);
		si(n.isoDate);
		let i = Z(n);
		return Qr(i), i;
	}
	si(e);
	let u = Z(c), d = ar(i, c);
	for (let e = 0; e < d.length; e++) {
		let t = d[e], n = l.default.toNumber(l.default.subtract(u, t)), i = Pi(n, 6e10, "halfExpand");
		if (n === r || s && i === r) return t;
	}
	if (o === "reject") {
		let e = nr(r), t = hr(c, "iso8601", "auto");
		throw RangeError(`Offset ${e} is invalid for ${t} in ${i}`);
	}
	return ir(d, i, c, a);
}
function kn(e, t) {
	let n, r, i, a, o, s, c, l = !1, u = "option";
	if (F(e)) {
		if (W(e)) {
			let n = $(t);
			return Qt(n), en(n, "reject"), J(n), Y(j(e, C), j(e, O), j(e, D));
		}
		o = Jn(e);
		let l = _n(o, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [
			"hour",
			"minute",
			"second",
			"millisecond",
			"microsecond",
			"nanosecond",
			"offset",
			"timeZone"
		], ["timeZone"]);
		({offset: a, timeZone: i} = l), a === void 0 && (u = "wall");
		let d = $(t);
		s = Qt(d), c = en(d, "reject");
		let f = J(d);
		({isoDate: n, time: r} = bn(o, l, f));
	} else {
		let d, f, p, m, h;
		({year: p, month: m, day: h, time: r, tzAnnotation: d, offset: a, z: f, calendar: o} = function(e) {
			let t = Vt(e);
			if (!t.tzAnnotation) throw RangeError("Temporal.ZonedDateTime requires a time zone ID in brackets");
			return t;
		}(L(e))), i = $n(d), f ? u = "exact" : a || (u = "wall"), o ||= "iso8601", o = Qi(o), l = !0;
		let g = $(t);
		s = Qt(g), c = en(g, "reject"), J(g), n = {
			year: p,
			month: m,
			day: h
		};
	}
	let d = 0;
	return u === "option" && (d = br(a)), Y(On(n, r, u, d, i, s, c, l), i, o);
}
function An(e, t, n) {
	qr(t), Ne(e), M(e, w, t), M(e, D, n), M(e, oe, !0);
}
function jn(e, t) {
	let n = N("%Temporal.PlainDate%"), r = Object.create(n.prototype);
	return An(r, e, t), r;
}
function Mn(e, t, n) {
	Xr(t), Ne(e), M(e, T, t), M(e, D, n);
}
function Nn(e, t) {
	let n = N("%Temporal.PlainDateTime%"), r = Object.create(n.prototype);
	return Mn(r, e, t), r;
}
function Pn(e, t, n) {
	qr(t), Ne(e), M(e, w, t), M(e, D, n), M(e, ce, !0);
}
function Fn(e, t) {
	let n = N("%Temporal.PlainMonthDay%"), r = Object.create(n.prototype);
	return Pn(r, e, t), r;
}
function In(e, t) {
	Ne(e), M(e, E, t);
}
function Ln(e) {
	let t = N("%Temporal.PlainTime%"), n = Object.create(t.prototype);
	return In(n, e), n;
}
function Rn(e, t, n) {
	$r(t), Ne(e), M(e, w, t), M(e, D, n), M(e, se, !0);
}
function zn(e, t) {
	let n = N("%Temporal.PlainYearMonth%"), r = Object.create(n.prototype);
	return Rn(r, e, t), r;
}
function Bn(e, t) {
	Qr(t), Ne(e), M(e, C, t);
}
function Vn(e) {
	let t = N("%Temporal.Instant%"), n = Object.create(t.prototype);
	return Bn(n, e), n;
}
function Hn(e, t, n, r) {
	Qr(t), Ne(e), M(e, C, t), M(e, O, n), M(e, D, r);
}
function Y(e, t, n = "iso8601") {
	let r = N("%Temporal.ZonedDateTime%"), i = Object.create(r.prototype);
	return Hn(i, e, t, n), i;
}
function Un(e) {
	return Tt.filter(((t) => e[t] !== void 0));
}
function Wn(e, t, n) {
	let r = Un(n), i = mn(e).fieldKeysToIgnore(r), a = Object.create(null), o = Un(t);
	for (let e = 0; e < Tt.length; e++) {
		let s, c = Tt[e];
		o.includes(c) && !i.includes(c) && (s = t[c]), r.includes(c) && (s = n[c]), s !== void 0 && (a[c] = s);
	}
	return a;
}
function Gn(e, t, n, r) {
	let i = mn(e).dateAdd(t, n, r);
	return qr(i), i;
}
function Kn(e, t, n, r) {
	return mn(e).dateUntil(t, n, r);
}
function qn(e) {
	if (F(e) && Pe(e, D)) return j(e, D);
	let t = L(e);
	try {
		return Qi(t);
	} catch {}
	let n;
	try {
		({calendar: n} = Vt(t));
	} catch {
		try {
			({calendar: n} = Ht(t));
		} catch {
			try {
				({calendar: n} = Ut(t));
			} catch {
				({calendar: n} = Wt(t));
			}
		}
	}
	return n ||= "iso8601", Qi(n);
}
function Jn(e) {
	if (Pe(e, D)) return j(e, D);
	let { calendar: t } = e;
	return t === void 0 ? "iso8601" : qn(t);
}
function Yn(e, t) {
	return Qi(e) === Qi(t);
}
function Xn(e, t, n) {
	let r = mn(e);
	r.resolveFields(t, "date");
	let i = r.dateToISO(t, n);
	return qr(i), i;
}
function Zn(e, t, n) {
	let r = mn(e);
	r.resolveFields(t, "year-month"), t.day = 1;
	let i = r.dateToISO(t, n);
	return $r(i), i;
}
function Qn(e, t, n) {
	let r = mn(e);
	r.resolveFields(t, "month-day");
	let i = r.monthDayToISOReferenceDate(t, n);
	return qr(i), i;
}
function $n(e) {
	if (F(e) && W(e)) return j(e, O);
	let t = L(e);
	if (t === "UTC") return "UTC";
	let { tzName: n, offsetMinutes: r } = function(e) {
		let { tzAnnotation: t, offset: n, z: r } = function(e) {
			if (Gt.test(e)) return {
				tzAnnotation: e,
				offset: void 0,
				z: !1
			};
			try {
				let { tzAnnotation: t, offset: n, z: r } = Vt(e);
				if (r || t || n) return {
					tzAnnotation: t,
					offset: n,
					z: r
				};
			} catch {}
			qt(e);
		}(e);
		return t ? Jt(t) : r ? Jt("UTC") : n ? Jt(n) : void 0;
	}(t);
	if (r !== void 0) return Er(r);
	let i = Cr(n);
	if (!i) throw RangeError(`Unrecognized time zone ${n}`);
	return i.identifier;
}
function er(e, t) {
	if (e === t) return !0;
	let n = Jt(e).offsetMinutes, r = Jt(t).offsetMinutes;
	if (n === void 0 && r === void 0) {
		let n = Cr(t);
		if (!n) return !1;
		let r = Cr(e);
		return !!r && r.primaryIdentifier === n.primaryIdentifier;
	}
	return n === r;
}
function tr(e, t) {
	let n = Jt(e).offsetMinutes;
	return n === void 0 ? Tr(e, t) : 6e10 * n;
}
function nr(e) {
	let t = e < 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 36e11), i = Math.floor(n / 6e10) % 60, a = Math.floor(n / 1e9) % 60, o = n % 1e9;
	return `${t}${ur(r, i, a, o, a === 0 && o === 0 ? "minute" : "auto")}`;
}
function rr(e, t) {
	let n = tr(e, t), { isoDate: { year: r, month: i, day: a }, time: { hour: o, minute: s, second: c, millisecond: l, microsecond: u, nanosecond: d } } = kr(t);
	return Br(r, i, a, o, s, c, l, u, d + n);
}
function X(e, t, n) {
	return ir(ar(e, t), e, t, n);
}
function ir(e, t, n, r) {
	let i = e.length;
	if (i === 1) return e[0];
	if (i) switch (r) {
		case "compatible":
		case "earlier": return e[0];
		case "later": return e[i - 1];
		case "reject": throw RangeError("multiple instants found");
	}
	if (r === "reject") throw RangeError("multiple instants found");
	let a = Z(n), o = l.default.subtract(a, b);
	Qr(o);
	let s = tr(t, o), c = l.default.add(a, b);
	Qr(c);
	let u = tr(t, c) - s;
	switch (r) {
		case "earlier": {
			let e = P.fromComponents(0, 0, 0, 0, 0, -u), r = wi(n.time, e);
			return ar(t, q(zr(n.isoDate.year, n.isoDate.month, n.isoDate.day + r.deltaDays), r))[0];
		}
		case "compatible":
		case "later": {
			let e = P.fromComponents(0, 0, 0, 0, 0, u), r = wi(n.time, e), i = ar(t, q(zr(n.isoDate.year, n.isoDate.month, n.isoDate.day + r.deltaDays), r));
			return i[i.length - 1];
		}
	}
}
function ar(e, t) {
	if (e === "UTC") return si(t.isoDate), [Z(t)];
	let n = Jt(e).offsetMinutes;
	if (n !== void 0) {
		let e = Br(t.isoDate.year, t.isoDate.month, t.isoDate.day, t.time.hour, t.time.minute - n, t.time.second, t.time.millisecond, t.time.microsecond, t.time.nanosecond);
		si(e.isoDate);
		let r = Z(e);
		return Qr(r), [r];
	}
	return si(t.isoDate), function(e, t) {
		let n = Z(t), r = l.default.subtract(n, b);
		l.default.lessThan(r, ut) && (r = n);
		let i = l.default.add(n, b);
		l.default.greaterThan(i, lt) && (i = n);
		let a = Tr(e, r), o = Tr(e, i);
		return (a === o ? [a] : [a, o]).map(((r) => {
			let i = l.default.subtract(n, l.default.BigInt(r));
			if (Hi(t, function(e, t) {
				let { epochMilliseconds: n, time: { millisecond: r, microsecond: i, nanosecond: a } } = kr(t), { year: o, month: s, day: c, hour: l, minute: u, second: d } = Mr(e, n);
				return Br(o, s, c, l, u, d, r, i, a);
			}(e, i)) === 0) return Qr(i), i;
		})).filter(((e) => e !== void 0));
	}(e, t);
}
function or(e, t) {
	let n = q(t, {
		deltaDays: 0,
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0,
		microsecond: 0,
		nanosecond: 0
	}), r = ar(e, n);
	if (r.length) return r[0];
	let i = Z(n), a = l.default.subtract(i, b);
	return Qr(a), Ar(e, a);
}
function sr(e) {
	let t;
	return t = e < 0 || e > 9999 ? (e < 0 ? "-" : "+") + Ct(Math.abs(e), 6) : Ct(e, 4), t;
}
function cr(e) {
	return Ct(e, 2);
}
function lr(e, t) {
	let n;
	if (t === "auto") {
		if (e === 0) return "";
		n = Ct(e, 9).replace(/0+$/, "");
	} else {
		if (t === 0) return "";
		n = Ct(e, 9).slice(0, t);
	}
	return `.${n}`;
}
function ur(e, t, n, r, i) {
	let a = `${cr(e)}:${cr(t)}`;
	return i === "minute" || (a += `:${cr(n)}`, a += lr(r, i)), a;
}
function dr(e, t, n) {
	let r = t;
	r === void 0 && (r = "UTC");
	let i = j(e, C), a = hr(rr(r, i), "iso8601", n, "never"), o = "Z";
	return t !== void 0 && (o = Dr(tr(r, i))), `${a}${o}`;
}
function fr(e, t) {
	let n = j(e, le), r = j(e, ue), i = j(e, de), a = j(e, k), o = j(e, A), s = j(e, fe), c = Fr(e), l = "";
	n !== 0 && (l += `${Math.abs(n)}Y`), r !== 0 && (l += `${Math.abs(r)}M`), i !== 0 && (l += `${Math.abs(i)}W`), a !== 0 && (l += `${Math.abs(a)}D`);
	let u = "";
	o !== 0 && (u += `${Math.abs(o)}H`), s !== 0 && (u += `${Math.abs(s)}M`);
	let d = P.fromComponents(0, 0, j(e, pe), j(e, me), j(e, he), j(e, ge));
	d.isZero() && ![
		"second",
		"millisecond",
		"microsecond",
		"nanosecond"
	].includes(un(e)) && t === "auto" || (u += `${Math.abs(d.sec)}${lr(Math.abs(d.subsec), t)}S`);
	let f = `${c < 0 ? "-" : ""}P${l}`;
	return u && (f = `${f}T${u}`), f;
}
function pr(e, t = "auto") {
	let { year: n, month: r, day: i } = j(e, w);
	return `${sr(n)}-${cr(r)}-${cr(i)}${zt(j(e, D), t)}`;
}
function mr({ hour: e, minute: t, second: n, millisecond: r, microsecond: i, nanosecond: a }, o) {
	return ur(e, t, n, 1e6 * r + 1e3 * i + a, o);
}
function hr(e, t, n, r = "auto") {
	let { isoDate: { year: i, month: a, day: o }, time: { hour: s, minute: c, second: l, millisecond: u, microsecond: d, nanosecond: f } } = e;
	return `${sr(i)}-${cr(a)}-${cr(o)}T${ur(s, c, l, 1e6 * u + 1e3 * d + f, n)}${zt(t, r)}`;
}
function gr(e, t = "auto") {
	let { year: n, month: r, day: i } = j(e, w), a = `${cr(r)}-${cr(i)}`, o = j(e, D);
	t !== "always" && t !== "critical" && o === "iso8601" || (a = `${sr(n)}-${a}`);
	let s = zt(o, t);
	return s && (a += s), a;
}
function _r(e, t = "auto") {
	let { year: n, month: r, day: i } = j(e, w), a = `${sr(n)}-${cr(r)}`, o = j(e, D);
	t !== "always" && t !== "critical" && o === "iso8601" || (a += `-${cr(i)}`);
	let s = zt(o, t);
	return s && (a += s), a;
}
function vr(e, t, n = "auto", r = "auto", i = "auto", a = void 0) {
	let o = j(e, C);
	if (a) {
		let { unit: e, increment: t, roundingMode: n } = a;
		o = Fi(o, t, e, n);
	}
	let s = j(e, O), c = tr(s, o), l = hr(rr(s, o), "iso8601", t, "never");
	return i !== "never" && (l += Dr(c)), r !== "never" && (l += `[${r === "critical" ? "!" : ""}${s}]`), l += zt(j(e, D), n), l;
}
function yr(e) {
	return Kt.test(e);
}
function br(e) {
	let t = na.exec(e);
	if (!t) throw RangeError(`invalid time zone offset: ${e}; must match ±HH:MM[:SS.SSSSSSSSS]`);
	return (t[1] === "-" ? -1 : 1) * (1e9 * (60 * (60 * t[2] + +(t[3] || 0)) + +(t[4] || 0)) + +((t[5] || 0) + "000000000").slice(0, 9));
}
var xr, Sr = Object.assign(Object.create(null), {
	"/": !0,
	"-": !0,
	_: !0
});
function Cr(e) {
	if (xr === void 0) {
		let e = Intl.supportedValuesOf?.("timeZone");
		if (e) {
			xr = /* @__PURE__ */ new Map();
			for (let t = 0; t < e.length; t++) {
				let n = e[t];
				xr.set($i(n), n);
			}
		} else xr = null;
	}
	let t = $i(e), n = xr?.get(t);
	if (n) return {
		identifier: n,
		primaryIdentifier: n
	};
	try {
		n = It(e).resolvedOptions().timeZone;
	} catch {
		return;
	}
	if (t === "antarctica/south_pole" && (n = "Antarctica/McMurdo"), vt.has(e)) throw RangeError(`${e} is a legacy time zone identifier from ICU. Use ${n} instead`);
	let r = [...t].map(((e, n) => n === 0 || Sr[t[n - 1]] ? e.toUpperCase() : e)).join("").split("/");
	if (r.length === 1) return t === "gb-eire" ? {
		identifier: "GB-Eire",
		primaryIdentifier: n
	} : {
		identifier: t.length <= 3 || /[-0-9]/.test(t) ? t.toUpperCase() : r[0],
		primaryIdentifier: n
	};
	if (r[0] === "Etc") return {
		identifier: `Etc/${[
			"Zulu",
			"Greenwich",
			"Universal"
		].includes(r[1]) ? r[1] : r[1].toUpperCase()}`,
		primaryIdentifier: n
	};
	if (r[0] === "Us") return {
		identifier: `US/${r[1]}`,
		primaryIdentifier: n
	};
	let i = /* @__PURE__ */ new Map([
		["Act", "ACT"],
		["Lhi", "LHI"],
		["Nsw", "NSW"],
		["Dar_Es_Salaam", "Dar_es_Salaam"],
		["Port_Of_Spain", "Port_of_Spain"],
		["Port-Au-Prince", "Port-au-Prince"],
		["Isle_Of_Man", "Isle_of_Man"],
		["Comodrivadavia", "ComodRivadavia"],
		["Knox_In", "Knox_IN"],
		["Dumontdurville", "DumontDUrville"],
		["Mcmurdo", "McMurdo"],
		["Denoronha", "DeNoronha"],
		["Easterisland", "EasterIsland"],
		["Bajanorte", "BajaNorte"],
		["Bajasur", "BajaSur"]
	]);
	return r[1] = i.get(r[1]) ?? r[1], r.length > 2 && (r[2] = i.get(r[2]) ?? r[2]), {
		identifier: r.join("/"),
		primaryIdentifier: n
	};
}
function wr(e, t) {
	let { year: n, month: r, day: i, hour: a, minute: o, second: s } = Mr(e, t), c = t % 1e3;
	return c < 0 && (c += 1e3), 1e6 * (Or({
		isoDate: {
			year: n,
			month: r,
			day: i
		},
		time: {
			hour: a,
			minute: o,
			second: s,
			millisecond: c
		}
	}) - t);
}
function Tr(e, t) {
	return wr(e, Wi(t, "floor"));
}
function Er(e) {
	let t = e < 0 ? "-" : "+", n = Math.abs(e);
	return `${t}${ur(Math.floor(n / 60), n % 60, 0, 0, "minute")}`;
}
function Dr(e) {
	return Er(Pi(e, st, "halfExpand") / 6e10);
}
function Or({ isoDate: { year: e, month: t, day: n }, time: { hour: r, minute: i, second: a, millisecond: o } }) {
	let s = e % 400, c = (e - s) / 400, l = /* @__PURE__ */ new Date();
	return l.setUTCHours(r, i, a, o), l.setUTCFullYear(s, t - 1, n), l.getTime() + pt * c;
}
function Z(e) {
	let t = Or(e), n = 1e3 * e.time.microsecond + e.time.nanosecond;
	return l.default.add(Gi(t), l.default.BigInt(n));
}
function kr(e) {
	let t = Wi(e, "trunc"), n = l.default.toNumber(l.default.remainder(e, _));
	n < 0 && (n += 1e6, --t);
	let r = Math.floor(n / 1e3) % 1e3, i = n % 1e3, a = new Date(t);
	return {
		epochMilliseconds: t,
		isoDate: {
			year: a.getUTCFullYear(),
			month: a.getUTCMonth() + 1,
			day: a.getUTCDate()
		},
		time: {
			hour: a.getUTCHours(),
			minute: a.getUTCMinutes(),
			second: a.getUTCSeconds(),
			millisecond: a.getUTCMilliseconds(),
			microsecond: r,
			nanosecond: i
		}
	};
}
function Ar(e, t) {
	if (e === "UTC") return null;
	let n = Wi(t, "floor");
	if (n < gt) return Ar(e, Gi(gt));
	let r = Math.max(n, Date.now()) + 366 * at * 3, i = n, a = wr(e, i), o = i, s = a;
	for (; a === s && i < r;) {
		if (o = i + 2 * at * 7, o > ct) return null;
		s = wr(e, o), a === s && (i = o);
	}
	return a === s ? null : Gi(ra(((t) => wr(e, t)), i, o, a, s));
}
function jr(e, t) {
	if (e === "UTC") return null;
	let n = Wi(t, "ceil"), r = Date.now(), i = r + 366 * at * 3;
	if (n > i) {
		let t = jr(e, Gi(i));
		if (t === null || l.default.lessThan(t, Gi(r))) return t;
	}
	if (e === "Africa/Casablanca" || e === "Africa/El_Aaiun") {
		let t = Date.UTC(2088, 0, 1);
		if (t < n) return jr(e, Gi(t));
	}
	let a = n - 1;
	if (a < gt) return null;
	let o = wr(e, a), s = a, c = o;
	for (; o === c && a > gt;) {
		if (s = a - 2 * at * 7, s < gt) return null;
		c = wr(e, s), o === c && (a = s);
	}
	return o === c ? null : Gi(ra(((t) => wr(e, t)), s, a, c, o));
}
function Mr(e, t) {
	return function(e) {
		let t = e.split(/[^\w]+/);
		if (t.length !== 7) throw RangeError(`expected 7 parts in "${e}`);
		let n = +t[0], r = +t[1], i = +t[2], a = t[3];
		if (a[0] === "b" || a[0] === "B") i = 1 - i;
		else if (a[0] !== "a" && a[0] !== "A") throw RangeError(`Unknown era ${a} in "${e}`);
		let o = t[4] === "24" ? 0 : +t[4], s = +t[5], c = +t[6];
		if (!(Number.isFinite(i) && Number.isFinite(n) && Number.isFinite(r) && Number.isFinite(o) && Number.isFinite(s) && Number.isFinite(c))) throw RangeError(`Invalid number in "${e}`);
		return {
			year: i,
			month: n,
			day: r,
			hour: o,
			minute: s,
			second: c
		};
	}(It(e).format(t));
}
function Nr(e) {
	return e !== void 0 && !(e % 4 != 0 || e % 100 == 0 && e % 400 != 0);
}
function Pr(e, t) {
	return {
		standard: [
			31,
			28,
			31,
			30,
			31,
			30,
			31,
			31,
			30,
			31,
			30,
			31
		],
		leapyear: [
			31,
			29,
			31,
			30,
			31,
			30,
			31,
			31,
			30,
			31,
			30,
			31
		]
	}[Nr(e) ? "leapyear" : "standard"][t - 1];
}
function Fr(e) {
	let t = [
		j(e, le),
		j(e, ue),
		j(e, de),
		j(e, k),
		j(e, A),
		j(e, fe),
		j(e, pe),
		j(e, me),
		j(e, he),
		j(e, ge)
	];
	for (let e = 0; e < t.length; e++) {
		let n = t[e];
		if (n !== 0) return n < 0 ? -1 : 1;
	}
	return 0;
}
function Ir(e) {
	let t = [
		"years",
		"months",
		"weeks",
		"days"
	];
	for (let n = 0; n < t.length; n++) {
		let r = e[t[n]];
		if (r !== 0) return r < 0 ? -1 : 1;
	}
	return 0;
}
function Lr(e) {
	let t = Ir(e.date);
	return t === 0 ? e.time.sign() : t;
}
function Rr(e, t) {
	let n = e, r = t;
	if (!Number.isFinite(n) || !Number.isFinite(r)) throw RangeError("infinity is out of range");
	return --r, n += Math.floor(r / 12), r %= 12, r < 0 && (r += 12), r += 1, {
		year: n,
		month: r
	};
}
function zr(e, t, n) {
	let r = e, i = t, a = n;
	if (!Number.isFinite(a)) throw RangeError("infinity is out of range");
	({year: r, month: i} = Rr(r, i));
	let o = 146097;
	if (Math.abs(a) > o) {
		let e = Math.trunc(a / o);
		r += 400 * e, a -= e * o;
	}
	let s = 0, c = i > 2 ? r : r - 1;
	for (; s = Nr(c) ? 366 : 365, a < -s;) --r, --c, a += s;
	for (c += 1; s = Nr(c) ? 366 : 365, a > s;) r += 1, c += 1, a -= s;
	for (; a < 1;) ({year: r, month: i} = Rr(r, i - 1)), a += Pr(r, i);
	for (; a > Pr(r, i);) a -= Pr(r, i), {year: r, month: i} = Rr(r, i + 1);
	return {
		year: r,
		month: i,
		day: a
	};
}
function Br(e, t, n, r, i, a, o, s, c) {
	let l = Vr(r, i, a, o, s, c);
	return q(zr(e, t, n + l.deltaDays), l);
}
function Vr(e, t, n, r, i, a) {
	let o, s = e, c = t, l = n, u = r, d = i, f = a;
	({div: o, mod: f} = Re(f, 3)), d += o, f < 0 && (--d, f += 1e3), {div: o, mod: d} = Re(d, 3), u += o, d < 0 && (--u, d += 1e3), l += Math.trunc(u / 1e3), u %= 1e3, u < 0 && (--l, u += 1e3), c += Math.trunc(l / 60), l %= 60, l < 0 && (--c, l += 60), s += Math.trunc(c / 60), c %= 60, c < 0 && (--s, c += 60);
	let p = Math.trunc(s / 24);
	return s %= 24, s < 0 && (--p, s += 24), p += 0, s += 0, c += 0, l += 0, u += 0, d += 0, f += 0, {
		deltaDays: p,
		hour: s,
		minute: c,
		second: l,
		millisecond: u,
		microsecond: d,
		nanosecond: f
	};
}
function Hr(e, t) {
	let n = K(e, 0);
	if (Ir(n) === 0) return e.days;
	let r = j(t, w), i = Gn(j(t, D), r, n, "constrain"), a = oi(r.year, r.month - 1, r.day), o = oi(i.year, i.month - 1, i.day) - a;
	return e.days + o;
}
function Ur(e) {
	return new (N("%Temporal.Duration%"))(-j(e, le), -j(e, ue), -j(e, de), -j(e, k), -j(e, A), -j(e, fe), -j(e, pe), -j(e, me), -j(e, he), -j(e, ge));
}
function Wr(e, t, n) {
	return Math.min(n, Math.max(t, e));
}
function Gr(e, t, n) {
	let r = Wr(t, 1, 12);
	return {
		year: e,
		month: r,
		day: Wr(n, 1, Pr(e, r))
	};
}
function Q(e, t, n) {
	if (e < t || e > n) throw RangeError(`value out of range: ${t} <= ${e} <= ${n}`);
}
function Kr(e, t, n) {
	Q(t, 1, 12), Q(n, 1, Pr(e, t));
}
function qr(e) {
	Xr(q(e, {
		deltaDays: 0,
		hour: 12,
		minute: 0,
		second: 0,
		millisecond: 0,
		microsecond: 0,
		nanosecond: 0
	}));
}
function Jr(e, t, n, r, i, a) {
	Q(e, 0, 23), Q(t, 0, 59), Q(n, 0, 59), Q(r, 0, 999), Q(i, 0, 999), Q(a, 0, 999);
}
function Yr(e, t, n, r, i, a, o, s, c) {
	Kr(e, t, n), Jr(r, i, a, o, s, c);
}
function Xr(e) {
	let t = Z(e);
	(l.default.lessThan(t, dt) || l.default.greaterThan(t, ft)) && Qr(t);
}
function Zr(e) {
	Z(e);
}
function Qr(e) {
	if (l.default.lessThan(e, ut) || l.default.greaterThan(e, lt)) throw RangeError("date/time value is outside of supported range");
}
function $r({ year: e, month: t }) {
	Q(e, mt, ht), e === mt ? Q(t, 4, 12) : e === ht && Q(t, 1, 9);
}
function ei(e, t, n, r, i, a, o, s, c, l) {
	let u = 0, d = [
		e,
		t,
		n,
		r,
		i,
		a,
		o,
		s,
		c,
		l
	];
	for (let e = 0; e < d.length; e++) {
		let t = d[e];
		if (t === 1 / 0 || t === -1 / 0) throw RangeError("infinite values not allowed as duration fields");
		if (t !== 0) {
			let e = t < 0 ? -1 : 1;
			if (u !== 0 && e !== u) throw RangeError("mixed-sign values not allowed as duration fields");
			u = e;
		}
	}
	if (Math.abs(e) >= 2 ** 32 || Math.abs(t) >= 2 ** 32 || Math.abs(n) >= 2 ** 32) throw RangeError("years, months, and weeks must be < 2³²");
	let f = Re(s, 3), p = Re(c, 6), m = Re(l, 9), h = Re(1e6 * f.mod + 1e3 * p.mod + m.mod, 9).div, g = 86400 * r + 3600 * i + 60 * a + o + f.div + p.div + m.div + h;
	if (!Number.isSafeInteger(g)) throw RangeError("total of duration time units cannot exceed 9007199254740991.999999999 s");
}
function ti(e) {
	return {
		date: {
			years: j(e, le),
			months: j(e, ue),
			weeks: j(e, de),
			days: j(e, k)
		},
		time: P.fromComponents(j(e, A), j(e, fe), j(e, pe), j(e, me), j(e, he), j(e, ge))
	};
}
function ni(e) {
	let t = P.fromComponents(j(e, A), j(e, fe), j(e, pe), j(e, me), j(e, he), j(e, ge)).add24HourDays(j(e, k));
	return {
		date: {
			years: j(e, le),
			months: j(e, ue),
			weeks: j(e, de),
			days: 0
		},
		time: t
	};
}
function ri(e) {
	let t = ni(e), n = Math.trunc(t.time.sec / 86400);
	return ei(t.date.years, t.date.months, t.date.weeks, n, 0, 0, 0, 0, 0, 0), {
		...t.date,
		days: n
	};
}
function ii(e, t) {
	let n = e.time.sign(), r = e.time.abs().subsec, i = 0, a = 0, o = e.time.abs().sec, s = 0, c = 0, l = 0;
	switch (t) {
		case "year":
		case "month":
		case "week":
		case "day":
			i = Math.trunc(r / 1e3), r %= 1e3, a = Math.trunc(i / 1e3), i %= 1e3, o += Math.trunc(a / 1e3), a %= 1e3, s = Math.trunc(o / 60), o %= 60, c = Math.trunc(s / 60), s %= 60, l = Math.trunc(c / 24), c %= 24;
			break;
		case "hour":
			i = Math.trunc(r / 1e3), r %= 1e3, a = Math.trunc(i / 1e3), i %= 1e3, o += Math.trunc(a / 1e3), a %= 1e3, s = Math.trunc(o / 60), o %= 60, c = Math.trunc(s / 60), s %= 60;
			break;
		case "minute":
			i = Math.trunc(r / 1e3), r %= 1e3, a = Math.trunc(i / 1e3), i %= 1e3, o += Math.trunc(a / 1e3), a %= 1e3, s = Math.trunc(o / 60), o %= 60;
			break;
		case "second":
			i = Math.trunc(r / 1e3), r %= 1e3, a = Math.trunc(i / 1e3), i %= 1e3, o += Math.trunc(a / 1e3), a %= 1e3;
			break;
		case "millisecond":
			i = Math.trunc(r / 1e3), r %= 1e3, a = ze(o, 3, Math.trunc(i / 1e3)), i %= 1e3, o = 0;
			break;
		case "microsecond":
			i = ze(o, 6, Math.trunc(r / 1e3)), r %= 1e3, o = 0;
			break;
		case "nanosecond": r = ze(o, 9, r), o = 0;
	}
	return new (N("%Temporal.Duration%"))(e.date.years, e.date.months, e.date.weeks, e.date.days + n * l, n * c, n * s, n * o, n * a, n * i, n * r);
}
function ai(e, t) {
	return Ir(e), t.sign(), {
		date: e,
		time: t
	};
}
function oi(e, t, n) {
	return Or({
		isoDate: {
			year: e,
			month: t + 1,
			day: n
		},
		time: {
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0
		}
	}) / at;
}
function si({ year: e, month: t, day: n }) {
	if (Math.abs(oi(e, t - 1, n)) > 1e8) throw RangeError("date/time value is outside the supported range");
}
function ci(e, t) {
	let n = t.hour - e.hour, r = t.minute - e.minute, i = t.second - e.second, a = t.millisecond - e.millisecond, o = t.microsecond - e.microsecond, s = t.nanosecond - e.nanosecond;
	return P.fromComponents(n, r, i, a, o, s);
}
function li(e, t, n, r, i) {
	let a = P.fromEpochNsDiff(t, e);
	return a = Ri(a, n, r, i), ai({
		years: 0,
		months: 0,
		weeks: 0,
		days: 0
	}, a);
}
function ui(e, t, n, r) {
	Zr(e), Zr(t);
	let i = ci(e.time, t.time), a = i.sign(), o = Bi(e.isoDate, t.isoDate), s = t.isoDate;
	o === a && (s = zr(s.year, s.month, s.day + a), i = i.add24HourDays(-a));
	let c = dn("day", r), l = Kn(n, e.isoDate, s, c);
	return r !== c && (i = i.add24HourDays(l.days), l.days = 0), ai(l, i);
}
function di(e, t, n, r, i) {
	let a = l.default.subtract(t, e);
	if (l.default.equal(a, u)) return {
		date: {
			years: 0,
			months: 0,
			weeks: 0,
			days: 0
		},
		time: P.ZERO
	};
	let o = l.default.lessThan(a, u) ? -1 : 1, s = rr(n, e), c = rr(n, t), d, f = 0, p = o === 1 ? 2 : 1, m = ci(s.time, c.time);
	for (m.sign() === -o && f++; f <= p; f++) {
		d = q(zr(c.isoDate.year, c.isoDate.month, c.isoDate.day - f * o), s.time);
		let e = X(n, d, "compatible");
		if (m = P.fromEpochNsDiff(t, e), m.sign() !== -o) break;
	}
	let h = dn("day", i);
	return ai(Kn(r, s.isoDate, d.isoDate, h), m);
}
function fi(e, t, n, r, i, a, o, s, c) {
	let u, d, f, p, m = t;
	switch (s) {
		case "year": {
			let t = Pi(m.date.years, o, "trunc");
			u = t, d = t + o * e, f = {
				years: u,
				months: 0,
				weeks: 0,
				days: 0
			}, p = {
				...f,
				years: d
			};
			break;
		}
		case "month": {
			let t = Pi(m.date.months, o, "trunc");
			u = t, d = t + o * e, f = K(m.date, 0, 0, u), p = K(m.date, 0, 0, d);
			break;
		}
		case "week": {
			let t = K(m.date, 0, 0), n = Gn(a, r.isoDate, t, "constrain"), i = Kn(a, n, zr(n.year, n.month, n.day + m.date.days), "week"), s = Pi(m.date.weeks + i.weeks, o, "trunc");
			u = s, d = s + o * e, f = K(m.date, 0, u), p = K(m.date, 0, d);
			break;
		}
		case "day": {
			let t = Pi(m.date.days, o, "trunc");
			u = t, d = t + o * e, f = K(m.date, u), p = K(m.date, d);
			break;
		}
	}
	let h = Gn(a, r.isoDate, f, "constrain"), g = Gn(a, r.isoDate, p, "constrain"), _, v, y = q(h, r.time), ee = q(g, r.time);
	i ? (_ = X(i, y, "compatible"), v = X(i, ee, "compatible")) : (_ = Z(y), v = Z(ee));
	let b = P.fromEpochNsDiff(n, _), x = P.fromEpochNsDiff(v, _), te = Be(c, e < 0 ? "negative" : "positive"), ne = b.add(b).abs().subtract(x.abs()).sign(), S = Math.abs(u) / o % 2 == 0, re = b.isZero() ? Math.abs(u) : b.cmp(x) ? Ve(Math.abs(u), Math.abs(d), ne, S, te) : Math.abs(d), ie = new P(l.default.add(l.default.multiply(x.totalNs, l.default.BigInt(u)), l.default.multiply(b.totalNs, l.default.BigInt(o * e)))).fdiv(x.totalNs), ae = re === Math.abs(d);
	return m = {
		date: ae ? p : f,
		time: P.ZERO
	}, {
		nudgeResult: {
			duration: m,
			nudgedEpochNs: ae ? v : _,
			didExpandCalendarUnit: ae
		},
		total: ie
	};
}
function pi(e, t, n, r, i, a, o, s, c) {
	let u = e, d = fn(s) || r && s === "day", f = Lr(u) < 0 ? -1 : 1, p;
	return d ? {nudgeResult: p} = fi(f, u, t, n, r, i, o, s, c) : p = r ? function(e, t, n, r, i, a, o, s) {
		let c = t, u = Gn(i, n.isoDate, c.date, "constrain"), d = q(u, n.time), f = q(zr(u.year, u.month, u.day + e), n.time), p = X(r, d, "compatible"), m = X(r, f, "compatible"), h = P.fromEpochNsDiff(m, p);
		if (h.sign() !== e) throw RangeError("time zone returned inconsistent Instants");
		let g = l.default.BigInt(Mt[o] * a), _ = c.time.round(g, s), v = _.subtract(h), y = v.sign() !== -e, ee, b;
		return y ? (ee = e, _ = v.round(g, s), b = _.addToEpochNs(m)) : (ee = 0, b = _.addToEpochNs(p)), {
			duration: ai(K(c.date, c.date.days + ee), _),
			nudgedEpochNs: b,
			didExpandCalendarUnit: y
		};
	}(f, u, n, r, i, o, s, c) : function(e, t, n, r, i, a) {
		let o = e, s = o.time.add24HourDays(o.date.days), c = s.round(l.default.BigInt(r * Mt[i]), a), u = c.subtract(s), { quotient: d } = s.divmod(ot), { quotient: f } = c.divmod(ot), p = Math.sign(f - d) === s.sign(), m = u.addToEpochNs(t), h = 0, g = c;
		return pn(n) === "date" && (h = f, g = c.add(P.fromComponents(24 * -f, 0, 0, 0, 0, 0))), {
			duration: {
				date: K(o.date, h),
				time: g
			},
			nudgedEpochNs: m,
			didExpandCalendarUnit: p
		};
	}(u, t, a, o, s, c), u = p.duration, p.didExpandCalendarUnit && s !== "week" && (u = function(e, t, n, r, i, a, o, s) {
		let c = t;
		if (s === o) return c;
		let l = jt.indexOf(o);
		for (let t = jt.indexOf(s) - 1; t >= l; t--) {
			let s = jt[t];
			if (s === "week" && o !== "week") continue;
			let l;
			switch (s) {
				case "year":
					l = {
						years: c.date.years + e,
						months: 0,
						weeks: 0,
						days: 0
					};
					break;
				case "month": {
					let t = c.date.months + e;
					l = K(c.date, 0, 0, t);
					break;
				}
				case "week": {
					let t = c.date.weeks + e;
					l = K(c.date, 0, t);
					break;
				}
			}
			let u = q(Gn(a, r.isoDate, l, "constrain"), r.time), d;
			if (d = i ? X(i, u, "compatible") : Z(u), S(n, d) === -e) break;
			c = {
				date: l,
				time: P.ZERO
			};
		}
		return c;
	}(f, u, p.nudgedEpochNs, n, r, i, a, dn(s, "day"))), u;
}
function mi(e, t, n, r, i, a) {
	return fn(a) || r && a === "day" ? fi(Lr(e) < 0 ? -1 : 1, e, t, n, r, i, 1, a, "trunc").total : zi(e.time.add24HourDays(e.date.days), a);
}
function hi(e, t, n, r, i, a, o) {
	if (Hi(e, t) == 0) return {
		date: {
			years: 0,
			months: 0,
			weeks: 0,
			days: 0
		},
		time: P.ZERO
	};
	Xr(e), Xr(t);
	let s = ui(e, t, n, r);
	return a === "nanosecond" && i === 1 ? s : pi(s, Z(t), e, null, n, r, i, a, o);
}
function gi(e, t, n, r, i, a, o, s) {
	if (pn(i) === "time") return li(e, t, a, o, s);
	let c = di(e, t, n, r, i);
	return o === "nanosecond" && a === 1 ? c : pi(c, t, rr(n, e), n, r, i, a, o, s);
}
function _i(e, t, n, r, i, a) {
	let o = Ot.reduce(((e, t) => {
		let i = t[0], a = t[1], o = t[2];
		return n !== "datetime" && o !== n || r.includes(a) || e.push(a, i), e;
	}), []), s = cn(t, "largestUnit", n, "auto");
	if (r.includes(s)) throw RangeError(`largestUnit must be one of ${o.join(", ")}, not ${s}`);
	let c = nn(t), l = $t(t, "trunc");
	e === "since" && (l = function(e) {
		switch (e) {
			case "ceil": return "floor";
			case "floor": return "ceil";
			case "halfCeil": return "halfFloor";
			case "halfFloor": return "halfCeil";
			default: return e;
		}
	}(l));
	let u = cn(t, "smallestUnit", n, i);
	if (r.includes(u)) throw RangeError(`smallestUnit must be one of ${o.join(", ")}, not ${u}`);
	let d = dn(a, u);
	if (s === "auto" && (s = d), dn(s, u) !== s) throw RangeError(`largestUnit ${s} cannot be smaller than smallestUnit ${u}`);
	let f = {
		hour: 24,
		minute: 60,
		second: 60,
		millisecond: 1e3,
		microsecond: 1e3,
		nanosecond: 1e3
	}[u];
	return f !== void 0 && rn(c, f, !1), {
		largestUnit: s,
		roundingIncrement: c,
		roundingMode: l,
		smallestUnit: u
	};
}
function vi(e, t, n, r) {
	let i = Cn(n), a = _i(e, $(r), "time", [], "nanosecond", "second"), o = ii(li(j(t, C), j(i, C), a.roundingIncrement, a.smallestUnit, a.roundingMode), a.largestUnit);
	return e === "since" && (o = Ur(o)), o;
}
function yi(e, t, n, r) {
	let i = yn(n), a = j(t, D), o = j(i, D);
	if (!Yn(a, o)) throw RangeError(`cannot compute difference between dates of ${a} and ${o} calendars`);
	let s = _i(e, $(r), "date", [], "day", "day"), c = N("%Temporal.Duration%"), l = j(t, w), u = j(i, w);
	if (Bi(l, u) === 0) return new c();
	let d = {
		date: Kn(a, l, u, s.largestUnit),
		time: P.ZERO
	};
	if (s.smallestUnit !== "day" || s.roundingIncrement !== 1) {
		let e = q(l, {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		});
		d = pi(d, Z(q(u, {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		})), e, null, a, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode);
	}
	let f = ii(d, "day");
	return e === "since" && (f = Ur(f)), f;
}
function bi(e, t, n, r) {
	let i = xn(n), a = j(t, D), o = j(i, D);
	if (!Yn(a, o)) throw RangeError(`cannot compute difference between dates of ${a} and ${o} calendars`);
	let s = _i(e, $(r), "datetime", [], "nanosecond", "day"), c = N("%Temporal.Duration%"), l = j(t, T), u = j(i, T);
	if (Hi(l, u) === 0) return new c();
	let d = ii(hi(l, u, a, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode), s.largestUnit);
	return e === "since" && (d = Ur(d)), d;
}
function xi(e, t, n, r) {
	let i = Tn(n), a = _i(e, $(r), "time", [], "nanosecond", "hour"), o = ci(j(t, E), j(i, E));
	o = Ri(o, a.roundingIncrement, a.smallestUnit, a.roundingMode);
	let s = ii(ai({
		years: 0,
		months: 0,
		weeks: 0,
		days: 0
	}, o), a.largestUnit);
	return e === "since" && (s = Ur(s)), s;
}
function Si(e, t, n, r) {
	let i = Dn(n), a = j(t, D), o = j(i, D);
	if (!Yn(a, o)) throw RangeError(`cannot compute difference between months of ${a} and ${o} calendars`);
	let s = _i(e, $(r), "date", ["week", "day"], "month", "year"), c = N("%Temporal.Duration%");
	if (Bi(j(t, w), j(i, w)) == 0) return new c();
	let l = gn(a, j(t, w), "year-month");
	l.day = 1;
	let u = Xn(a, l, "constrain"), d = gn(a, j(i, w), "year-month");
	d.day = 1;
	let f = Xn(a, d, "constrain"), p = {
		date: K(Kn(a, u, f, s.largestUnit), 0, 0),
		time: P.ZERO
	};
	if (s.smallestUnit !== "month" || s.roundingIncrement !== 1) {
		let e = q(u, {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		});
		p = pi(p, Z(q(f, {
			deltaDays: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		})), e, null, a, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode);
	}
	let m = ii(p, "day");
	return e === "since" && (m = Ur(m)), m;
}
function Ci(e, t, n, r) {
	let i = kn(n), a = j(t, D), o = j(i, D);
	if (!Yn(a, o)) throw RangeError(`cannot compute difference between dates of ${a} and ${o} calendars`);
	let s = _i(e, $(r), "datetime", [], "nanosecond", "hour"), c = j(t, C), u = j(i, C), d = N("%Temporal.Duration%"), f;
	if (pn(s.largestUnit) !== "date") f = ii(li(c, u, s.roundingIncrement, s.smallestUnit, s.roundingMode), s.largestUnit);
	else {
		let e = j(t, O);
		if (!er(e, j(i, O))) throw RangeError("When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes.");
		if (l.default.equal(c, u)) return new d();
		f = ii(gi(c, u, e, a, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode), "hour");
	}
	return e === "since" && (f = Ur(f)), f;
}
function wi({ hour: e, minute: t, second: n, millisecond: r, microsecond: i, nanosecond: a }, o) {
	let s = n, c = a;
	return s += o.sec, c += o.subsec, Vr(e, t, s, r, i, c);
}
function Ti(e, t) {
	let n = t.addToEpochNs(e);
	return Qr(n), n;
}
function Ei(e, t, n, r, i = "constrain") {
	if (Ir(r.date) === 0) return Ti(e, r.time);
	let a = rr(t, e);
	return Ti(X(t, q(Gn(n, a.isoDate, r.date, i), a.time), "compatible"), r.time);
}
function Di(e, t, n) {
	let r = Sn(n);
	e === "subtract" && (r = Ur(r));
	let i = dn(un(t), un(r));
	if (fn(i)) throw RangeError("For years, months, or weeks arithmetic, use date arithmetic relative to a starting point");
	let a = ni(t), o = ni(r);
	return ii(ai({
		years: 0,
		months: 0,
		weeks: 0,
		days: 0
	}, a.time.add(o.time)), i);
}
function Oi(e, t, n) {
	let r = Sn(n);
	e === "subtract" && (r = Ur(r));
	let i = un(r);
	if (pn(i) === "date") throw RangeError(`Duration field ${i} not supported by Temporal.Instant. Try Temporal.ZonedDateTime instead.`);
	let a = ni(r);
	return Vn(Ti(j(t, C), a.time));
}
function ki(e, t, n, r) {
	let i = j(t, D), a = Sn(n);
	e === "subtract" && (a = Ur(a));
	let o = ri(a), s = J($(r));
	return jn(Gn(i, j(t, w), o, s), i);
}
function Ai(e, t, n, r) {
	let i = Sn(n);
	e === "subtract" && (i = Ur(i));
	let a = J($(r)), o = j(t, D), s = ni(i), c = j(t, T), l = wi(c.time, s.time), u = K(s.date, l.deltaDays);
	return ei(u.years, u.months, u.weeks, u.days, 0, 0, 0, 0, 0, 0), Nn(q(Gn(o, c.isoDate, u, a), l), o);
}
function ji(e, t, n) {
	let r = Sn(n);
	e === "subtract" && (r = Ur(r));
	let i = ni(r), { hour: a, minute: o, second: s, millisecond: c, microsecond: l, nanosecond: u } = wi(j(t, E), i.time);
	return Ln(Xt(a, o, s, c, l, u, "reject"));
}
function Mi(e, t, n, r) {
	let i = Sn(n);
	e === "subtract" && (i = Ur(i));
	let a = J($(r)), o = Fr(i), s = j(t, D), c = gn(s, j(t, w), "year-month");
	c.day = 1;
	let l = Xn(s, c, "constrain");
	if (o < 0) {
		let e = Gn(s, l, { months: 1 }, "constrain");
		l = zr(e.year, e.month, e.day - 1);
	}
	let u = ri(i);
	return qr(l), zn(Zn(s, gn(s, Gn(s, l, u, a), "year-month"), a), s);
}
function Ni(e, t, n, r) {
	let i = Sn(n);
	e === "subtract" && (i = Ur(i));
	let a = J($(r)), o = j(t, O), s = j(t, D), c = ti(i);
	return Y(Ei(j(t, C), o, s, c, a), o, s);
}
function Pi(e, t, n) {
	let r = Math.trunc(e / t), i = e % t, a = e < 0 ? "negative" : "positive", o = Math.abs(r), s = o + 1, c = Yi(Math.abs(2 * i) - t), l = o % 2 == 0, u = Be(n, a), d = i === 0 ? o : Ve(o, s, c, l, u);
	return t * (a === "positive" ? d : -d);
}
function Fi(e, t, n, r) {
	let i = Mt[n] * t;
	return function(e, t, n) {
		let r = x(e), i = x(t), a = l.default.divide(r, i), o = l.default.remainder(r, i), s = Be(n, "positive"), c, p;
		l.default.lessThan(r, u) ? (c = l.default.subtract(a, d), p = a) : (c = a, p = l.default.add(a, d));
		let m = S(ne(l.default.multiply(o, f)), i) * (l.default.lessThan(r, u) ? -1 : 1) + 0, h = l.default.equal(o, u) ? a : Ve(c, p, m, te(c), s);
		return l.default.multiply(h, i);
	}(e, l.default.BigInt(i), r);
}
function Ii(e, t, n, r) {
	Zr(e);
	let { year: i, month: a, day: o } = e.isoDate, s = Li(e.time, t, n, r);
	return q(zr(i, a, o + s.deltaDays), s);
}
function Li({ hour: e, minute: t, second: n, millisecond: r, microsecond: i, nanosecond: a }, o, s, c) {
	let l;
	switch (s) {
		case "day":
		case "hour":
			l = 1e3 * (1e3 * (1e3 * (60 * (60 * e + t) + n) + r) + i) + a;
			break;
		case "minute":
			l = 1e3 * (1e3 * (1e3 * (60 * t + n) + r) + i) + a;
			break;
		case "second":
			l = 1e3 * (1e3 * (1e3 * n + r) + i) + a;
			break;
		case "millisecond":
			l = 1e3 * (1e3 * r + i) + a;
			break;
		case "microsecond":
			l = 1e3 * i + a;
			break;
		case "nanosecond": l = a;
	}
	let u = Mt[s], d = Pi(l, u * o, c) / u;
	switch (s) {
		case "day": return {
			deltaDays: d,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		};
		case "hour": return Vr(d, 0, 0, 0, 0, 0);
		case "minute": return Vr(e, d, 0, 0, 0, 0);
		case "second": return Vr(e, t, d, 0, 0, 0);
		case "millisecond": return Vr(e, t, n, d, 0, 0);
		case "microsecond": return Vr(e, t, n, r, d, 0);
		case "nanosecond": return Vr(e, t, n, r, i, d);
		default: throw Error(`Invalid unit ${s}`);
	}
}
function Ri(e, t, n, r) {
	let i = Mt[n];
	return e.round(l.default.BigInt(i * t), r);
}
function zi(e, t) {
	let n = Mt[t];
	return e.fdiv(l.default.BigInt(n));
}
function Bi(e, t) {
	return e.year === t.year ? e.month === t.month ? e.day === t.day ? 0 : Yi(e.day - t.day) : Yi(e.month - t.month) : Yi(e.year - t.year);
}
function Vi(e, t) {
	return e.hour === t.hour ? e.minute === t.minute ? e.second === t.second ? e.millisecond === t.millisecond ? e.microsecond === t.microsecond ? e.nanosecond === t.nanosecond ? 0 : Yi(e.nanosecond - t.nanosecond) : Yi(e.microsecond - t.microsecond) : Yi(e.millisecond - t.millisecond) : Yi(e.second - t.second) : Yi(e.minute - t.minute) : Yi(e.hour - t.hour);
}
function Hi(e, t) {
	let n = Bi(e.isoDate, t.isoDate);
	return n === 0 ? Vi(e.time, t.time) : n;
}
function Ui(e) {
	let t = Ki(e);
	return globalThis.BigInt === void 0 ? t : globalThis.BigInt(t.toString(10));
}
function Wi(e, t) {
	let { quotient: n, remainder: r } = re(x(e), _), i = l.default.toNumber(n);
	return t === "floor" && l.default.toNumber(r) < 0 && --i, t === "ceil" && l.default.toNumber(r) > 0 && (i += 1), i;
}
function Gi(e) {
	if (!Number.isInteger(e)) throw RangeError("epoch milliseconds must be an integer");
	return l.default.multiply(l.default.BigInt(e), _);
}
function Ki(e) {
	let t = e;
	if (typeof e == "object") {
		let n = e[Symbol.toPrimitive];
		n && typeof n == "function" && (t = n.call(e, "number"));
	}
	if (typeof t == "number") throw TypeError("cannot convert number to bigint");
	return typeof t == "bigint" ? l.default.BigInt(t.toString(10)) : l.default.BigInt(t);
}
var qi = (() => {
	let e = l.default.BigInt(Date.now() % 1e6);
	return () => {
		let t = Date.now(), n = l.default.BigInt(t), r = l.default.add(Gi(t), e);
		return e = l.default.remainder(n, _), l.default.greaterThan(r, lt) ? lt : l.default.lessThan(r, ut) ? ut : r;
	};
})();
function Ji() {
	return new Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function Yi(e) {
	return e < 0 ? -1 : e > 0 ? 1 : e;
}
function $(e) {
	if (e === void 0) return Object.create(null);
	if (F(e) && e !== null) return e;
	throw TypeError("Options parameter must be an object, not " + (e === null ? "null" : typeof e));
}
function Xi(e, t) {
	let n = Object.create(null);
	return n[e] = t, n;
}
function Zi(e, t, n, r) {
	let i = e[t];
	if (i !== void 0) {
		if (i = bt(i), !n.includes(i)) throw RangeError(`${t} must be one of ${n.join(", ")}, not ${i}`);
		return i;
	}
	if (r === sn) throw RangeError(`${t} option is required`);
	return r;
}
function Qi(e) {
	let t = $i(e);
	if (!_t.includes($i(t))) throw RangeError(`invalid calendar identifier ${t}`);
	switch (t) {
		case "ethiopic-amete-alem": return "ethioaa";
		case "islamicc": return "islamic-civil";
	}
	return t;
}
function $i(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) {
		let r = e.charCodeAt(n);
		t += r >= 65 && r <= 90 ? String.fromCharCode(r + 32) : String.fromCharCode(r);
	}
	return t;
}
function ea(e) {
	throw TypeError(`Do not use built-in arithmetic operators with Temporal objects. When comparing, use ${e === "PlainMonthDay" ? "Temporal.PlainDate.compare(obj1.toPlainDate(year), obj2.toPlainDate(year))" : `Temporal.${e}.compare(obj1, obj2)`}, not obj1 > obj2. When coercing to strings, use \`\${obj}\` or String(obj), not '' + obj. When coercing to numbers, use properties or methods of the object, not \`+obj\`. When concatenating with strings, use \`\${str}\${obj}\` or str.concat(obj), not str + obj. In React, coerce to a string before rendering a Temporal object.`);
}
var ta = RegExp(`^${Ye.source}$`), na = /* @__PURE__ */ RegExp("^([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])(?::?([0-5][0-9])(?:[.,](\\d{1,9}))?)?)?$");
function ra(e, t, n, r = e(t), i = e(n)) {
	let a = t, o = n, s = r, c = i;
	for (; o - a > 1;) {
		let t = Math.trunc((a + o) / 2), n = e(t);
		n === s ? (a = t, s = n) : n === c && (o = t, c = n);
	}
	return o;
}
function ia(e) {
	return [...e];
}
function aa(e, t) {
	if (e !== "gregory" && e !== "iso8601") return;
	let n = sa[e], r = t.year, { dayOfWeek: i, dayOfYear: a, daysInYear: o } = n.isoToDate(t, {
		dayOfWeek: !0,
		dayOfYear: !0,
		daysInYear: !0
	}), s = n.getFirstDayOfWeek(), c = n.getMinimalDaysInFirstWeek(), l = (i + 7 - s) % 7, u = (i - a + 7001 - s) % 7, d = Math.floor((a - 1 + u) / 7);
	if (7 - u >= c && ++d, d == 0) d = function(e, t, n, r) {
		let i = (r - e - n + 1) % 7;
		i < 0 && (i += 7);
		let a = Math.floor((n + i - 1) / 7);
		return 7 - i >= t && ++a, a;
	}(s, c, a + n.isoToDate(n.dateAdd(t, { years: -1 }, "constrain"), { daysInYear: !0 }).daysInYear, i), r--;
	else if (a >= o - 5) {
		let e = (l + o - a) % 7;
		e < 0 && (e += 7), 6 - e >= c && a + 7 - l > o && (d = 1, r++);
	}
	return {
		week: d,
		year: r
	};
}
function oa(e, t, n, r, i) {
	if (t !== i.year) {
		if (e * (t - i.year) > 0) return !0;
	} else if (n !== i.month) {
		if (e * (n - i.month) > 0) return !0;
	} else if (r !== i.day && e * (r - i.day) > 0) return !0;
	return !1;
}
var sa = {};
function ca(e) {
	if (!e.startsWith("M")) throw RangeError(`Invalid month code: ${e}.  Month codes must start with M.`);
	let t = +e.slice(1);
	if (Number.isNaN(t)) throw RangeError(`Invalid month code: ${e}`);
	return t;
}
function la(e, t = !1) {
	return `M${`${e}`.padStart(2, "0")}${t ? "L" : ""}`;
}
function ua(e, t = void 0, n = 12) {
	let { month: r, monthCode: i } = e;
	if (i === void 0) {
		if (r === void 0) throw TypeError("Either month or monthCode are required");
		t === "reject" && Q(r, 1, n), t === "constrain" && (r = Wr(r, 1, n)), i = la(r);
	} else {
		let e = ca(i);
		if (i !== la(e)) throw RangeError(`Invalid month code: ${i}`);
		if (r !== void 0 && r !== e) throw RangeError(`monthCode ${i} and month ${r} must match if both are present`);
		if (r = e, r < 1 || r > n) throw RangeError(`Invalid monthCode: ${i}`);
	}
	return {
		...e,
		month: r,
		monthCode: i
	};
}
sa.iso8601 = {
	resolveFields(e, t) {
		if ((t === "date" || t === "year-month") && e.year === void 0) throw TypeError("year is required");
		if ((t === "date" || t === "month-day") && e.day === void 0) throw TypeError("day is required");
		Object.assign(e, ua(e));
	},
	dateToISO: (e, t) => Yt(e.year, e.month, e.day, t),
	monthDayToISOReferenceDate(e, t) {
		let { month: n, day: r } = Yt(e.year ?? 1972, e.month, e.day, t);
		return {
			month: n,
			day: r,
			year: 1972
		};
	},
	extraFields: () => [],
	fieldKeysToIgnore(e) {
		let t = /* @__PURE__ */ new Set();
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			t.add(r), r === "month" ? t.add("monthCode") : r === "monthCode" && t.add("month");
		}
		return ia(t);
	},
	dateAdd(e, { years: t = 0, months: n = 0, weeks: r = 0, days: i = 0 }, a) {
		let { year: o, month: s, day: c } = e;
		return o += t, s += n, {year: o, month: s} = Rr(o, s), {year: o, month: s, day: c} = Yt(o, s, c, a), c += i + 7 * r, zr(o, s, c);
	},
	dateUntil(e, t, n) {
		let r = -Bi(e, t);
		if (r === 0) return {
			years: 0,
			months: 0,
			weeks: 0,
			days: 0
		};
		let i, a = 0, o = 0;
		if (n === "year" || n === "month") {
			let s = t.year - e.year;
			for (s !== 0 && (s -= r); !oa(r, e.year + s, e.month, e.day, t);) a = s, s += r;
			let c = r;
			for (i = Rr(e.year + a, e.month + c); !oa(r, i.year, i.month, e.day, t);) o = c, c += r, i = Rr(i.year, i.month + r);
			n === "month" && (o += 12 * a, a = 0);
		}
		i = Rr(e.year + a, e.month + o);
		let s = Gr(i.year, i.month, e.day), c = 0, l = oi(t.year, t.month - 1, t.day) - oi(s.year, s.month - 1, s.day);
		return n === "week" && (c = Math.trunc(l / 7), l %= 7), {
			years: a,
			months: o,
			weeks: c,
			days: l
		};
	},
	isoToDate({ year: e, month: t, day: n }, r) {
		let i = {
			era: void 0,
			eraYear: void 0,
			year: e,
			month: t,
			day: n,
			daysInWeek: 7,
			monthsInYear: 12
		};
		if (r.monthCode && (i.monthCode = la(t)), r.dayOfWeek) {
			let r = t + (t < 3 ? 10 : -2), a = e - +(t < 3), o = Math.floor(a / 100), s = a - 100 * o, c = (n + Math.floor(2.6 * r - .2) + (s + Math.floor(s / 4)) + (Math.floor(o / 4) - 2 * o)) % 7;
			i.dayOfWeek = c + (c <= 0 ? 7 : 0);
		}
		if (r.dayOfYear) {
			let r = n;
			for (let n = t - 1; n > 0; n--) r += Pr(e, n);
			i.dayOfYear = r;
		}
		return r.weekOfYear && (i.weekOfYear = aa("iso8601", {
			year: e,
			month: t,
			day: n
		})), r.daysInMonth && (i.daysInMonth = Pr(e, t)), (r.daysInYear || r.inLeapYear) && (i.inLeapYear = Nr(e), i.daysInYear = i.inLeapYear ? 366 : 365), i;
	},
	getFirstDayOfWeek: () => 1,
	getMinimalDaysInFirstWeek: () => 4
};
var da = class e {
	constructor(t) {
		if (this.map = /* @__PURE__ */ new Map(), this.calls = 0, this.hits = 0, this.misses = 0, t !== void 0) {
			let n = 0;
			for (let r of t.map.entries()) {
				if (++n > e.MAX_CACHE_ENTRIES) break;
				this.map.set(...r);
			}
		}
	}
	get(e) {
		let t = this.map.get(e);
		return t && (this.hits++, this.report()), this.calls++, t;
	}
	set(e, t) {
		this.map.set(e, t), this.misses++, this.report();
	}
	report() {}
	setObject(t) {
		if (e.objectMap.get(t)) throw RangeError("object already cached");
		e.objectMap.set(t, this), this.report();
	}
	static getCacheForObject(t) {
		let n = e.objectMap.get(t);
		return n || (n = new e(), e.objectMap.set(t, n)), n;
	}
};
function fa({ isoYear: e, isoMonth: t, isoDay: n }) {
	return `${sr(e)}-${cr(t)}-${cr(n)}T00:00Z`;
}
function pa(e, t) {
	return {
		years: e.year - t.year,
		months: e.month - t.month,
		days: e.day - t.day
	};
}
da.objectMap = /* @__PURE__ */ new WeakMap(), da.MAX_CACHE_ENTRIES = 1e3;
var ma = class {
	constructor() {
		this.eras = [], this.hasEra = !1, this.erasBeginMidYear = !1;
	}
	getFormatter() {
		return this.formatter === void 0 && (this.formatter = new Intl.DateTimeFormat(`en-US-u-ca-${this.id}`, {
			day: "numeric",
			month: "numeric",
			year: "numeric",
			era: "short",
			timeZone: "UTC"
		})), this.formatter;
	}
	getCalendarParts(e) {
		let t = this.getFormatter(), n = new Date(e);
		if (e === "-271821-04-19T00:00Z") {
			let e = t.resolvedOptions();
			t = new Intl.DateTimeFormat(e.locale, {
				...e,
				timeZone: "Etc/GMT+1"
			}), n = /* @__PURE__ */ new Date("-271821-04-20T00:00Z");
		}
		try {
			return t.formatToParts(n);
		} catch {
			throw RangeError(`Invalid ISO date: ${e}`);
		}
	}
	isoToCalendarDate(e, t) {
		let { year: n, month: r, day: i } = e, a = JSON.stringify({
			func: "isoToCalendarDate",
			isoYear: n,
			isoMonth: r,
			isoDay: i,
			id: this.id
		}), o = t.get(a);
		if (o) return o;
		let s = fa({
			isoYear: n,
			isoMonth: r,
			isoDay: i
		}), c = this.getCalendarParts(s), l = {};
		for (let e = 0; e < c.length; e++) {
			let { type: t, value: n } = c[e];
			if (t !== "year" && t !== "relatedYear" || (this.hasEra ? l.eraYear = +n : l.year = +n), t === "month") {
				let e = /^([0-9]*)(.*?)$/.exec(n);
				if (!e || e.length != 3 || !e[1] && !e[2]) throw RangeError(`Unexpected month: ${n}`);
				if (l.month = e[1] ? +e[1] : 1, l.month < 1) throw RangeError(`Invalid month ${n} from ${s}[u-ca-${this.id}] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10527)`);
				if (l.month > 13) throw RangeError(`Invalid month ${n} from ${s}[u-ca-${this.id}] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10529)`);
				e[2] && (l.monthExtra = e[2]);
			}
			t === "day" && (l.day = +n), this.hasEra && t === "era" && n != null && n !== "" && (l.era = n.split(" (")[0].normalize("NFD").replace(/[^-0-9 \p{L}]/gu, "").replace(/ /g, "-").toLowerCase());
		}
		if (this.hasEra && l.eraYear === void 0) throw RangeError(`Intl.DateTimeFormat.formatToParts lacks relatedYear in ${this.id} calendar. Try Node 14+ or modern browsers.`);
		if (this.hasEra) {
			let e = this.eras.find(((e) => l.era === e.genericName));
			e && (l.era = e.code);
		}
		if (this.reviseIntlEra) {
			let { era: t, eraYear: n } = this.reviseIntlEra(l, e);
			l.era = t, l.eraYear = n;
		}
		this.checkIcuBugs && this.checkIcuBugs(e);
		let u = this.adjustCalendarDate(l, t, "constrain", !0);
		if (u.year === void 0) throw RangeError(`Missing year converting ${JSON.stringify(e)}`);
		if (u.month === void 0) throw RangeError(`Missing month converting ${JSON.stringify(e)}`);
		if (u.day === void 0) throw RangeError(`Missing day converting ${JSON.stringify(e)}`);
		return t.set(a, u), ["constrain", "reject"].forEach(((n) => {
			let r = JSON.stringify({
				func: "calendarToIsoDate",
				year: u.year,
				month: u.month,
				day: u.day,
				overflow: n,
				id: this.id
			});
			t.set(r, e);
		})), u;
	}
	validateCalendarDate(e) {
		let { month: t, year: n, day: r, eraYear: i, monthCode: a, monthExtra: o } = e;
		if (o !== void 0) throw RangeError("Unexpected `monthExtra` value");
		if (n === void 0 && i === void 0) throw TypeError("year or eraYear is required");
		if (t === void 0 && a === void 0) throw TypeError("month or monthCode is required");
		if (r === void 0) throw RangeError("Missing day");
		if (a !== void 0) {
			if (typeof a != "string") throw RangeError("monthCode must be a string, not " + typeof a);
			if (!/^M([01]?\d)(L?)$/.test(a)) throw RangeError(`Invalid monthCode: ${a}`);
		}
		if (this.hasEra && e.era === void 0 != (e.eraYear === void 0)) throw TypeError("properties era and eraYear must be provided together");
	}
	adjustCalendarDate(e, t = void 0, n = "constrain", r = !1) {
		if (this.calendarType === "lunisolar") throw RangeError("Override required for lunisolar calendars");
		let i = e;
		this.validateCalendarDate(i);
		let a = this.monthsInYear(i, t), { month: o, monthCode: s } = i;
		return {month: o, monthCode: s} = ua(i, n, a), {
			...i,
			month: o,
			monthCode: s
		};
	}
	regulateMonthDayNaive(e, t, n) {
		let r = this.monthsInYear(e, n), { month: i, day: a } = e;
		return t === "reject" ? (Q(i, 1, r), Q(a, 1, this.maximumMonthLength(e))) : (i = Wr(i, 1, r), a = Wr(a, 1, this.maximumMonthLength({
			...e,
			month: i
		}))), {
			...e,
			month: i,
			day: a
		};
	}
	calendarToIsoDate(e, t = "constrain", n) {
		let r = e, i = this.adjustCalendarDate(e, n, t, !1);
		i = this.regulateMonthDayNaive(i, t, n);
		let { year: a, month: o, day: s } = i, c = JSON.stringify({
			func: "calendarToIsoDate",
			year: a,
			month: o,
			day: s,
			overflow: t,
			id: this.id
		}), l, u = n.get(c);
		if (u || r.year !== void 0 && r.month !== void 0 && r.day !== void 0 && (r.year !== i.year || r.month !== i.month || r.day !== i.day) && (l = JSON.stringify({
			func: "calendarToIsoDate",
			year: r.year,
			month: r.month,
			day: r.day,
			overflow: t,
			id: this.id
		}), u = n.get(l), u)) return u;
		let d = this.estimateIsoDate({
			year: a,
			month: o,
			day: s
		}), f = (e) => {
			let r = this.addDaysIso(d, e);
			if (i.day > this.minimumMonthLength(i)) {
				let e = this.isoToCalendarDate(r, n);
				for (; e.month !== o || e.year !== a;) {
					if (t === "reject") throw RangeError(`day ${s} does not exist in month ${o} of year ${a}`);
					r = this.addDaysIso(r, -1), e = this.isoToCalendarDate(r, n);
				}
			}
			return r;
		}, p = 0, m = this.isoToCalendarDate(d, n), h = pa(i, m);
		if (h.years !== 0 || h.months !== 0 || h.days !== 0) {
			let e = 365 * h.years + 30 * h.months + h.days;
			d = this.addDaysIso(d, e), m = this.isoToCalendarDate(d, n), h = pa(i, m), h.years === 0 && h.months === 0 ? d = f(h.days) : p = this.compareCalendarDates(i, m);
		}
		let g = 8;
		for (; p;) {
			d = this.addDaysIso(d, p * g);
			let e = m;
			m = this.isoToCalendarDate(d, n);
			let a = p;
			if (p = this.compareCalendarDates(i, m), p) {
				if (h = pa(i, m), h.years === 0 && h.months === 0) d = f(h.days), p = 0;
				else if (a && p !== a) {
					if (g > 1) g /= 2;
					else {
						if (t === "reject") throw RangeError(`Can't find ISO date from calendar date: ${JSON.stringify({ ...r })}`);
						this.compareCalendarDates(m, e) > 0 && (d = this.addDaysIso(d, -1)), p = 0;
					}
				}
			}
		}
		if (n.set(c, d), l && n.set(l, d), i.year === void 0 || i.month === void 0 || i.day === void 0 || i.monthCode === void 0 || this.hasEra && (i.era === void 0 || i.eraYear === void 0)) throw RangeError("Unexpected missing property");
		return d;
	}
	compareCalendarDates(e, t) {
		return e.year === t.year ? e.month === t.month ? e.day === t.day ? 0 : Yi(e.day - t.day) : Yi(e.month - t.month) : Yi(e.year - t.year);
	}
	regulateDate(e, t = "constrain", n) {
		let r = this.calendarToIsoDate(e, t, n);
		return this.isoToCalendarDate(r, n);
	}
	addDaysIso(e, t) {
		return zr(e.year, e.month, e.day + t);
	}
	addDaysCalendar(e, t, n) {
		let r = this.calendarToIsoDate(e, "constrain", n), i = this.addDaysIso(r, t);
		return this.isoToCalendarDate(i, n);
	}
	addMonthsCalendar(e, t, n, r) {
		let i = e, { day: a } = i;
		for (let e = 0, n = Math.abs(t); e < n; e++) {
			let { month: e } = i, n = i, o = t < 0 ? -Math.max(a, this.daysInPreviousMonth(i, r)) : this.daysInMonth(i, r), s = this.calendarToIsoDate(i, "constrain", r), c = this.addDaysIso(s, o);
			if (i = this.isoToCalendarDate(c, r), t > 0) {
				let t = this.monthsInYear(n, r);
				for (; i.month - 1 != e % t;) c = this.addDaysIso(c, -1), i = this.isoToCalendarDate(c, r);
			}
			i.day !== a && (i = this.regulateDate({
				...i,
				day: a
			}, "constrain", r));
		}
		if (n === "reject" && i.day !== a) throw RangeError(`Day ${a} does not exist in resulting calendar month`);
		return i;
	}
	addCalendar(e, { years: t = 0, months: n = 0, weeks: r = 0, days: i = 0 }, a, o) {
		let { year: s, day: c, monthCode: l } = e, u = this.adjustCalendarDate({
			year: s + t,
			monthCode: l,
			day: c
		}, o), d = this.addMonthsCalendar(u, n, a, o), f = i + 7 * r;
		return this.addDaysCalendar(d, f, o);
	}
	untilCalendar(e, t, n, r) {
		let i = 0, a = 0, o = 0, s = 0;
		switch (n) {
			case "day":
				i = this.calendarDaysUntil(e, t, r);
				break;
			case "week": {
				let n = this.calendarDaysUntil(e, t, r);
				i = n % 7, a = (n - i) / 7;
				break;
			}
			case "month":
			case "year": {
				let a = this.compareCalendarDates(t, e);
				if (!a) return {
					years: 0,
					months: 0,
					weeks: 0,
					days: 0
				};
				let c = t.year - e.year, l = t.day - e.day;
				if (n === "year" && c) {
					let n = 0;
					t.monthCode > e.monthCode && (n = 1), t.monthCode < e.monthCode && (n = -1), n ||= Math.sign(l), s = n * a < 0 ? c - a : c;
				}
				let u, d = s ? this.addCalendar(e, { years: s }, "constrain", r) : e;
				do
					o += a, u = d, d = this.addMonthsCalendar(u, a, "constrain", r), d.day !== e.day && (d = this.regulateDate({
						...d,
						day: e.day
					}, "constrain", r));
				while (this.compareCalendarDates(t, d) * a >= 0);
				o -= a, i = this.calendarDaysUntil(u, t, r);
				break;
			}
		}
		return {
			years: s,
			months: o,
			weeks: a,
			days: i
		};
	}
	daysInMonth(e, t) {
		let { day: n } = e, r = this.maximumMonthLength(e), i = this.minimumMonthLength(e);
		if (i === r) return i;
		let a = n <= r - i ? r : i, o = this.calendarToIsoDate(e, "constrain", t), s = this.addDaysIso(o, a), c = this.isoToCalendarDate(s, t), l = this.addDaysIso(s, -c.day);
		return this.isoToCalendarDate(l, t).day;
	}
	daysInPreviousMonth(e, t) {
		let { day: n, month: r, year: i } = e, a = {
			year: r > 1 ? i : i - 1,
			month: r,
			day: 1
		}, o = r > 1 ? r - 1 : this.monthsInYear(a, t);
		a = {
			...a,
			month: o
		};
		let s = this.minimumMonthLength(a), c = this.maximumMonthLength(a);
		if (s === c) return c;
		let l = this.calendarToIsoDate(e, "constrain", t), u = this.addDaysIso(l, -n);
		return this.isoToCalendarDate(u, t).day;
	}
	startOfCalendarYear(e) {
		return {
			year: e.year,
			month: 1,
			monthCode: "M01",
			day: 1
		};
	}
	startOfCalendarMonth(e) {
		return {
			year: e.year,
			month: e.month,
			day: 1
		};
	}
	calendarDaysUntil(e, t, n) {
		let r = this.calendarToIsoDate(e, "constrain", n), i = this.calendarToIsoDate(t, "constrain", n);
		return oi(i.year, i.month - 1, i.day) - oi(r.year, r.month - 1, r.day);
	}
	monthDaySearchStartYear(e, t) {
		return 1972;
	}
	monthDayFromFields(e, t, n) {
		let r, i, a, o, s, { era: c, eraYear: l, year: u, month: d, monthCode: f, day: p } = e;
		if (d !== void 0 && u === void 0 && (!this.hasEra || c === void 0 || l === void 0)) throw TypeError("when month is present, year (or era and eraYear) are required");
		(f === void 0 || u !== void 0 || this.hasEra && l !== void 0) && ({monthCode: f, day: p} = this.isoToCalendarDate(this.calendarToIsoDate(e, t, n), n));
		let m = {
			year: this.monthDaySearchStartYear(f, p),
			month: 12,
			day: 31
		}, h = this.isoToCalendarDate(m, n), g = h.monthCode > f || h.monthCode === f && h.day >= p ? h.year : h.year - 1;
		for (let e = 0; e < 20; e++) {
			let c = this.adjustCalendarDate({
				day: p,
				monthCode: f,
				year: g - e
			}, n), l = this.calendarToIsoDate(c, "constrain", n), u = this.isoToCalendarDate(l, n);
			if ({year: r, month: i, day: a} = l, u.monthCode === f && u.day === p) return {
				month: i,
				day: a,
				year: r
			};
			if (t === "constrain") {
				let e = this.maxLengthOfMonthCodeInAnyYear(u.monthCode);
				if (u.monthCode === f && u.day === e && p > e) return {
					month: i,
					day: a,
					year: r
				};
				(o === void 0 || u.monthCode === o.monthCode && u.day > o.day) && (o = u, s = l);
			}
		}
		if (t === "constrain" && s !== void 0) return s;
		throw RangeError(`No recent ${this.id} year with monthCode ${f} and day ${p}`);
	}
	getFirstDayOfWeek() {}
	getMinimalDaysInFirstWeek() {}
}, ha = class extends ma {
	constructor() {
		super(...arguments), this.id = "hebrew", this.calendarType = "lunisolar", this.months = {
			Tishri: {
				leap: 1,
				regular: 1,
				monthCode: "M01",
				days: 30
			},
			Heshvan: {
				leap: 2,
				regular: 2,
				monthCode: "M02",
				days: {
					min: 29,
					max: 30
				}
			},
			Kislev: {
				leap: 3,
				regular: 3,
				monthCode: "M03",
				days: {
					min: 29,
					max: 30
				}
			},
			Tevet: {
				leap: 4,
				regular: 4,
				monthCode: "M04",
				days: 29
			},
			Shevat: {
				leap: 5,
				regular: 5,
				monthCode: "M05",
				days: 30
			},
			Adar: {
				leap: void 0,
				regular: 6,
				monthCode: "M06",
				days: 29
			},
			"Adar I": {
				leap: 6,
				regular: void 0,
				monthCode: "M05L",
				days: 30
			},
			"Adar II": {
				leap: 7,
				regular: void 0,
				monthCode: "M06",
				days: 29
			},
			Nisan: {
				leap: 8,
				regular: 7,
				monthCode: "M07",
				days: 30
			},
			Iyar: {
				leap: 9,
				regular: 8,
				monthCode: "M08",
				days: 29
			},
			Sivan: {
				leap: 10,
				regular: 9,
				monthCode: "M09",
				days: 30
			},
			Tamuz: {
				leap: 11,
				regular: 10,
				monthCode: "M10",
				days: 29
			},
			Av: {
				leap: 12,
				regular: 11,
				monthCode: "M11",
				days: 30
			},
			Elul: {
				leap: 13,
				regular: 12,
				monthCode: "M12",
				days: 29
			}
		};
	}
	inLeapYear(e) {
		let { year: t } = e;
		return (7 * t + 1) % 19 < 7;
	}
	monthsInYear(e) {
		return this.inLeapYear(e) ? 13 : 12;
	}
	minimumMonthLength(e) {
		return this.minMaxMonthLength(e, "min");
	}
	maximumMonthLength(e) {
		return this.minMaxMonthLength(e, "max");
	}
	minMaxMonthLength(e, t) {
		let { month: n, year: r } = e, i = this.getMonthCode(r, n), a = Object.entries(this.months).find(((e) => e[1].monthCode === i));
		if (a === void 0) throw RangeError(`unmatched Hebrew month: ${n}`);
		let o = a[1].days;
		return typeof o == "number" ? o : o[t];
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		return [
			"M04",
			"M06",
			"M08",
			"M10",
			"M12"
		].includes(e) ? 29 : 30;
	}
	estimateIsoDate(e) {
		let { year: t } = e;
		return {
			year: t - 3760,
			month: 1,
			day: 1
		};
	}
	getMonthCode(e, t) {
		return this.inLeapYear({ year: e }) ? t === 6 ? la(5, !0) : la(t < 6 ? t : t - 1) : la(t);
	}
	adjustCalendarDate(e, t, n = "constrain", r = !1) {
		let { year: i, month: a, monthCode: o, day: s, monthExtra: c } = e;
		if (i === void 0) throw TypeError("Missing property: year");
		if (r) {
			if (c) {
				let e = this.months[c];
				if (!e) throw RangeError(`Unrecognized month from formatToParts: ${c}`);
				a = this.inLeapYear({ year: i }) ? e.leap : e.regular;
			}
			return o = this.getMonthCode(i, a), {
				year: i,
				month: a,
				day: s,
				monthCode: o
			};
		}
		if (this.validateCalendarDate(e), a === void 0) {
			if (o.endsWith("L")) {
				if (o !== "M05L") throw RangeError(`Hebrew leap month must have monthCode M05L, not ${o}`);
				if (a = 6, !this.inLeapYear({ year: i })) {
					if (n === "reject") throw RangeError(`Hebrew monthCode M05L is invalid in year ${i} which is not a leap year`);
					a = 6, o = "M06";
				}
			} else {
				a = ca(o), this.inLeapYear({ year: i }) && a >= 6 && a++;
				let e = this.monthsInYear({ year: i });
				if (a < 1 || a > e) throw RangeError(`Invalid monthCode: ${o}`);
			}
		} else if (n === "reject" ? (Q(a, 1, this.monthsInYear({ year: i })), Q(s, 1, this.maximumMonthLength({
			year: i,
			month: a
		}))) : (a = Wr(a, 1, this.monthsInYear({ year: i })), s = Wr(s, 1, this.maximumMonthLength({
			year: i,
			month: a
		}))), o === void 0) o = this.getMonthCode(i, a);
		else if (this.getMonthCode(i, a) !== o) throw RangeError(`monthCode ${o} doesn't correspond to month ${a} in Hebrew year ${i}`);
		return {
			...e,
			day: s,
			month: a,
			monthCode: o,
			year: i
		};
	}
}, ga = class extends ma {
	constructor() {
		super(...arguments), this.calendarType = "lunar", this.DAYS_PER_ISLAMIC_YEAR = 354 + 11 / 30, this.DAYS_PER_ISO_YEAR = 365.2425;
	}
	inLeapYear(e, t) {
		let n = {
			year: e.year,
			month: 1,
			monthCode: "M01",
			day: 1
		}, r = {
			year: e.year + 1,
			month: 1,
			monthCode: "M01",
			day: 1
		};
		return this.calendarDaysUntil(n, r, t) === 355;
	}
	monthsInYear() {
		return 12;
	}
	minimumMonthLength() {
		return 29;
	}
	maximumMonthLength() {
		return 30;
	}
	maxLengthOfMonthCodeInAnyYear() {
		return 30;
	}
	estimateIsoDate(e) {
		let { year: t } = this.adjustCalendarDate(e);
		return {
			year: Math.floor(t * this.DAYS_PER_ISLAMIC_YEAR / this.DAYS_PER_ISO_YEAR) + 622,
			month: 1,
			day: 1
		};
	}
}, _a = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamic";
	}
}, va = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamic-umalqura";
	}
}, ya = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamic-tbla";
	}
}, ba = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamic-civil";
	}
}, xa = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamic-rgsa";
	}
}, Sa = class extends ga {
	constructor() {
		super(...arguments), this.id = "islamicc";
	}
}, Ca = class extends ma {
	constructor() {
		super(...arguments), this.id = "persian", this.calendarType = "solar";
	}
	inLeapYear(e, t) {
		return this.daysInMonth({
			year: e.year,
			month: 12,
			day: 1
		}, t) === 30;
	}
	monthsInYear() {
		return 12;
	}
	minimumMonthLength(e) {
		let { month: t } = e;
		return t === 12 ? 29 : t <= 6 ? 31 : 30;
	}
	maximumMonthLength(e) {
		let { month: t } = e;
		return t === 12 ? 30 : t <= 6 ? 31 : 30;
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		return ca(e) <= 6 ? 31 : 30;
	}
	estimateIsoDate(e) {
		let { year: t } = this.adjustCalendarDate(e);
		return {
			year: t + 621,
			month: 1,
			day: 1
		};
	}
}, wa = class extends ma {
	constructor() {
		super(...arguments), this.id = "indian", this.calendarType = "solar", this.months = {
			1: {
				length: 30,
				month: 3,
				day: 22,
				leap: {
					length: 31,
					month: 3,
					day: 21
				}
			},
			2: {
				length: 31,
				month: 4,
				day: 21
			},
			3: {
				length: 31,
				month: 5,
				day: 22
			},
			4: {
				length: 31,
				month: 6,
				day: 22
			},
			5: {
				length: 31,
				month: 7,
				day: 23
			},
			6: {
				length: 31,
				month: 8,
				day: 23
			},
			7: {
				length: 30,
				month: 9,
				day: 23
			},
			8: {
				length: 30,
				month: 10,
				day: 23
			},
			9: {
				length: 30,
				month: 11,
				day: 22
			},
			10: {
				length: 30,
				month: 12,
				day: 22
			},
			11: {
				length: 30,
				month: 1,
				nextYear: !0,
				day: 21
			},
			12: {
				length: 30,
				month: 2,
				nextYear: !0,
				day: 20
			}
		}, this.vulnerableToBceBug = (/* @__PURE__ */ new Date("0000-01-01T00:00Z")).toLocaleDateString("en-US-u-ca-indian", { timeZone: "UTC" }) !== "10/11/-79 Saka";
	}
	inLeapYear(e) {
		return Ta(e.year + 78);
	}
	monthsInYear() {
		return 12;
	}
	minimumMonthLength(e) {
		return this.getMonthInfo(e).length;
	}
	maximumMonthLength(e) {
		return this.getMonthInfo(e).length;
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		let t = ca(e), n = this.months[t];
		return n = n.leap ?? n, n.length;
	}
	getMonthInfo(e) {
		let { month: t } = e, n = this.months[t];
		if (n === void 0) throw RangeError(`Invalid month: ${t}`);
		return this.inLeapYear(e) && n.leap && (n = n.leap), n;
	}
	estimateIsoDate(e) {
		let t = this.adjustCalendarDate(e), n = this.getMonthInfo(t);
		return zr(t.year + 78 + +!!n.nextYear, n.month, n.day + t.day - 1);
	}
	checkIcuBugs(e) {
		if (this.vulnerableToBceBug && e.year < 1) throw RangeError(`calendar '${this.id}' is broken for ISO dates before 0001-01-01 (see https://bugs.chromium.org/p/v8/issues/detail?id=10529)`);
	}
};
function Ta(e) {
	return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
var Ea = class extends ma {
	constructor(e, t) {
		super(), this.calendarType = "solar", this.id = e, this.isoEpoch = t;
	}
	inLeapYear(e) {
		let { year: t } = this.estimateIsoDate({
			month: 1,
			day: 1,
			year: e.year
		});
		return Ta(t);
	}
	monthsInYear() {
		return 12;
	}
	minimumMonthLength(e) {
		let { month: t } = e;
		return t === 2 ? this.inLeapYear(e) ? 29 : 28 : [
			4,
			6,
			9,
			11
		].indexOf(t) >= 0 ? 30 : 31;
	}
	maximumMonthLength(e) {
		return this.minimumMonthLength(e);
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		return [
			31,
			29,
			31,
			30,
			31,
			30,
			31,
			31,
			30,
			31,
			30,
			31
		][ca(e) - 1];
	}
	estimateIsoDate(e) {
		let t = this.adjustCalendarDate(e);
		return Yt(t.year + this.isoEpoch.year, t.month + this.isoEpoch.month, t.day + this.isoEpoch.day, "constrain");
	}
}, Da = class extends ma {
	constructor(e, t) {
		super(), this.hasEra = !0, this.calendarType = "solar", this.id = e;
		let { eras: n, anchorEra: r } = function(e) {
			let t, n = e;
			if (n.length === 0) throw RangeError("Invalid era data: eras are required");
			if (n.length === 1 && n[0].reverseOf) throw RangeError("Invalid era data: anchor era cannot count years backwards");
			if (n.length === 1 && !n[0].code) throw RangeError("Invalid era data: at least one named era is required");
			if (n.filter(((e) => e.reverseOf != null)).length > 1) throw RangeError("Invalid era data: only one era can count years backwards");
			n.forEach(((e) => {
				if (e.isAnchor || !e.anchorEpoch && !e.reverseOf) {
					if (t) throw RangeError("Invalid era data: cannot have multiple anchor eras");
					t = e, e.anchorEpoch = { year: +!e.hasYearZero };
				} else if (!e.code) throw RangeError("If era name is blank, it must be the anchor era");
			})), n = n.filter(((e) => e.code)), n.forEach(((e) => {
				let { reverseOf: t } = e;
				if (t) {
					let r = n.find(((e) => e.code === t));
					if (r === void 0) throw RangeError(`Invalid era data: unmatched reverseOf era: ${t}`);
					e.reverseOf = r, e.anchorEpoch = r.anchorEpoch, e.isoEpoch = r.isoEpoch;
				}
				e.anchorEpoch.month === void 0 && (e.anchorEpoch.month = 1), e.anchorEpoch.day === void 0 && (e.anchorEpoch.day = 1);
			})), n.sort(((e, t) => {
				if (e.reverseOf) return 1;
				if (t.reverseOf) return -1;
				if (!e.isoEpoch || !t.isoEpoch) throw RangeError("Invalid era data: missing ISO epoch");
				return t.isoEpoch.year - e.isoEpoch.year;
			}));
			let r = n[n.length - 1].reverseOf;
			if (r && r !== n[n.length - 2]) throw RangeError("Invalid era data: invalid reverse-sign era");
			return n.forEach(((e, t) => {
				e.genericName = "era" + (n.length - 1 - t);
			})), {
				eras: n,
				anchorEra: t || n[0]
			};
		}(t);
		this.anchorEra = r, this.eras = n;
	}
	inLeapYear(e) {
		let { year: t } = this.estimateIsoDate({
			month: 1,
			day: 1,
			year: e.year
		});
		return Ta(t);
	}
	monthsInYear() {
		return 12;
	}
	minimumMonthLength(e) {
		let { month: t } = e;
		return t === 2 ? this.inLeapYear(e) ? 29 : 28 : [
			4,
			6,
			9,
			11
		].indexOf(t) >= 0 ? 30 : 31;
	}
	maximumMonthLength(e) {
		return this.minimumMonthLength(e);
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		return [
			31,
			29,
			31,
			30,
			31,
			30,
			31,
			31,
			30,
			31,
			30,
			31
		][ca(e) - 1];
	}
	completeEraYear(e) {
		let t = (t, n, r) => {
			let i = e[t];
			if (i != null && i != n && !(r || []).includes(i)) {
				let e = r?.[0];
				throw RangeError(`Input ${t} ${i} doesn't match calculated value ${e ? `${n} (also called ${e})` : n}`);
			}
		}, n = (t) => {
			let n, r = {
				...e,
				year: t
			}, i = this.eras.find(((e, i) => {
				if (i === this.eras.length - 1) {
					if (e.reverseOf) {
						if (t > 0) throw RangeError(`Signed year ${t} is invalid for era ${e.code}`);
						return n = e.anchorEpoch.year - t, !0;
					}
					return n = t - e.anchorEpoch.year + +!e.hasYearZero, !0;
				}
				return this.compareCalendarDates(r, e.anchorEpoch) >= 0 && (n = t - e.anchorEpoch.year + +!e.hasYearZero, !0);
			}));
			if (!i) throw RangeError(`Year ${t} was not matched by any era`);
			return {
				eraYear: n,
				era: i.code,
				eraNames: i.names
			};
		}, { year: r, eraYear: i, era: a } = e;
		if (r != null) {
			let e = n(r);
			({eraYear: i, era: a} = e), t("era", a, e?.eraNames), t("eraYear", i);
		} else {
			if (i == null) throw RangeError("Either year or eraYear and era are required");
			{
				if (a === void 0) throw RangeError("era and eraYear must be provided together");
				let e = this.eras.find((({ code: e, names: t = [] }) => e === a || t.includes(a)));
				if (!e) throw RangeError(`Era ${a} (ISO year ${i}) was not matched by any era`);
				r = e.reverseOf ? e.anchorEpoch.year - i : i + e.anchorEpoch.year - +!e.hasYearZero, t("year", r), {eraYear: i, era: a} = n(r);
			}
		}
		return {
			...e,
			year: r,
			eraYear: i,
			era: a
		};
	}
	adjustCalendarDate(e, t, n = "constrain") {
		let r = e, { month: i, monthCode: a } = r;
		return i === void 0 && (r = {
			...r,
			month: ca(a)
		}), this.validateCalendarDate(r), r = this.completeEraYear(r), super.adjustCalendarDate(r, t, n);
	}
	estimateIsoDate(e) {
		let { year: t, month: n, day: r } = this.adjustCalendarDate(e), { anchorEra: i } = this;
		return Yt(t + i.isoEpoch.year - +!i.hasYearZero, n, r, "constrain");
	}
}, Oa = class extends Da {
	constructor(e, t) {
		super(e, t);
	}
	isoToCalendarDate(e) {
		let { year: t, month: n, day: r } = e, i = la(n), a = t - this.anchorEra.isoEpoch.year + 1;
		return this.completeEraYear({
			year: a,
			month: n,
			monthCode: i,
			day: r
		});
	}
}, ka = {
	inLeapYear(e) {
		let { year: t } = e;
		return (t + 1) % 4 == 0;
	},
	monthsInYear: () => 13,
	minimumMonthLength(e) {
		let { month: t } = e;
		return t === 13 ? this.inLeapYear(e) ? 6 : 5 : 30;
	},
	maximumMonthLength(e) {
		return this.minimumMonthLength(e);
	},
	maxLengthOfMonthCodeInAnyYear: (e) => e === "M13" ? 6 : 30
}, Aa = class extends Ea {
	constructor(e, t) {
		super(e, t), this.inLeapYear = ka.inLeapYear, this.monthsInYear = ka.monthsInYear, this.minimumMonthLength = ka.minimumMonthLength, this.maximumMonthLength = ka.maximumMonthLength, this.maxLengthOfMonthCodeInAnyYear = ka.maxLengthOfMonthCodeInAnyYear;
	}
}, ja = class extends Da {
	constructor(e, t) {
		super(e, t), this.inLeapYear = ka.inLeapYear, this.monthsInYear = ka.monthsInYear, this.minimumMonthLength = ka.minimumMonthLength, this.maximumMonthLength = ka.maximumMonthLength, this.maxLengthOfMonthCodeInAnyYear = ka.maxLengthOfMonthCodeInAnyYear;
	}
}, Ma = class extends Aa {
	constructor() {
		super("ethioaa", {
			year: -5492,
			month: 7,
			day: 17
		});
	}
}, Na = class extends ja {
	constructor() {
		super("coptic", [{
			code: "coptic",
			isoEpoch: {
				year: 284,
				month: 8,
				day: 29
			}
		}, {
			code: "coptic-inverse",
			reverseOf: "coptic"
		}]);
	}
}, Pa = class extends ja {
	constructor() {
		super("ethiopic", [{
			code: "ethioaa",
			names: ["ethiopic-amete-alem", "mundi"],
			isoEpoch: {
				year: -5492,
				month: 7,
				day: 17
			}
		}, {
			code: "ethiopic",
			names: ["incar"],
			isoEpoch: {
				year: 8,
				month: 8,
				day: 27
			},
			anchorEpoch: { year: 5501 }
		}]);
	}
}, Fa = class extends Oa {
	constructor() {
		super("roc", [{
			code: "roc",
			names: ["minguo"],
			isoEpoch: {
				year: 1912,
				month: 1,
				day: 1
			}
		}, {
			code: "roc-inverse",
			names: ["before-roc"],
			reverseOf: "roc"
		}]);
	}
}, Ia = class extends Ea {
	constructor() {
		super("buddhist", {
			year: -543,
			month: 1,
			day: 1
		});
	}
}, La = class extends Oa {
	constructor() {
		super("gregory", [{
			code: "gregory",
			names: ["ad", "ce"],
			isoEpoch: {
				year: 1,
				month: 1,
				day: 1
			}
		}, {
			code: "gregory-inverse",
			names: ["be", "bce"],
			reverseOf: "gregory"
		}]);
	}
	reviseIntlEra(e) {
		let { era: t, eraYear: n } = e;
		return t === "b" && (t = "gregory-inverse"), t === "a" && (t = "gregory"), {
			era: t,
			eraYear: n
		};
	}
	getFirstDayOfWeek() {
		return 1;
	}
	getMinimalDaysInFirstWeek() {
		return 1;
	}
}, Ra = class extends Oa {
	constructor() {
		super("japanese", [
			{
				code: "reiwa",
				isoEpoch: {
					year: 2019,
					month: 5,
					day: 1
				},
				anchorEpoch: {
					year: 2019,
					month: 5,
					day: 1
				}
			},
			{
				code: "heisei",
				isoEpoch: {
					year: 1989,
					month: 1,
					day: 8
				},
				anchorEpoch: {
					year: 1989,
					month: 1,
					day: 8
				}
			},
			{
				code: "showa",
				isoEpoch: {
					year: 1926,
					month: 12,
					day: 25
				},
				anchorEpoch: {
					year: 1926,
					month: 12,
					day: 25
				}
			},
			{
				code: "taisho",
				isoEpoch: {
					year: 1912,
					month: 7,
					day: 30
				},
				anchorEpoch: {
					year: 1912,
					month: 7,
					day: 30
				}
			},
			{
				code: "meiji",
				isoEpoch: {
					year: 1868,
					month: 9,
					day: 8
				},
				anchorEpoch: {
					year: 1868,
					month: 9,
					day: 8
				}
			},
			{
				code: "japanese",
				names: [
					"japanese",
					"gregory",
					"ad",
					"ce"
				],
				isoEpoch: {
					year: 1,
					month: 1,
					day: 1
				}
			},
			{
				code: "japanese-inverse",
				names: [
					"japanese-inverse",
					"gregory-inverse",
					"bc",
					"bce"
				],
				reverseOf: "japanese"
			}
		]), this.erasBeginMidYear = !0;
	}
	reviseIntlEra(e, t) {
		let { era: n, eraYear: r } = e, { year: i } = t;
		return this.eras.find(((e) => e.code === n)) ? {
			era: n,
			eraYear: r
		} : i < 1 ? {
			era: "japanese-inverse",
			eraYear: 1 - i
		} : {
			era: "japanese",
			eraYear: i
		};
	}
}, za = class extends ma {
	constructor() {
		super(...arguments), this.calendarType = "lunisolar";
	}
	inLeapYear(e, t) {
		let n = this.getMonthList(e.year, t);
		return Object.entries(n).length === 13;
	}
	monthsInYear(e, t) {
		return this.inLeapYear(e, t) ? 13 : 12;
	}
	minimumMonthLength() {
		return 29;
	}
	maximumMonthLength() {
		return 30;
	}
	maxLengthOfMonthCodeInAnyYear(e) {
		return [
			"M01L",
			"M09L",
			"M10L",
			"M11L",
			"M12L"
		].includes(e) ? 29 : 30;
	}
	monthDaySearchStartYear(e, t) {
		let n = {
			M01L: [1651, 1651],
			M02L: [1947, 1765],
			M03L: [1966, 1955],
			M04L: [1963, 1944],
			M05L: [1971, 1952],
			M06L: [1960, 1941],
			M07L: [1968, 1938],
			M08L: [1957, 1718],
			M09L: [1832, 1832],
			M10L: [1870, 1870],
			M11L: [1814, 1814],
			M12L: [1890, 1890]
		}[e] ?? [1972, 1972];
		return t < 30 ? n[0] : n[1];
	}
	getMonthList(e, t) {
		if (e === void 0) throw TypeError("Missing year");
		let n = JSON.stringify({
			func: "getMonthList",
			calendarYear: e,
			id: this.id
		}), r = t.get(n);
		if (r) return r;
		let i = this.getFormatter(), a = (e, t) => {
			let n = fa({
				isoYear: e,
				isoMonth: 2,
				isoDay: 1
			}), r = new Date(n);
			r.setUTCDate(t + 1);
			let a = i.formatToParts(r), o = a.find(((e) => e.type === "month")).value, s = +a.find(((e) => e.type === "day")).value, c = a.find(((e) => e.type === "relatedYear")), l;
			if (c === void 0) throw RangeError(`Intl.DateTimeFormat.formatToParts lacks relatedYear in ${this.id} calendar. Try Node 14+ or modern browsers.`);
			return l = +c.value, {
				calendarMonthString: o,
				calendarDay: s,
				calendarYearToVerify: l
			};
		}, o = 17, { calendarMonthString: s, calendarDay: c, calendarYearToVerify: l } = a(e, o);
		s !== "1" && (o += 29, {calendarMonthString: s, calendarDay: c} = a(e, o)), o -= c - 5;
		let u = {}, d, f, p = 1, m = !1;
		do
			({calendarMonthString: s, calendarDay: c, calendarYearToVerify: l} = a(e, o)), d && (u[f].daysInMonth = d + 30 - c), l === e ? (u[s] = { monthIndex: p++ }, o += 30) : m = !0, d = c, f = s;
		while (!m);
		return u[f].daysInMonth = d + 30 - c, t.set(n, u), u;
	}
	estimateIsoDate(e) {
		let { year: t, month: n } = e;
		return {
			year: t,
			month: n >= 12 ? 12 : n + 1,
			day: 1
		};
	}
	adjustCalendarDate(e, t, n = "constrain", r = !1) {
		let { year: i, month: a, monthExtra: o, day: s, monthCode: c } = e;
		if (i === void 0) throw TypeError("Missing property: year");
		if (r) {
			if (o && o !== "bis") throw RangeError(`Unexpected leap month suffix: ${o}`);
			let e = la(a, o !== void 0), n = `${a}${o || ""}`, r = this.getMonthList(i, t)[n];
			if (r === void 0) throw RangeError(`Unmatched month ${n} in Chinese year ${i}`);
			return a = r.monthIndex, {
				year: i,
				month: a,
				day: s,
				monthCode: e
			};
		}
		if (this.validateCalendarDate(e), a === void 0) {
			let e = this.getMonthList(i, t), r = c.replace(/^M|L$/g, ((e) => e === "L" ? "bis" : ""));
			r[0] === "0" && (r = r.slice(1));
			let o = e[r];
			if (a = o && o.monthIndex, a === void 0 && c.endsWith("L") && c != "M13L" && n === "constrain") {
				let t = +c.replace(/^M0?|L$/g, "");
				o = e[t], o && (a = o.monthIndex, c = la(t));
			}
			if (a === void 0) throw RangeError(`Unmatched month ${c} in Chinese year ${i}`);
		} else if (c === void 0) {
			let e = this.getMonthList(i, t), r = Object.entries(e), o = r.length;
			n === "reject" ? (Q(a, 1, o), Q(s, 1, this.maximumMonthLength())) : (a = Wr(a, 1, o), s = Wr(s, 1, this.maximumMonthLength()));
			let l = r.find(((e) => e[1].monthIndex === a));
			if (l === void 0) throw RangeError(`Invalid month ${a} in Chinese year ${i}`);
			c = la(+l[0].replace("bis", ""), l[0].indexOf("bis") !== -1);
		} else {
			let e = this.getMonthList(i, t), n = c.replace(/^M|L$/g, ((e) => e === "L" ? "bis" : ""));
			n[0] === "0" && (n = n.slice(1));
			let r = e[n];
			if (!r) throw RangeError(`Unmatched monthCode ${c} in Chinese year ${i}`);
			if (a !== r.monthIndex) throw RangeError(`monthCode ${c} doesn't correspond to month ${a} in Chinese year ${i}`);
		}
		return {
			...e,
			year: i,
			month: a,
			monthCode: c,
			day: s
		};
	}
}, Ba = class extends za {
	constructor() {
		super(...arguments), this.id = "chinese";
	}
}, Va = class extends za {
	constructor() {
		super(...arguments), this.id = "dangi";
	}
}, Ha = class {
	constructor(e) {
		this.helper = e;
	}
	extraFields(e) {
		return this.helper.hasEra && e.includes("year") ? ["era", "eraYear"] : [];
	}
	resolveFields(e) {
		if (this.helper.calendarType !== "lunisolar") {
			let t = new da();
			ua(e, void 0, this.helper.monthsInYear({ year: e.year ?? 1972 }, t));
		}
	}
	dateToISO(e, t) {
		let n = new da(), r = this.helper.calendarToIsoDate(e, t, n);
		return n.setObject(r), r;
	}
	monthDayToISOReferenceDate(e, t) {
		let n = new da(), r = this.helper.monthDayFromFields(e, t, n);
		return n.setObject(r), r;
	}
	fieldKeysToIgnore(e) {
		let t = /* @__PURE__ */ new Set();
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			switch (t.add(r), r) {
				case "era":
					t.add("eraYear"), t.add("year");
					break;
				case "eraYear":
					t.add("era"), t.add("year");
					break;
				case "year":
					t.add("era"), t.add("eraYear");
					break;
				case "month":
					t.add("monthCode"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
					break;
				case "monthCode":
					t.add("month"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
					break;
				case "day": this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
			}
		}
		return ia(t);
	}
	dateAdd(e, { years: t, months: n, weeks: r, days: i }, a) {
		let o = da.getCacheForObject(e), s = this.helper.isoToCalendarDate(e, o), c = this.helper.addCalendar(s, {
			years: t,
			months: n,
			weeks: r,
			days: i
		}, a, o), l = this.helper.calendarToIsoDate(c, "constrain", o);
		return da.getCacheForObject(l) || new da(o).setObject(l), l;
	}
	dateUntil(e, t, n) {
		let r = da.getCacheForObject(e), i = da.getCacheForObject(t), a = this.helper.isoToCalendarDate(e, r), o = this.helper.isoToCalendarDate(t, i);
		return this.helper.untilCalendar(a, o, n, r);
	}
	isoToDate(e, t) {
		let n = da.getCacheForObject(e), r = this.helper.isoToCalendarDate(e, n);
		if (t.dayOfWeek && (r.dayOfWeek = sa.iso8601.isoToDate(e, { dayOfWeek: !0 }).dayOfWeek), t.dayOfYear) {
			let e = this.helper.startOfCalendarYear(r);
			r.dayOfYear = this.helper.calendarDaysUntil(e, r, n) + 1;
		}
		if (t.weekOfYear && (r.weekOfYear = aa(this.helper.id, e)), r.daysInWeek = 7, t.daysInMonth && (r.daysInMonth = this.helper.daysInMonth(r, n)), t.daysInYear) {
			let e = this.helper.startOfCalendarYear(r), t = this.helper.addCalendar(e, { years: 1 }, "constrain", n);
			r.daysInYear = this.helper.calendarDaysUntil(e, t, n);
		}
		return t.monthsInYear && (r.monthsInYear = this.helper.monthsInYear(r, n)), t.inLeapYear && (r.inLeapYear = this.helper.inLeapYear(r, n)), r;
	}
	getFirstDayOfWeek() {
		return this.helper.getFirstDayOfWeek();
	}
	getMinimalDaysInFirstWeek() {
		return this.helper.getMinimalDaysInFirstWeek();
	}
};
for (let e of [
	ha,
	Ca,
	Pa,
	Ma,
	Na,
	Ba,
	Va,
	Fa,
	wa,
	Ia,
	La,
	Ra,
	_a,
	va,
	ya,
	ba,
	xa,
	Sa
]) {
	let t = new e();
	sa[t.id] = new Ha(t);
}
Le("calendarImpl", (function(e) {
	return sa[e];
}));
var Ua = Intl.DateTimeFormat;
function Wa(e, t) {
	let n = j(e, t);
	return typeof n == "function" && (n = new Ua(j(e, De), n(j(e, Oe))), function(e, t, n) {
		let r = je(e);
		if (r === void 0) throw TypeError("Missing slots for the given container");
		if (r[t] === void 0) throw TypeError(`tried to reset ${t} which was not set`);
		r[t] = n;
	}(e, t, n)), n;
}
function Ga(e) {
	return Pe(e, Ce);
}
var Ka = class {
	constructor(e = void 0, t = void 0) {
		(function(e, t, n) {
			let r = n !== void 0, i;
			if (r) {
				let e = [
					"localeMatcher",
					"calendar",
					"numberingSystem",
					"hour12",
					"hourCycle",
					"timeZone",
					"weekday",
					"era",
					"year",
					"month",
					"day",
					"dayPeriod",
					"hour",
					"minute",
					"second",
					"fractionalSecondDigits",
					"timeZoneName",
					"formatMatcher",
					"dateStyle",
					"timeStyle"
				];
				i = function(e) {
					if (e == null) throw TypeError(`Expected object not ${e}`);
					return Object(e);
				}(n);
				let t = Object.create(null);
				for (let n = 0; n < e.length; n++) {
					let r = e[n];
					Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r]);
				}
				i = t;
			} else i = Object.create(null);
			let a = new Ua(t, i), o = a.resolvedOptions();
			if (Ne(e), r) {
				let t = Object.assign(Object.create(null), o);
				for (let e in t) Object.prototype.hasOwnProperty.call(i, e) || delete t[e];
				t.hour12 = i.hour12, t.hourCycle = i.hourCycle, M(e, Oe, t);
			} else M(e, Oe, i);
			M(e, De, o.locale), M(e, Ce, a), M(e, we, o.timeZone), M(e, Ee, o.calendar), M(e, _e, ro), M(e, ve, to), M(e, ye, no), M(e, be, eo), M(e, xe, io), M(e, Se, ao);
			let s = r ? i.timeZone : void 0;
			if (s === void 0) M(e, Te, o.timeZone);
			else {
				let t = bt(s);
				if (t.startsWith("−")) throw RangeError("Unicode minus (U+2212) is not supported in time zone offsets");
				M(e, Te, $n(t));
			}
		})(this, e, t);
	}
	get format() {
		G(this, Ga);
		let e = Ya.bind(this);
		return Object.defineProperties(e, {
			length: {
				value: 1,
				enumerable: !1,
				writable: !1,
				configurable: !0
			},
			name: {
				value: "",
				enumerable: !1,
				writable: !1,
				configurable: !0
			}
		}), e;
	}
	formatRange(e, t) {
		return G(this, Ga), Za.call(this, e, t);
	}
	formatToParts(e, ...t) {
		return G(this, Ga), Xa.call(this, e, ...t);
	}
	formatRangeToParts(e, t) {
		return G(this, Ga), Qa.call(this, e, t);
	}
	resolvedOptions() {
		return G(this, Ga), Ja.call(this);
	}
};
"formatToParts" in Ua.prototype || delete Ka.prototype.formatToParts, "formatRangeToParts" in Ua.prototype || delete Ka.prototype.formatRangeToParts;
var qa = function(e = void 0, t = void 0) {
	return new Ka(e, t);
};
function Ja() {
	let e = j(this, Ce).resolvedOptions();
	return e.timeZone = j(this, Te), e;
}
function Ya(e, ...t) {
	let n, r, i = po(e, this);
	return i.formatter ? (n = i.formatter, r = [Wi(i.epochNs, "floor")]) : (n = j(this, Ce), r = [e, ...t]), n.format(...r);
}
function Xa(e, ...t) {
	let n, r, i = po(e, this);
	return i.formatter ? (n = i.formatter, r = [Wi(i.epochNs, "floor")]) : (n = j(this, Ce), r = [e, ...t]), n.formatToParts(...r);
}
function Za(e, t) {
	if (e === void 0 || t === void 0) throw TypeError("Intl.DateTimeFormat.formatRange requires two values");
	let n = uo(e), r = uo(t), i, a = [n, r];
	if (lo(n) !== lo(r)) throw TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
	if (lo(n)) {
		if (!fo(n, r)) throw TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
		let { epochNs: e, formatter: t } = po(n, this), { epochNs: o, formatter: s } = po(r, this);
		t && (i = t, a = [Wi(e, "floor"), Wi(o, "floor")]);
	}
	return i ||= j(this, Ce), i.formatRange(...a);
}
function Qa(e, t) {
	if (e === void 0 || t === void 0) throw TypeError("Intl.DateTimeFormat.formatRange requires two values");
	let n = uo(e), r = uo(t), i, a = [n, r];
	if (lo(n) !== lo(r)) throw TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
	if (lo(n)) {
		if (!fo(n, r)) throw TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
		let { epochNs: e, formatter: t } = po(n, this), { epochNs: o, formatter: s } = po(r, this);
		t && (i = t, a = [Wi(e, "floor"), Wi(o, "floor")]);
	}
	return i ||= j(this, Ce), i.formatRangeToParts(...a);
}
function $a(e = {}, t = {}) {
	let n = Object.assign({}, e), r = [
		"year",
		"month",
		"day",
		"hour",
		"minute",
		"second",
		"weekday",
		"dayPeriod",
		"timeZoneName",
		"dateStyle",
		"timeStyle"
	];
	for (let e = 0; e < r.length; e++) {
		let i = r[e];
		n[i] = i in t ? t[i] : n[i], !1 !== n[i] && n[i] !== void 0 || delete n[i];
	}
	return n;
}
function eo(e) {
	let t = $a(e, {
		year: !1,
		month: !1,
		day: !1,
		weekday: !1,
		timeZoneName: !1,
		dateStyle: !1
	});
	if (t.timeStyle !== "long" && t.timeStyle !== "full" || (delete t.timeStyle, Object.assign(t, {
		hour: "numeric",
		minute: "2-digit",
		second: "2-digit"
	})), !so(t)) {
		if (co(e)) throw TypeError(`cannot format Temporal.PlainTime with options [${Object.keys(e)}]`);
		Object.assign(t, {
			hour: "numeric",
			minute: "numeric",
			second: "numeric"
		});
	}
	return t;
}
function to(e) {
	let t = {
		short: {
			year: "2-digit",
			month: "numeric"
		},
		medium: {
			year: "numeric",
			month: "short"
		},
		long: {
			year: "numeric",
			month: "long"
		},
		full: {
			year: "numeric",
			month: "long"
		}
	}, n = $a(e, {
		day: !1,
		hour: !1,
		minute: !1,
		second: !1,
		weekday: !1,
		dayPeriod: !1,
		timeZoneName: !1,
		timeStyle: !1
	});
	if ("dateStyle" in n && n.dateStyle) {
		let e = n.dateStyle;
		delete n.dateStyle, Object.assign(n, t[e]);
	}
	if (!("year" in n || "month" in n || "era" in n)) {
		if (co(e)) throw TypeError(`cannot format PlainYearMonth with options [${Object.keys(e)}]`);
		Object.assign(n, {
			year: "numeric",
			month: "numeric"
		});
	}
	return n;
}
function no(e) {
	let t = {
		short: {
			month: "numeric",
			day: "numeric"
		},
		medium: {
			month: "short",
			day: "numeric"
		},
		long: {
			month: "long",
			day: "numeric"
		},
		full: {
			month: "long",
			day: "numeric"
		}
	}, n = $a(e, {
		year: !1,
		hour: !1,
		minute: !1,
		second: !1,
		weekday: !1,
		dayPeriod: !1,
		timeZoneName: !1,
		timeStyle: !1
	});
	if ("dateStyle" in n && n.dateStyle) {
		let e = n.dateStyle;
		delete n.dateStyle, Object.assign(n, t[e]);
	}
	if (!("month" in n) && !("day" in n)) {
		if (co(e)) throw TypeError(`cannot format PlainMonthDay with options [${Object.keys(e)}]`);
		Object.assign(n, {
			month: "numeric",
			day: "numeric"
		});
	}
	return n;
}
function ro(e) {
	let t = $a(e, {
		hour: !1,
		minute: !1,
		second: !1,
		dayPeriod: !1,
		timeZoneName: !1,
		timeStyle: !1
	});
	if (!oo(t)) {
		if (co(e)) throw TypeError(`cannot format PlainDate with options [${Object.keys(e)}]`);
		Object.assign(t, {
			year: "numeric",
			month: "numeric",
			day: "numeric"
		});
	}
	return t;
}
function io(e) {
	let t = $a(e, { timeZoneName: !1 });
	if ((t.timeStyle === "long" || t.timeStyle === "full") && (delete t.timeStyle, Object.assign(t, {
		hour: "numeric",
		minute: "2-digit",
		second: "2-digit"
	}), t.dateStyle) && (Object.assign(t, {
		short: {
			year: "numeric",
			month: "numeric",
			day: "numeric"
		},
		medium: {
			year: "numeric",
			month: "short",
			day: "numeric"
		},
		long: {
			year: "numeric",
			month: "long",
			day: "numeric"
		},
		full: {
			year: "numeric",
			month: "long",
			day: "numeric",
			weekday: "long"
		}
	}[t.dateStyle]), delete t.dateStyle), !so(t) && !oo(t)) {
		if (co(e)) throw TypeError(`cannot format PlainDateTime with options [${Object.keys(e)}]`);
		Object.assign(t, {
			year: "numeric",
			month: "numeric",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			second: "numeric"
		});
	}
	return t;
}
function ao(e) {
	let t = e;
	return so(t) || oo(t) || (t = Object.assign({}, t, {
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric"
	})), t;
}
function oo(e) {
	return "year" in e || "month" in e || "day" in e || "weekday" in e || "dateStyle" in e || "era" in e;
}
function so(e) {
	return "hour" in e || "minute" in e || "second" in e || "timeStyle" in e || "dayPeriod" in e || "fractionalSecondDigits" in e;
}
function co(e) {
	return oo(e) || so(e) || "dateStyle" in e || "timeStyle" in e || "timeZoneName" in e;
}
function lo(e) {
	return B(e) || V(e) || H(e) || W(e) || U(e) || Lt(e) || R(e);
}
function uo(e) {
	return lo(e) ? e : yt(e);
}
function fo(e, t) {
	return !(!lo(e) || !lo(t) || V(e) && !V(t) || B(e) && !B(t) || H(e) && !H(t) || W(e) && !W(t) || U(e) && !U(t) || Lt(e) && !Lt(t) || R(e) && !R(t));
}
function po(e, t) {
	if (V(e)) {
		let n = {
			isoDate: {
				year: 1970,
				month: 1,
				day: 1
			},
			time: j(e, E)
		};
		return {
			epochNs: X(j(t, we), n, "compatible"),
			formatter: Wa(t, be)
		};
	}
	if (U(e)) {
		let n = j(e, D), r = j(t, Ee);
		if (n !== r) throw RangeError(`cannot format PlainYearMonth with calendar ${n} in locale with calendar ${r}`);
		let i = q(j(e, w), {
			deltaDays: 0,
			hour: 12,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		});
		return {
			epochNs: X(j(t, we), i, "compatible"),
			formatter: Wa(t, ve)
		};
	}
	if (Lt(e)) {
		let n = j(e, D), r = j(t, Ee);
		if (n !== r) throw RangeError(`cannot format PlainMonthDay with calendar ${n} in locale with calendar ${r}`);
		let i = q(j(e, w), {
			deltaDays: 0,
			hour: 12,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		});
		return {
			epochNs: X(j(t, we), i, "compatible"),
			formatter: Wa(t, ye)
		};
	}
	if (B(e)) {
		let n = j(e, D), r = j(t, Ee);
		if (n !== "iso8601" && n !== r) throw RangeError(`cannot format PlainDate with calendar ${n} in locale with calendar ${r}`);
		let i = q(j(e, w), {
			deltaDays: 0,
			hour: 12,
			minute: 0,
			second: 0,
			millisecond: 0,
			microsecond: 0,
			nanosecond: 0
		});
		return {
			epochNs: X(j(t, we), i, "compatible"),
			formatter: Wa(t, _e)
		};
	}
	if (H(e)) {
		let n = j(e, D), r = j(t, Ee);
		if (n !== "iso8601" && n !== r) throw RangeError(`cannot format PlainDateTime with calendar ${n} in locale with calendar ${r}`);
		let i = j(e, T);
		return {
			epochNs: X(j(t, we), i, "compatible"),
			formatter: Wa(t, xe)
		};
	}
	if (W(e)) throw TypeError("Temporal.ZonedDateTime not supported in DateTimeFormat methods. Use toLocaleString() instead.");
	return R(e) ? {
		epochNs: j(e, C),
		formatter: Wa(t, Se)
	} : {};
}
function mo(e) {
	let t = Object.create(null);
	return t.years = j(e, le), t.months = j(e, ue), t.weeks = j(e, de), t.days = j(e, k), t.hours = j(e, A), t.minutes = j(e, fe), t.seconds = j(e, pe), t.milliseconds = j(e, me), t.microseconds = j(e, he), t.nanoseconds = j(e, ge), t;
}
Ka.prototype.constructor = qa, Object.defineProperty(qa, "prototype", {
	value: Ka.prototype,
	writable: !1,
	enumerable: !1,
	configurable: !1
}), qa.supportedLocalesOf = Ua.supportedLocalesOf, Ie(qa, "Intl.DateTimeFormat");
var { format: ho, formatToParts: go } = Intl.DurationFormat?.prototype ?? Object.create(null);
function _o(e) {
	Intl.DurationFormat.prototype.resolvedOptions.call(this);
	let t = mo(Sn(e));
	return ho.call(this, t);
}
Intl.DurationFormat?.prototype && (Intl.DurationFormat.prototype.format = _o, Intl.DurationFormat.prototype.formatToParts = function(e) {
	Intl.DurationFormat.prototype.resolvedOptions.call(this);
	let t = mo(Sn(e));
	return go.call(this, t);
}), Object.freeze({
	__proto__: null,
	DateTimeFormat: qa,
	ModifiedIntlDurationFormatPrototypeFormat: _o
});
var vo = class {
	constructor(e) {
		if (arguments.length < 1) throw TypeError("missing argument: epochNanoseconds is required");
		Bn(this, Ki(e));
	}
	get epochMilliseconds() {
		return G(this, R), Wi(j(this, C), "floor");
	}
	get epochNanoseconds() {
		return G(this, R), Ui(l.default.BigInt(j(this, C)));
	}
	add(e) {
		return G(this, R), Oi("add", this, e);
	}
	subtract(e) {
		return G(this, R), Oi("subtract", this, e);
	}
	until(e, t = void 0) {
		return G(this, R), vi("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, R), vi("since", this, e, t);
	}
	round(e) {
		if (G(this, R), e === void 0) throw TypeError("options parameter is required");
		let t = typeof e == "string" ? Xi("smallestUnit", e) : $(e), n = nn(t), r = $t(t, "halfExpand"), i = cn(t, "smallestUnit", "time", sn);
		return rn(n, {
			hour: 24,
			minute: 1440,
			second: 86400,
			millisecond: 864e5,
			microsecond: 864e8,
			nanosecond: 864e11
		}[i], !0), Vn(Fi(j(this, C), n, i, r));
	}
	equals(e) {
		G(this, R);
		let t = Cn(e), n = j(this, C), r = j(t, C);
		return l.default.equal(l.default.BigInt(n), l.default.BigInt(r));
	}
	toString(e = void 0) {
		G(this, R);
		let t = $(e), n = an(t), r = $t(t, "trunc"), i = cn(t, "smallestUnit", "time", void 0);
		if (i === "hour") throw RangeError("smallestUnit must be a time unit other than \"hour\"");
		let a = t.timeZone;
		a !== void 0 && (a = $n(a));
		let { precision: o, unit: s, increment: c } = on(i, n);
		return dr(Vn(Fi(j(this, C), c, s, r)), a, o);
	}
	toJSON() {
		return G(this, R), dr(this, void 0, "auto");
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, R), new qa(e, t).format(this);
	}
	valueOf() {
		ea("Instant");
	}
	toZonedDateTimeISO(e) {
		G(this, R);
		let t = $n(e);
		return Y(j(this, C), t, "iso8601");
	}
	static fromEpochMilliseconds(e) {
		return Vn(Gi(yt(e)));
	}
	static fromEpochNanoseconds(e) {
		return Vn(Ki(e));
	}
	static from(e) {
		return Cn(e);
	}
	static compare(e, t) {
		let n = Cn(e), r = Cn(t), i = j(n, C), a = j(r, C);
		return l.default.lessThan(i, a) ? -1 : +!!l.default.greaterThan(i, a);
	}
};
Ie(vo, "Temporal.Instant");
var yo = class {
	constructor(e, t, n, r = "iso8601") {
		let i = I(e), a = I(t), o = I(n), s = Qi(r === void 0 ? "iso8601" : L(r));
		Kr(i, a, o), An(this, {
			year: i,
			month: a,
			day: o
		}, s);
	}
	get calendarId() {
		return G(this, B), j(this, D);
	}
	get era() {
		return bo(this, "era");
	}
	get eraYear() {
		return bo(this, "eraYear");
	}
	get year() {
		return bo(this, "year");
	}
	get month() {
		return bo(this, "month");
	}
	get monthCode() {
		return bo(this, "monthCode");
	}
	get day() {
		return bo(this, "day");
	}
	get dayOfWeek() {
		return bo(this, "dayOfWeek");
	}
	get dayOfYear() {
		return bo(this, "dayOfYear");
	}
	get weekOfYear() {
		return bo(this, "weekOfYear")?.week;
	}
	get yearOfWeek() {
		return bo(this, "weekOfYear")?.year;
	}
	get daysInWeek() {
		return bo(this, "daysInWeek");
	}
	get daysInMonth() {
		return bo(this, "daysInMonth");
	}
	get daysInYear() {
		return bo(this, "daysInYear");
	}
	get monthsInYear() {
		return bo(this, "monthsInYear");
	}
	get inLeapYear() {
		return bo(this, "inLeapYear");
	}
	with(e, t = void 0) {
		if (G(this, B), !F(e)) throw TypeError("invalid argument");
		Rt(e);
		let n = j(this, D), r = gn(n, j(this, w));
		return r = Wn(n, r, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [], "partial")), jn(Xn(n, r, J($(t))), n);
	}
	withCalendar(e) {
		G(this, B);
		let t = qn(e);
		return jn(j(this, w), t);
	}
	add(e, t = void 0) {
		return G(this, B), ki("add", this, e, t);
	}
	subtract(e, t = void 0) {
		return G(this, B), ki("subtract", this, e, t);
	}
	until(e, t = void 0) {
		return G(this, B), yi("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, B), yi("since", this, e, t);
	}
	equals(e) {
		G(this, B);
		let t = yn(e);
		return Bi(j(this, w), j(t, w)) === 0 && Yn(j(this, D), j(t, D));
	}
	toString(e = void 0) {
		return G(this, B), pr(this, tn($(e)));
	}
	toJSON() {
		return G(this, B), pr(this);
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, B), new qa(e, t).format(this);
	}
	valueOf() {
		ea("PlainDate");
	}
	toPlainDateTime(e = void 0) {
		G(this, B);
		let t = En(e);
		return Nn(q(j(this, w), t), j(this, D));
	}
	toZonedDateTime(e) {
		let t, n;
		if (G(this, B), F(e)) {
			let r = e.timeZone;
			r === void 0 ? t = $n(e) : (t = $n(r), n = e.plainTime);
		} else t = $n(e);
		let r = j(this, w), i;
		return n === void 0 ? i = or(t, r) : (n = Tn(n), i = X(t, q(r, j(n, E)), "compatible")), Y(i, t, j(this, D));
	}
	toPlainYearMonth() {
		G(this, B);
		let e = j(this, D);
		return zn(Zn(e, gn(e, j(this, w)), "constrain"), e);
	}
	toPlainMonthDay() {
		G(this, B);
		let e = j(this, D);
		return Fn(Qn(e, gn(e, j(this, w)), "constrain"), e);
	}
	static from(e, t = void 0) {
		return yn(e, t);
	}
	static compare(e, t) {
		let n = yn(e), r = yn(t);
		return Bi(j(n, w), j(r, w));
	}
};
function bo(e, t) {
	G(e, B);
	let n = j(e, w);
	return hn(e).isoToDate(n, { [t]: !0 })[t];
}
Ie(yo, "Temporal.PlainDate");
var xo = class {
	constructor(e, t, n, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = "iso8601") {
		let u = I(e), d = I(t), f = I(n), p = r === void 0 ? 0 : I(r), m = i === void 0 ? 0 : I(i), h = a === void 0 ? 0 : I(a), g = o === void 0 ? 0 : I(o), _ = s === void 0 ? 0 : I(s), v = c === void 0 ? 0 : I(c), y = Qi(l === void 0 ? "iso8601" : L(l));
		Yr(u, d, f, p, m, h, g, _, v), Mn(this, {
			isoDate: {
				year: u,
				month: d,
				day: f
			},
			time: {
				hour: p,
				minute: m,
				second: h,
				millisecond: g,
				microsecond: _,
				nanosecond: v
			}
		}, y);
	}
	get calendarId() {
		return G(this, H), j(this, D);
	}
	get year() {
		return So(this, "year");
	}
	get month() {
		return So(this, "month");
	}
	get monthCode() {
		return So(this, "monthCode");
	}
	get day() {
		return So(this, "day");
	}
	get hour() {
		return Co(this, "hour");
	}
	get minute() {
		return Co(this, "minute");
	}
	get second() {
		return Co(this, "second");
	}
	get millisecond() {
		return Co(this, "millisecond");
	}
	get microsecond() {
		return Co(this, "microsecond");
	}
	get nanosecond() {
		return Co(this, "nanosecond");
	}
	get era() {
		return So(this, "era");
	}
	get eraYear() {
		return So(this, "eraYear");
	}
	get dayOfWeek() {
		return So(this, "dayOfWeek");
	}
	get dayOfYear() {
		return So(this, "dayOfYear");
	}
	get weekOfYear() {
		return So(this, "weekOfYear")?.week;
	}
	get yearOfWeek() {
		return So(this, "weekOfYear")?.year;
	}
	get daysInWeek() {
		return So(this, "daysInWeek");
	}
	get daysInYear() {
		return So(this, "daysInYear");
	}
	get daysInMonth() {
		return So(this, "daysInMonth");
	}
	get monthsInYear() {
		return So(this, "monthsInYear");
	}
	get inLeapYear() {
		return So(this, "inLeapYear");
	}
	with(e, t = void 0) {
		if (G(this, H), !F(e)) throw TypeError("invalid argument");
		Rt(e);
		let n = j(this, D), r = j(this, T), i = {
			...gn(n, r.isoDate),
			...r.time
		};
		return i = Wn(n, i, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [
			"hour",
			"minute",
			"second",
			"millisecond",
			"microsecond",
			"nanosecond"
		], "partial")), Nn(bn(n, i, J($(t))), n);
	}
	withPlainTime(e = void 0) {
		G(this, H);
		let t = En(e);
		return Nn(q(j(this, T).isoDate, t), j(this, D));
	}
	withCalendar(e) {
		G(this, H);
		let t = qn(e);
		return Nn(j(this, T), t);
	}
	add(e, t = void 0) {
		return G(this, H), Ai("add", this, e, t);
	}
	subtract(e, t = void 0) {
		return G(this, H), Ai("subtract", this, e, t);
	}
	until(e, t = void 0) {
		return G(this, H), bi("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, H), bi("since", this, e, t);
	}
	round(e) {
		if (G(this, H), e === void 0) throw TypeError("options parameter is required");
		let t = typeof e == "string" ? Xi("smallestUnit", e) : $(e), n = nn(t), r = $t(t, "halfExpand"), i = cn(t, "smallestUnit", "time", sn, ["day"]), a = {
			day: 1,
			hour: 24,
			minute: 60,
			second: 60,
			millisecond: 1e3,
			microsecond: 1e3,
			nanosecond: 1e3
		}[i];
		rn(n, a, a === 1);
		let o = j(this, T);
		return Nn(n === 1 && i === "nanosecond" ? o : Ii(o, n, i, r), j(this, D));
	}
	equals(e) {
		G(this, H);
		let t = xn(e);
		return Hi(j(this, T), j(t, T)) === 0 && Yn(j(this, D), j(t, D));
	}
	toString(e = void 0) {
		G(this, H);
		let t = $(e), n = tn(t), r = an(t), i = $t(t, "trunc"), a = cn(t, "smallestUnit", "time", void 0);
		if (a === "hour") throw RangeError("smallestUnit must be a time unit other than \"hour\"");
		let { precision: o, unit: s, increment: c } = on(a, r), l = Ii(j(this, T), c, s, i);
		return Xr(l), hr(l, j(this, D), o, n);
	}
	toJSON() {
		return G(this, H), hr(j(this, T), j(this, D), "auto");
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, H), new qa(e, t).format(this);
	}
	valueOf() {
		ea("PlainDateTime");
	}
	toZonedDateTime(e, t = void 0) {
		G(this, H);
		let n = $n(e), r = Qt($(t));
		return Y(X(n, j(this, T), r), n, j(this, D));
	}
	toPlainDate() {
		return G(this, H), jn(j(this, T).isoDate, j(this, D));
	}
	toPlainTime() {
		return G(this, H), Ln(j(this, T).time);
	}
	static from(e, t = void 0) {
		return xn(e, t);
	}
	static compare(e, t) {
		let n = xn(e), r = xn(t);
		return Hi(j(n, T), j(r, T));
	}
};
function So(e, t) {
	G(e, H);
	let n = j(e, T).isoDate;
	return hn(e).isoToDate(n, { [t]: !0 })[t];
}
function Co(e, t) {
	return G(e, H), j(e, T).time[t];
}
Ie(xo, "Temporal.PlainDateTime");
var wo = class e {
	constructor(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0) {
		let u = e === void 0 ? 0 : St(e), d = t === void 0 ? 0 : St(t), f = n === void 0 ? 0 : St(n), p = r === void 0 ? 0 : St(r), m = i === void 0 ? 0 : St(i), h = a === void 0 ? 0 : St(a), g = o === void 0 ? 0 : St(o), _ = s === void 0 ? 0 : St(s), v = c === void 0 ? 0 : St(c), y = l === void 0 ? 0 : St(l);
		ei(u, d, f, p, m, h, g, _, v, y), Ne(this), M(this, le, u), M(this, ue, d), M(this, de, f), M(this, k, p), M(this, A, m), M(this, fe, h), M(this, pe, g), M(this, me, _), M(this, he, v), M(this, ge, y);
	}
	get years() {
		return G(this, z), j(this, le);
	}
	get months() {
		return G(this, z), j(this, ue);
	}
	get weeks() {
		return G(this, z), j(this, de);
	}
	get days() {
		return G(this, z), j(this, k);
	}
	get hours() {
		return G(this, z), j(this, A);
	}
	get minutes() {
		return G(this, z), j(this, fe);
	}
	get seconds() {
		return G(this, z), j(this, pe);
	}
	get milliseconds() {
		return G(this, z), j(this, me);
	}
	get microseconds() {
		return G(this, z), j(this, he);
	}
	get nanoseconds() {
		return G(this, z), j(this, ge);
	}
	get sign() {
		return G(this, z), Fr(this);
	}
	get blank() {
		return G(this, z), Fr(this) === 0;
	}
	with(t) {
		G(this, z);
		let { years: n = j(this, le), months: r = j(this, ue), weeks: i = j(this, de), days: a = j(this, k), hours: o = j(this, A), minutes: s = j(this, fe), seconds: c = j(this, pe), milliseconds: l = j(this, me), microseconds: u = j(this, he), nanoseconds: d = j(this, ge) } = Zt(t);
		return new e(n, r, i, a, o, s, c, l, u, d);
	}
	negated() {
		return G(this, z), Ur(this);
	}
	abs() {
		return G(this, z), new e(Math.abs(j(this, le)), Math.abs(j(this, ue)), Math.abs(j(this, de)), Math.abs(j(this, k)), Math.abs(j(this, A)), Math.abs(j(this, fe)), Math.abs(j(this, pe)), Math.abs(j(this, me)), Math.abs(j(this, he)), Math.abs(j(this, ge)));
	}
	add(e) {
		return G(this, z), Di("add", this, e);
	}
	subtract(e) {
		return G(this, z), Di("subtract", this, e);
	}
	round(e) {
		if (G(this, z), e === void 0) throw TypeError("options parameter is required");
		let t = un(this), n = typeof e == "string" ? Xi("smallestUnit", e) : $(e), r = cn(n, "largestUnit", "datetime", void 0, ["auto"]), { plainRelativeTo: i, zonedRelativeTo: a } = ln(n), o = nn(n), s = $t(n, "halfExpand"), c = cn(n, "smallestUnit", "datetime", void 0), l = !0;
		c ||= (l = !1, "nanosecond");
		let u = dn(t, c), d = !0;
		if (r ||= (d = !1, u), r === "auto" && (r = u), !l && !d) throw RangeError("at least one of smallestUnit or largestUnit is required");
		if (dn(r, c) !== r) throw RangeError(`largestUnit ${r} cannot be smaller than smallestUnit ${c}`);
		let f = {
			hour: 24,
			minute: 60,
			second: 60,
			millisecond: 1e3,
			microsecond: 1e3,
			nanosecond: 1e3
		}[c];
		if (f !== void 0 && rn(o, f, !1), o > 1 && pn(c) === "date" && r !== c) throw RangeError("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit");
		if (a) {
			let e = ti(this), t = j(a, O), n = j(a, D), i = j(a, C);
			return e = gi(i, Ei(i, t, n, e), t, n, r, o, c, s), pn(r) === "date" && (r = "hour"), ii(e, r);
		}
		if (i) {
			let e = ni(this), t = wi({
				deltaDays: 0,
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0,
				microsecond: 0,
				nanosecond: 0
			}, e.time), n = j(i, w), a = j(i, D), l = Gn(a, n, K(e.date, t.deltaDays), "constrain");
			return e = hi(q(n, {
				deltaDays: 0,
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0,
				microsecond: 0,
				nanosecond: 0
			}), q(l, t), a, r, o, c, s), ii(e, r);
		}
		if (fn(t)) throw RangeError(`a starting point is required for ${t}s balancing`);
		if (fn(r)) throw RangeError(`a starting point is required for ${r}s balancing`);
		let p = ni(this);
		if (c === "day") {
			let { quotient: e, remainder: t } = p.time.divmod(ot), n = p.date.days + e + zi(t, "day");
			n = Pi(n, o, s), p = ai({
				years: 0,
				months: 0,
				weeks: 0,
				days: n
			}, P.ZERO);
		} else p = ai({
			years: 0,
			months: 0,
			weeks: 0,
			days: 0
		}, Ri(p.time, o, c, s));
		return ii(p, r);
	}
	total(e) {
		if (G(this, z), e === void 0) throw TypeError("options argument is required");
		let t = typeof e == "string" ? Xi("unit", e) : $(e), { plainRelativeTo: n, zonedRelativeTo: r } = ln(t), i = cn(t, "unit", "datetime", sn);
		if (r) {
			let e = ti(this), t = j(r, O), n = j(r, D), a = j(r, C);
			return function(e, t, n, r, i) {
				return pn(i) === "time" ? zi(P.fromEpochNsDiff(t, e), i) : mi(di(e, t, n, r, i), t, rr(n, e), n, r, i);
			}(a, Ei(a, t, n, e), t, n, i);
		}
		if (n) {
			let e = ni(this), t = wi({
				deltaDays: 0,
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0,
				microsecond: 0,
				nanosecond: 0
			}, e.time), r = j(n, w), a = j(n, D), o = Gn(a, r, K(e.date, t.deltaDays), "constrain");
			return function(e, t, n, r) {
				if (Hi(e, t) == 0) return 0;
				Xr(e), Xr(t);
				let i = ui(e, t, n, r);
				return r === "nanosecond" ? l.default.toNumber(i.time.totalNs) : mi(i, Z(t), e, null, n, r);
			}(q(r, {
				deltaDays: 0,
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0,
				microsecond: 0,
				nanosecond: 0
			}), q(o, t), a, i);
		}
		let a = un(this);
		if (fn(a)) throw RangeError(`a starting point is required for ${a}s total`);
		if (fn(i)) throw RangeError(`a starting point is required for ${i}s total`);
		return zi(ni(this).time, i);
	}
	toString(e = void 0) {
		G(this, z);
		let t = $(e), n = an(t), r = $t(t, "trunc"), i = cn(t, "smallestUnit", "time", void 0);
		if (i === "hour" || i === "minute") throw RangeError("smallestUnit must be a time unit other than \"hours\" or \"minutes\"");
		let { precision: a, unit: o, increment: s } = on(i, n);
		if (o === "nanosecond" && s === 1) return fr(this, a);
		let c = un(this), l = ti(this), u = Ri(l.time, s, o, r);
		return l = ai(l.date, u), fr(ii(l, dn(c, "second")), a);
	}
	toJSON() {
		return G(this, z), fr(this, "auto");
	}
	toLocaleString(e = void 0, t = void 0) {
		if (G(this, z), typeof Intl.DurationFormat == "function") {
			let n = new Intl.DurationFormat(e, t);
			return _o.call(n, this);
		}
		return console.warn("Temporal.Duration.prototype.toLocaleString() requires Intl.DurationFormat."), fr(this, "auto");
	}
	valueOf() {
		ea("Duration");
	}
	static from(e) {
		return Sn(e);
	}
	static compare(e, t, n = void 0) {
		let r = Sn(e), i = Sn(t), { plainRelativeTo: a, zonedRelativeTo: o } = ln($(n));
		if (j(r, le) === j(i, le) && j(r, ue) === j(i, ue) && j(r, de) === j(i, de) && j(r, k) === j(i, k) && j(r, A) === j(i, A) && j(r, fe) === j(i, fe) && j(r, pe) === j(i, pe) && j(r, me) === j(i, me) && j(r, he) === j(i, he) && j(r, ge) === j(i, ge)) return 0;
		let s = un(r), c = un(i), u = ti(r), d = ti(i);
		if (o && (pn(s) === "date" || pn(c) === "date")) {
			let e = j(o, O), t = j(o, D), n = j(o, C), r = Ei(n, e, t, u), i = Ei(n, e, t, d);
			return Yi(l.default.toNumber(l.default.subtract(r, i)));
		}
		let f = u.date.days, p = d.date.days;
		if (fn(s) || fn(c)) {
			if (!a) throw RangeError("A starting point is required for years, months, or weeks comparison");
			f = Hr(u.date, a), p = Hr(d.date, a);
		}
		let m = u.time.add24HourDays(f), h = d.time.add24HourDays(p);
		return m.cmp(h);
	}
};
Ie(wo, "Temporal.Duration");
var To = class {
	constructor(e, t, n = "iso8601", r = 1972) {
		let i = I(e), a = I(t), o = Qi(n === void 0 ? "iso8601" : L(n)), s = I(r);
		Kr(s, i, a), Pn(this, {
			year: s,
			month: i,
			day: a
		}, o);
	}
	get monthCode() {
		return Eo(this, "monthCode");
	}
	get day() {
		return Eo(this, "day");
	}
	get calendarId() {
		return G(this, Lt), j(this, D);
	}
	with(e, t = void 0) {
		if (G(this, Lt), !F(e)) throw TypeError("invalid argument");
		Rt(e);
		let n = j(this, D), r = gn(n, j(this, w), "month-day");
		return r = Wn(n, r, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [], "partial")), Fn(Qn(n, r, J($(t))), n);
	}
	equals(e) {
		G(this, Lt);
		let t = wn(e);
		return Bi(j(this, w), j(t, w)) === 0 && Yn(j(this, D), j(t, D));
	}
	toString(e = void 0) {
		return G(this, Lt), gr(this, tn($(e)));
	}
	toJSON() {
		return G(this, Lt), gr(this);
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, Lt), new qa(e, t).format(this);
	}
	valueOf() {
		ea("PlainMonthDay");
	}
	toPlainDate(e) {
		if (G(this, Lt), !F(e)) throw TypeError("argument should be an object");
		let t = j(this, D);
		return jn(Xn(t, Wn(t, gn(t, j(this, w), "month-day"), _n(t, e, ["year"], [], [])), "constrain"), t);
	}
	static from(e, t = void 0) {
		return wn(e, t);
	}
};
function Eo(e, t) {
	G(e, Lt);
	let n = j(e, w);
	return hn(e).isoToDate(n, { [t]: !0 })[t];
}
function Do(e) {
	return rr(e, qi());
}
Ie(To, "Temporal.PlainMonthDay");
var Oo = {
	instant: () => Vn(qi()),
	plainDateTimeISO: (e = Ji()) => Nn(Do($n(e)), "iso8601"),
	plainDateISO: (e = Ji()) => jn(Do($n(e)).isoDate, "iso8601"),
	plainTimeISO: (e = Ji()) => Ln(Do($n(e)).time),
	timeZoneId: () => Ji(),
	zonedDateTimeISO: (e = Ji()) => {
		let t = $n(e);
		return Y(qi(), t, "iso8601");
	},
	[Symbol.toStringTag]: "Temporal.Now"
};
Object.defineProperty(Oo, Symbol.toStringTag, {
	value: "Temporal.Now",
	writable: !1,
	enumerable: !1,
	configurable: !0
});
var ko = class e {
	constructor(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0) {
		let o = e === void 0 ? 0 : I(e), s = t === void 0 ? 0 : I(t), c = n === void 0 ? 0 : I(n), l = r === void 0 ? 0 : I(r), u = i === void 0 ? 0 : I(i), d = a === void 0 ? 0 : I(a);
		Jr(o, s, c, l, u, d), In(this, {
			hour: o,
			minute: s,
			second: c,
			millisecond: l,
			microsecond: u,
			nanosecond: d
		});
	}
	get hour() {
		return G(this, V), j(this, E).hour;
	}
	get minute() {
		return G(this, V), j(this, E).minute;
	}
	get second() {
		return G(this, V), j(this, E).second;
	}
	get millisecond() {
		return G(this, V), j(this, E).millisecond;
	}
	get microsecond() {
		return G(this, V), j(this, E).microsecond;
	}
	get nanosecond() {
		return G(this, V), j(this, E).nanosecond;
	}
	with(t, n = void 0) {
		if (G(this, V), !F(t)) throw TypeError("invalid argument");
		Rt(t);
		let r = vn(t, "partial"), i = vn(this), { hour: a, minute: o, second: s, millisecond: c, microsecond: l, nanosecond: u } = Object.assign(i, r), d = J($(n));
		return {hour: a, minute: o, second: s, millisecond: c, microsecond: l, nanosecond: u} = Xt(a, o, s, c, l, u, d), new e(a, o, s, c, l, u);
	}
	add(e) {
		return G(this, V), ji("add", this, e);
	}
	subtract(e) {
		return G(this, V), ji("subtract", this, e);
	}
	until(e, t = void 0) {
		return G(this, V), xi("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, V), xi("since", this, e, t);
	}
	round(e) {
		if (G(this, V), e === void 0) throw TypeError("options parameter is required");
		let t = typeof e == "string" ? Xi("smallestUnit", e) : $(e), n = nn(t), r = $t(t, "halfExpand"), i = cn(t, "smallestUnit", "time", sn);
		return rn(n, {
			hour: 24,
			minute: 60,
			second: 60,
			millisecond: 1e3,
			microsecond: 1e3,
			nanosecond: 1e3
		}[i], !1), Ln(Li(j(this, E), n, i, r));
	}
	equals(e) {
		G(this, V);
		let t = Tn(e);
		return Vi(j(this, E), j(t, E)) === 0;
	}
	toString(e = void 0) {
		G(this, V);
		let t = $(e), n = an(t), r = $t(t, "trunc"), i = cn(t, "smallestUnit", "time", void 0);
		if (i === "hour") throw RangeError("smallestUnit must be a time unit other than \"hour\"");
		let { precision: a, unit: o, increment: s } = on(i, n);
		return mr(Li(j(this, E), s, o, r), a);
	}
	toJSON() {
		return G(this, V), mr(j(this, E), "auto");
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, V), new qa(e, t).format(this);
	}
	valueOf() {
		ea("PlainTime");
	}
	static from(e, t = void 0) {
		return Tn(e, t);
	}
	static compare(e, t) {
		let n = Tn(e), r = Tn(t);
		return Vi(j(n, E), j(r, E));
	}
};
Ie(ko, "Temporal.PlainTime");
var Ao = class {
	constructor(e, t, n = "iso8601", r = 1) {
		let i = I(e), a = I(t), o = Qi(n === void 0 ? "iso8601" : L(n)), s = I(r);
		Kr(i, a, s), Rn(this, {
			year: i,
			month: a,
			day: s
		}, o);
	}
	get year() {
		return jo(this, "year");
	}
	get month() {
		return jo(this, "month");
	}
	get monthCode() {
		return jo(this, "monthCode");
	}
	get calendarId() {
		return G(this, U), j(this, D);
	}
	get era() {
		return jo(this, "era");
	}
	get eraYear() {
		return jo(this, "eraYear");
	}
	get daysInMonth() {
		return jo(this, "daysInMonth");
	}
	get daysInYear() {
		return jo(this, "daysInYear");
	}
	get monthsInYear() {
		return jo(this, "monthsInYear");
	}
	get inLeapYear() {
		return jo(this, "inLeapYear");
	}
	with(e, t = void 0) {
		if (G(this, U), !F(e)) throw TypeError("invalid argument");
		Rt(e);
		let n = j(this, D), r = gn(n, j(this, w), "year-month");
		return r = Wn(n, r, _n(n, e, [
			"year",
			"month",
			"monthCode"
		], [], "partial")), zn(Zn(n, r, J($(t))), n);
	}
	add(e, t = void 0) {
		return G(this, U), Mi("add", this, e, t);
	}
	subtract(e, t = void 0) {
		return G(this, U), Mi("subtract", this, e, t);
	}
	until(e, t = void 0) {
		return G(this, U), Si("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, U), Si("since", this, e, t);
	}
	equals(e) {
		G(this, U);
		let t = Dn(e);
		return Bi(j(this, w), j(t, w)) === 0 && Yn(j(this, D), j(t, D));
	}
	toString(e = void 0) {
		return G(this, U), _r(this, tn($(e)));
	}
	toJSON() {
		return G(this, U), _r(this);
	}
	toLocaleString(e = void 0, t = void 0) {
		return G(this, U), new qa(e, t).format(this);
	}
	valueOf() {
		ea("PlainYearMonth");
	}
	toPlainDate(e) {
		if (G(this, U), !F(e)) throw TypeError("argument should be an object");
		let t = j(this, D);
		return jn(Xn(t, Wn(t, gn(t, j(this, w), "year-month"), _n(t, e, ["day"], [], [])), "constrain"), t);
	}
	static from(e, t = void 0) {
		return Dn(e, t);
	}
	static compare(e, t) {
		let n = Dn(e), r = Dn(t);
		return Bi(j(n, w), j(r, w));
	}
};
function jo(e, t) {
	G(e, U);
	let n = j(e, w);
	return hn(e).isoToDate(n, { [t]: !0 })[t];
}
Ie(Ao, "Temporal.PlainYearMonth");
var Mo = qa.prototype.resolvedOptions, No = class {
	constructor(e, t, n = "iso8601") {
		if (arguments.length < 1) throw TypeError("missing argument: epochNanoseconds is required");
		let r = Ki(e), i = L(t), { tzName: a, offsetMinutes: o } = Jt(i);
		if (o === void 0) {
			let e = Cr(a);
			if (!e) throw RangeError(`unknown time zone ${a}`);
			i = e.identifier;
		} else i = Er(o);
		Hn(this, r, i, Qi(n === void 0 ? "iso8601" : L(n)));
	}
	get calendarId() {
		return G(this, W), j(this, D);
	}
	get timeZoneId() {
		return G(this, W), j(this, O);
	}
	get year() {
		return Fo(this, "year");
	}
	get month() {
		return Fo(this, "month");
	}
	get monthCode() {
		return Fo(this, "monthCode");
	}
	get day() {
		return Fo(this, "day");
	}
	get hour() {
		return Io(this, "hour");
	}
	get minute() {
		return Io(this, "minute");
	}
	get second() {
		return Io(this, "second");
	}
	get millisecond() {
		return Io(this, "millisecond");
	}
	get microsecond() {
		return Io(this, "microsecond");
	}
	get nanosecond() {
		return Io(this, "nanosecond");
	}
	get era() {
		return Fo(this, "era");
	}
	get eraYear() {
		return Fo(this, "eraYear");
	}
	get epochMilliseconds() {
		return G(this, W), Wi(j(this, C), "floor");
	}
	get epochNanoseconds() {
		return G(this, W), Ui(j(this, C));
	}
	get dayOfWeek() {
		return Fo(this, "dayOfWeek");
	}
	get dayOfYear() {
		return Fo(this, "dayOfYear");
	}
	get weekOfYear() {
		return Fo(this, "weekOfYear")?.week;
	}
	get yearOfWeek() {
		return Fo(this, "weekOfYear")?.year;
	}
	get hoursInDay() {
		G(this, W);
		let e = j(this, O), t = Po(this).isoDate, n = zr(t.year, t.month, t.day + 1), r = or(e, t), i = or(e, n);
		return zi(P.fromEpochNsDiff(i, r), "hour");
	}
	get daysInWeek() {
		return Fo(this, "daysInWeek");
	}
	get daysInMonth() {
		return Fo(this, "daysInMonth");
	}
	get daysInYear() {
		return Fo(this, "daysInYear");
	}
	get monthsInYear() {
		return Fo(this, "monthsInYear");
	}
	get inLeapYear() {
		return Fo(this, "inLeapYear");
	}
	get offset() {
		return G(this, W), nr(tr(j(this, O), j(this, C)));
	}
	get offsetNanoseconds() {
		return G(this, W), tr(j(this, O), j(this, C));
	}
	with(e, t = void 0) {
		if (G(this, W), !F(e)) throw TypeError("invalid zoned-date-time-like");
		Rt(e);
		let n = j(this, D), r = j(this, O), i = tr(r, j(this, C)), a = Po(this), o = {
			...gn(n, a.isoDate),
			...a.time,
			offset: nr(i)
		};
		o = Wn(n, o, _n(n, e, [
			"year",
			"month",
			"monthCode",
			"day"
		], [
			"hour",
			"minute",
			"second",
			"millisecond",
			"microsecond",
			"nanosecond",
			"offset"
		], "partial"));
		let s = $(t), c = Qt(s), l = en(s, "prefer"), u = bn(n, o, J(s)), d = br(o.offset);
		return Y(On(u.isoDate, u.time, "option", d, r, c, l, !1), r, n);
	}
	withPlainTime(e = void 0) {
		G(this, W);
		let t = j(this, O), n = j(this, D), r = Po(this).isoDate, i;
		return i = e === void 0 ? or(t, r) : X(t, q(r, j(Tn(e), E)), "compatible"), Y(i, t, n);
	}
	withTimeZone(e) {
		G(this, W);
		let t = $n(e);
		return Y(j(this, C), t, j(this, D));
	}
	withCalendar(e) {
		G(this, W);
		let t = qn(e);
		return Y(j(this, C), j(this, O), t);
	}
	add(e, t = void 0) {
		return G(this, W), Ni("add", this, e, t);
	}
	subtract(e, t = void 0) {
		return G(this, W), Ni("subtract", this, e, t);
	}
	until(e, t = void 0) {
		return G(this, W), Ci("until", this, e, t);
	}
	since(e, t = void 0) {
		return G(this, W), Ci("since", this, e, t);
	}
	round(e) {
		if (G(this, W), e === void 0) throw TypeError("options parameter is required");
		let t = typeof e == "string" ? Xi("smallestUnit", e) : $(e), n = nn(t), r = $t(t, "halfExpand"), i = cn(t, "smallestUnit", "time", sn, ["day"]), a = {
			day: 1,
			hour: 24,
			minute: 60,
			second: 60,
			millisecond: 1e3,
			microsecond: 1e3,
			nanosecond: 1e3
		}[i];
		if (rn(n, a, a === 1), i === "nanosecond" && n === 1) return Y(j(this, C), j(this, O), j(this, D));
		let o = j(this, O), s = j(this, C), c = Po(this), u;
		if (i === "day") {
			let e = c.isoDate, t = zr(e.year, e.month, e.day + 1), n = or(o, e), i = or(o, t), a = l.default.subtract(i, n);
			u = P.fromEpochNsDiff(s, n).round(a, r).addToEpochNs(n);
		} else {
			let e = Ii(c, n, i, r), t = tr(o, s);
			u = On(e.isoDate, e.time, "option", t, o, "compatible", "prefer", !1);
		}
		return Y(u, o, j(this, D));
	}
	equals(e) {
		G(this, W);
		let t = kn(e), n = j(this, C), r = j(t, C);
		return !!l.default.equal(l.default.BigInt(n), l.default.BigInt(r)) && !!er(j(this, O), j(t, O)) && Yn(j(this, D), j(t, D));
	}
	toString(e = void 0) {
		G(this, W);
		let t = $(e), n = tn(t), r = an(t), i = function(e) {
			return Zi(e, "offset", ["auto", "never"], "auto");
		}(t), a = $t(t, "trunc"), o = cn(t, "smallestUnit", "time", void 0);
		if (o === "hour") throw RangeError("smallestUnit must be a time unit other than \"hour\"");
		let s = function(e) {
			return Zi(e, "timeZoneName", [
				"auto",
				"never",
				"critical"
			], "auto");
		}(t), { precision: c, unit: l, increment: u } = on(o, r);
		return vr(this, c, n, s, i, {
			unit: l,
			increment: u,
			roundingMode: a
		});
	}
	toLocaleString(e = void 0, t = void 0) {
		G(this, W);
		let n = $(t), r = Object.create(null);
		if (function(e, t, n, r) {
			if (t == null) return;
			let i = Reflect.ownKeys(t);
			for (let r = 0; r < i.length; r++) {
				let a = i[r];
				!n.some(((e) => Object.is(e, a))) && Object.prototype.propertyIsEnumerable.call(t, a) && (e[a] = t[a]);
			}
		}(r, n, ["timeZone"]), n.timeZone !== void 0) throw TypeError("ZonedDateTime toLocaleString does not accept a timeZone option");
		if (r.year === void 0 && r.month === void 0 && r.day === void 0 && r.era === void 0 && r.weekday === void 0 && r.dateStyle === void 0 && r.hour === void 0 && r.minute === void 0 && r.second === void 0 && r.fractionalSecondDigits === void 0 && r.timeStyle === void 0 && r.dayPeriod === void 0 && r.timeZoneName === void 0 && (r.timeZoneName = "short"), r.timeZone = j(this, O), yr(r.timeZone)) throw RangeError("toLocaleString does not currently support offset time zones");
		let i = new qa(e, r), a = Mo.call(i).calendar, o = j(this, D);
		if (o !== "iso8601" && a !== "iso8601" && !Yn(a, o)) throw RangeError(`cannot format ZonedDateTime with calendar ${o} in locale with calendar ${a}`);
		return i.format(Vn(j(this, C)));
	}
	toJSON() {
		return G(this, W), vr(this, "auto");
	}
	valueOf() {
		ea("ZonedDateTime");
	}
	startOfDay() {
		G(this, W);
		let e = j(this, O);
		return Y(or(e, Po(this).isoDate), e, j(this, D));
	}
	getTimeZoneTransition(e) {
		G(this, W);
		let t = j(this, O);
		if (e === void 0) throw TypeError("options parameter is required");
		let n = Zi(typeof e == "string" ? Xi("direction", e) : $(e), "direction", ["next", "previous"], sn);
		if (n === void 0) throw TypeError("direction option is required");
		if (yr(t) || t === "UTC") return null;
		let r = j(this, C), i = n === "next" ? Ar(t, r) : jr(t, r);
		return i === null ? null : Y(i, t, j(this, D));
	}
	toInstant() {
		return G(this, W), Vn(j(this, C));
	}
	toPlainDate() {
		return G(this, W), jn(Po(this).isoDate, j(this, D));
	}
	toPlainTime() {
		return G(this, W), Ln(Po(this).time);
	}
	toPlainDateTime() {
		return G(this, W), Nn(Po(this), j(this, D));
	}
	static from(e, t = void 0) {
		return kn(e, t);
	}
	static compare(e, t) {
		let n = kn(e), r = kn(t), i = j(n, C), a = j(r, C);
		return l.default.lessThan(l.default.BigInt(i), l.default.BigInt(a)) ? -1 : +!!l.default.greaterThan(l.default.BigInt(i), l.default.BigInt(a));
	}
};
function Po(e) {
	return rr(j(e, O), j(e, C));
}
function Fo(e, t) {
	G(e, W);
	let n = Po(e).isoDate;
	return hn(e).isoToDate(n, { [t]: !0 })[t];
}
function Io(e, t) {
	return G(e, W), Po(e).time[t];
}
Ie(No, "Temporal.ZonedDateTime");
var Lo = Object.freeze({
	__proto__: null,
	Duration: wo,
	Instant: vo,
	Now: Oo,
	PlainDate: yo,
	PlainDateTime: xo,
	PlainMonthDay: To,
	PlainTime: ko,
	PlainYearMonth: Ao,
	ZonedDateTime: No
});
(class {
	toTemporalInstant() {
		return Vn(Gi(Date.prototype.valueOf.call(this)));
	}
}).prototype.toTemporalInstant;
var Ro = [
	vo,
	yo,
	xo,
	wo,
	To,
	ko,
	Ao,
	No
];
for (let e of Ro) {
	let t = Object.getOwnPropertyDescriptor(e, "prototype");
	(t.configurable || t.enumerable || t.writable) && (t.configurable = !1, t.enumerable = !1, t.writable = !1, Object.defineProperty(e, "prototype", t));
}
//#endregion
//#region node_modules/@formatjs/fast-memoize/index.js
function zo(e, t) {
	let n = t && t.cache ? t.cache : qo, r = t && t.serializer ? t.serializer : Go;
	return (t && t.strategy ? t.strategy : Wo)(e, {
		cache: n,
		serializer: r
	});
}
function Bo(e) {
	return e == null || typeof e == "number" || typeof e == "boolean";
}
function Vo(e, t, n, r) {
	let i = Bo(r) ? r : n(r), a = t.get(i);
	return a === void 0 && (a = e.call(this, r), t.set(i, a)), a;
}
function Ho(e, t, n) {
	let r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
	return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
}
function Uo(e, t, n, r, i) {
	return n.bind(t, e, r, i);
}
function Wo(e, t) {
	let n = e.length === 1 ? Vo : Ho;
	return Uo(e, this, n, t.cache.create(), t.serializer);
}
var Go = function() {
	return JSON.stringify(arguments);
}, Ko = class {
	constructor() {
		this.cache = Object.create(null);
	}
	get(e) {
		return this.cache[e];
	}
	set(e, t) {
		this.cache[e] = t;
	}
}, qo = { create: function() {
	return new Ko();
} }, Jo = { supplemental: { languageMatching: { "written-new": [
	{ paradigmLocales: { _locales: "en en_GB es es_419 pt_BR pt_PT" } },
	{ $enUS: { _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI" } },
	{ $cnsar: { _value: "HK+MO" } },
	{ $americas: { _value: "019" } },
	{ $maghreb: { _value: "MA+DZ+TN+LY+MR+EH" } },
	{ no: {
		_desired: "nb",
		_distance: "1"
	} },
	{ bs: {
		_desired: "hr",
		_distance: "4"
	} },
	{ bs: {
		_desired: "sh",
		_distance: "4"
	} },
	{ hr: {
		_desired: "sh",
		_distance: "4"
	} },
	{ sr: {
		_desired: "sh",
		_distance: "4"
	} },
	{ aa: {
		_desired: "ssy",
		_distance: "4"
	} },
	{ de: {
		_desired: "gsw",
		_distance: "4",
		_oneway: "true"
	} },
	{ de: {
		_desired: "lb",
		_distance: "4",
		_oneway: "true"
	} },
	{ no: {
		_desired: "da",
		_distance: "8"
	} },
	{ nb: {
		_desired: "da",
		_distance: "8"
	} },
	{ ru: {
		_desired: "ab",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ach",
		_distance: "30",
		_oneway: "true"
	} },
	{ nl: {
		_desired: "af",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ak",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "am",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "ay",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "az",
		_distance: "30",
		_oneway: "true"
	} },
	{ ur: {
		_desired: "bal",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "be",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "bem",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "bh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "bn",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "bo",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "br",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "ca",
		_distance: "20",
		_oneway: "true"
	} },
	{ fil: {
		_desired: "ceb",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "chr",
		_distance: "20",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ckb",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "co",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "crs",
		_distance: "20",
		_oneway: "true"
	} },
	{ sk: {
		_desired: "cs",
		_distance: "20"
	} },
	{ en: {
		_desired: "cy",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ee",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "eo",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "eu",
		_distance: "20",
		_oneway: "true"
	} },
	{ da: {
		_desired: "fo",
		_distance: "20",
		_oneway: "true"
	} },
	{ nl: {
		_desired: "fy",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ga",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "gaa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "gd",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "gl",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "gn",
		_distance: "20",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "gu",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ha",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "haw",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "ht",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "hy",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ia",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ig",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "is",
		_distance: "20",
		_oneway: "true"
	} },
	{ id: {
		_desired: "jv",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ka",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "kg",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "kk",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "km",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "kn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "kri",
		_distance: "30",
		_oneway: "true"
	} },
	{ tr: {
		_desired: "ku",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "ky",
		_distance: "30",
		_oneway: "true"
	} },
	{ it: {
		_desired: "la",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "lg",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "ln",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "lo",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "loz",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "lua",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "mai",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mfe",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "mg",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mi",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ml",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "mn",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "mr",
		_distance: "30",
		_oneway: "true"
	} },
	{ id: {
		_desired: "ms",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mt",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "my",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ne",
		_distance: "30",
		_oneway: "true"
	} },
	{ nb: {
		_desired: "nn",
		_distance: "20"
	} },
	{ no: {
		_desired: "nn",
		_distance: "20"
	} },
	{ en: {
		_desired: "nso",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ny",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "nyn",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "oc",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "om",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "or",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "pa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "pcm",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ps",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "qu",
		_distance: "30",
		_oneway: "true"
	} },
	{ de: {
		_desired: "rm",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "rn",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "rw",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "sa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sd",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "si",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "so",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sq",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "st",
		_distance: "30",
		_oneway: "true"
	} },
	{ id: {
		_desired: "su",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sw",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ta",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "te",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tg",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ti",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tk",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tlh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "to",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tt",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tum",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "ug",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "uk",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ur",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "uz",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "wo",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "xh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "yi",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "yo",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "za",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "zu",
		_distance: "30",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aao",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "abh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "abv",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acx",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acy",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "adf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aeb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aec",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "afb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ajp",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "apc",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "apd",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "arq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ars",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ary",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "arz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "auz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "avl",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayl",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayp",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "bbz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "pga",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "shu",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ssh",
		_distance: "10",
		_oneway: "true"
	} },
	{ az: {
		_desired: "azb",
		_distance: "10",
		_oneway: "true"
	} },
	{ et: {
		_desired: "vro",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "ffm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fub",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fue",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fui",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuv",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gnw",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gui",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gun",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "nhd",
		_distance: "10",
		_oneway: "true"
	} },
	{ iu: {
		_desired: "ikt",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "enb",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "eyo",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "niq",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "oki",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "pko",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "sgc",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "tec",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "tuy",
		_distance: "10",
		_oneway: "true"
	} },
	{ kok: {
		_desired: "gom",
		_distance: "10",
		_oneway: "true"
	} },
	{ kpe: {
		_desired: "gkp",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "ida",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lkb",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lko",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lks",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lri",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lrm",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lsm",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lto",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lts",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lwg",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "nle",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "nyd",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "rag",
		_distance: "10",
		_oneway: "true"
	} },
	{ lv: {
		_desired: "ltg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bhr",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bjq",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bmm",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bzc",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "msh",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "skg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "tdx",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "tkg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "txy",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "xmv",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "xmw",
		_distance: "10",
		_oneway: "true"
	} },
	{ mn: {
		_desired: "mvf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bjn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "btj",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bve",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bvu",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "coa",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "dup",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "hji",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "id",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "jak",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "jax",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kvb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kvr",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kxd",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "lce",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "lcf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "liw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "max",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "meo",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mfa",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mfb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "min",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mqg",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "msi",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mui",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "orn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "ors",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "pel",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "pse",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "tmw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "urk",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "vkk",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "vkt",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "xmm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "zlm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "zmi",
		_distance: "10",
		_oneway: "true"
	} },
	{ ne: {
		_desired: "dty",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "gax",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "hae",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "orc",
		_distance: "10",
		_oneway: "true"
	} },
	{ or: {
		_desired: "spv",
		_distance: "10",
		_oneway: "true"
	} },
	{ ps: {
		_desired: "pbt",
		_distance: "10",
		_oneway: "true"
	} },
	{ ps: {
		_desired: "pst",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qub",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qud",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quf",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qug",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quk",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qul",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qup",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qur",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qus",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quw",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qux",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quy",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qva",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qve",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvi",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvj",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvl",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvm",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvn",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvo",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvp",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvs",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvw",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvz",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwa",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qws",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxa",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxl",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxn",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxo",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxp",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxr",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxt",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxu",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxw",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sdc",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sdn",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sro",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aae",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aat",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aln",
		_distance: "10",
		_oneway: "true"
	} },
	{ syr: {
		_desired: "aii",
		_distance: "10",
		_oneway: "true"
	} },
	{ uz: {
		_desired: "uzs",
		_distance: "10",
		_oneway: "true"
	} },
	{ yi: {
		_desired: "yih",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cdo",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cjy",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cpx",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "czh",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "czo",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "gan",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "hak",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "hsn",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "lzh",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "mnp",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "nan",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "wuu",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "yue",
		_distance: "10",
		_oneway: "true"
	} },
	{ "*": {
		_desired: "*",
		_distance: "80"
	} },
	{ "en-Latn": {
		_desired: "am-Ethi",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "az-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "bn-Beng",
		_distance: "10",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "bo-Tibt",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "hy-Armn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ka-Geor",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "km-Khmr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "kn-Knda",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "lo-Laoo",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ml-Mlym",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "my-Mymr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ne-Deva",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "or-Orya",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "pa-Guru",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ps-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "sd-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "si-Sinh",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ta-Taml",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "te-Telu",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ti-Ethi",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "tk-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ur-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "uz-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "yi-Hebr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "sr-Cyrl": {
		_desired: "sr-Latn",
		_distance: "5"
	} },
	{ "zh-Hans": {
		_desired: "za-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "zh-Hani",
		_distance: "20",
		_oneway: "true"
	} },
	{ "zh-Hant": {
		_desired: "zh-Hani",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ar-Arab": {
		_desired: "ar-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "bn-Beng": {
		_desired: "bn-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "gu-Gujr": {
		_desired: "gu-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "hi-Deva": {
		_desired: "hi-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "kn-Knda": {
		_desired: "kn-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ml-Mlym": {
		_desired: "ml-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "mr-Deva": {
		_desired: "mr-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ta-Taml": {
		_desired: "ta-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "te-Telu": {
		_desired: "te-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "zh-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Latn",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hani",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hira",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Kana",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hrkt",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Hrkt": {
		_desired: "ja-Hira",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Hrkt": {
		_desired: "ja-Kana",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Hani",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Hang",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Jamo",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Hang": {
		_desired: "ko-Jamo",
		_distance: "5",
		_oneway: "true"
	} },
	{ "*-*": {
		_desired: "*-*",
		_distance: "50"
	} },
	{ "ar-*-$maghreb": {
		_desired: "ar-*-$maghreb",
		_distance: "4"
	} },
	{ "ar-*-$!maghreb": {
		_desired: "ar-*-$!maghreb",
		_distance: "4"
	} },
	{ "ar-*-*": {
		_desired: "ar-*-*",
		_distance: "5"
	} },
	{ "en-*-$enUS": {
		_desired: "en-*-$enUS",
		_distance: "4"
	} },
	{ "en-*-GB": {
		_desired: "en-*-$!enUS",
		_distance: "3"
	} },
	{ "en-*-$!enUS": {
		_desired: "en-*-$!enUS",
		_distance: "4"
	} },
	{ "en-*-*": {
		_desired: "en-*-*",
		_distance: "5"
	} },
	{ "es-*-$americas": {
		_desired: "es-*-$americas",
		_distance: "4"
	} },
	{ "es-*-$!americas": {
		_desired: "es-*-$!americas",
		_distance: "4"
	} },
	{ "es-*-*": {
		_desired: "es-*-*",
		_distance: "5"
	} },
	{ "pt-*-$americas": {
		_desired: "pt-*-$americas",
		_distance: "4"
	} },
	{ "pt-*-$!americas": {
		_desired: "pt-*-$!americas",
		_distance: "4"
	} },
	{ "pt-*-*": {
		_desired: "pt-*-*",
		_distance: "5"
	} },
	{ "zh-Hant-$cnsar": {
		_desired: "zh-Hant-$cnsar",
		_distance: "4"
	} },
	{ "zh-Hant-$!cnsar": {
		_desired: "zh-Hant-$!cnsar",
		_distance: "4"
	} },
	{ "zh-Hant-*": {
		_desired: "zh-Hant-*",
		_distance: "5"
	} },
	{ "*-*-*": {
		_desired: "*-*-*",
		_distance: "4"
	} }
] } } }, Yo = {
	"001": /* @__PURE__ */ "001.001-status-grouping.002.005.009.011.013.014.015.017.018.019.021.029.030.034.035.039.053.054.057.061.142.143.145.150.151.154.155.AC.AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CP.CQ.CR.CU.CV.CW.CX.CY.CZ.DE.DG.DJ.DK.DM.DO.DZ.EA.EC.EE.EG.EH.ER.ES.ET.EU.EZ.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.IC.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.QO.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TA.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.UN.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
	"002": /* @__PURE__ */ "002.002-status-grouping.011.014.015.017.018.202.AO.BF.BI.BJ.BW.CD.CF.CG.CI.CM.CV.DJ.DZ.EA.EG.EH.ER.ET.GA.GH.GM.GN.GQ.GW.IC.IO.KE.KM.LR.LS.LY.MA.MG.ML.MR.MU.MW.MZ.NA.NE.NG.RE.RW.SC.SD.SH.SL.SN.SO.SS.ST.SZ.TD.TF.TG.TN.TZ.UG.YT.ZA.ZM.ZW".split("."),
	"003": /* @__PURE__ */ "003.013.021.029.AG.AI.AW.BB.BL.BM.BQ.BS.BZ.CA.CR.CU.CW.DM.DO.GD.GL.GP.GT.HN.HT.JM.KN.KY.LC.MF.MQ.MS.MX.NI.PA.PM.PR.SV.SX.TC.TT.US.VC.VG.VI".split("."),
	"005": [
		"005",
		"AR",
		"BO",
		"BR",
		"BV",
		"CL",
		"CO",
		"EC",
		"FK",
		"GF",
		"GS",
		"GY",
		"PE",
		"PY",
		"SR",
		"UY",
		"VE"
	],
	"009": /* @__PURE__ */ "009.053.054.057.061.AC.AQ.AS.AU.CC.CK.CP.CX.DG.FJ.FM.GU.HM.KI.MH.MP.NC.NF.NR.NU.NZ.PF.PG.PN.PW.QO.SB.TA.TK.TO.TV.UM.VU.WF.WS".split("."),
	"011": [
		"011",
		"BF",
		"BJ",
		"CI",
		"CV",
		"GH",
		"GM",
		"GN",
		"GW",
		"LR",
		"ML",
		"MR",
		"NE",
		"NG",
		"SH",
		"SL",
		"SN",
		"TG"
	],
	"013": [
		"013",
		"BZ",
		"CR",
		"GT",
		"HN",
		"MX",
		"NI",
		"PA",
		"SV"
	],
	"014": [
		"014",
		"BI",
		"DJ",
		"ER",
		"ET",
		"IO",
		"KE",
		"KM",
		"MG",
		"MU",
		"MW",
		"MZ",
		"RE",
		"RW",
		"SC",
		"SO",
		"SS",
		"TF",
		"TZ",
		"UG",
		"YT",
		"ZM",
		"ZW"
	],
	"015": [
		"015",
		"DZ",
		"EA",
		"EG",
		"EH",
		"IC",
		"LY",
		"MA",
		"SD",
		"TN"
	],
	"017": [
		"017",
		"AO",
		"CD",
		"CF",
		"CG",
		"CM",
		"GA",
		"GQ",
		"ST",
		"TD"
	],
	"018": [
		"018",
		"BW",
		"LS",
		"NA",
		"SZ",
		"ZA"
	],
	"019": /* @__PURE__ */ "003.005.013.019.019-status-grouping.021.029.419.AG.AI.AR.AW.BB.BL.BM.BO.BQ.BR.BS.BV.BZ.CA.CL.CO.CR.CU.CW.DM.DO.EC.FK.GD.GF.GL.GP.GS.GT.GY.HN.HT.JM.KN.KY.LC.MF.MQ.MS.MX.NI.PA.PE.PM.PR.PY.SR.SV.SX.TC.TT.US.UY.VC.VE.VG.VI".split("."),
	"021": [
		"021",
		"BM",
		"CA",
		"GL",
		"PM",
		"US"
	],
	"029": /* @__PURE__ */ "029.AG.AI.AW.BB.BL.BQ.BS.CU.CW.DM.DO.GD.GP.HT.JM.KN.KY.LC.MF.MQ.MS.PR.SX.TC.TT.VC.VG.VI".split("."),
	"030": [
		"030",
		"CN",
		"HK",
		"JP",
		"KP",
		"KR",
		"MN",
		"MO",
		"TW"
	],
	"034": [
		"034",
		"AF",
		"BD",
		"BT",
		"IN",
		"IR",
		"LK",
		"MV",
		"NP",
		"PK"
	],
	"035": [
		"035",
		"BN",
		"ID",
		"KH",
		"LA",
		"MM",
		"MY",
		"PH",
		"SG",
		"TH",
		"TL",
		"VN"
	],
	"039": [
		"039",
		"AD",
		"AL",
		"BA",
		"ES",
		"GI",
		"GR",
		"HR",
		"IT",
		"ME",
		"MK",
		"MT",
		"PT",
		"RS",
		"SI",
		"SM",
		"VA",
		"XK"
	],
	"053": [
		"053",
		"AU",
		"CC",
		"CX",
		"HM",
		"NF",
		"NZ"
	],
	"054": [
		"054",
		"FJ",
		"NC",
		"PG",
		"SB",
		"VU"
	],
	"057": [
		"057",
		"FM",
		"GU",
		"KI",
		"MH",
		"MP",
		"NR",
		"PW",
		"UM"
	],
	"061": [
		"061",
		"AS",
		"CK",
		"NU",
		"PF",
		"PN",
		"TK",
		"TO",
		"TV",
		"WF",
		"WS"
	],
	142: /* @__PURE__ */ "030.034.035.142.143.145.AE.AF.AM.AZ.BD.BH.BN.BT.CN.CY.GE.HK.ID.IL.IN.IQ.IR.JO.JP.KG.KH.KP.KR.KW.KZ.LA.LB.LK.MM.MN.MO.MV.MY.NP.OM.PH.PK.PS.QA.SA.SG.SY.TH.TJ.TL.TM.TR.TW.UZ.VN.YE".split("."),
	143: [
		"143",
		"KG",
		"KZ",
		"TJ",
		"TM",
		"UZ"
	],
	145: [
		"145",
		"AE",
		"AM",
		"AZ",
		"BH",
		"CY",
		"GE",
		"IL",
		"IQ",
		"JO",
		"KW",
		"LB",
		"OM",
		"PS",
		"QA",
		"SA",
		"SY",
		"TR",
		"YE"
	],
	150: /* @__PURE__ */ "039.150.151.154.155.AD.AL.AT.AX.BA.BE.BG.BY.CH.CQ.CZ.DE.DK.EE.ES.FI.FO.FR.GB.GG.GI.GR.HR.HU.IE.IM.IS.IT.JE.LI.LT.LU.LV.MC.MD.ME.MK.MT.NL.NO.PL.PT.RO.RS.RU.SE.SI.SJ.SK.SM.UA.VA.XK".split("."),
	151: [
		"151",
		"BG",
		"BY",
		"CZ",
		"HU",
		"MD",
		"PL",
		"RO",
		"RU",
		"SK",
		"UA"
	],
	154: [
		"154",
		"AX",
		"CQ",
		"DK",
		"EE",
		"FI",
		"FO",
		"GB",
		"GG",
		"IE",
		"IM",
		"IS",
		"JE",
		"LT",
		"LV",
		"NO",
		"SE",
		"SJ"
	],
	155: [
		"155",
		"AT",
		"BE",
		"CH",
		"DE",
		"FR",
		"LI",
		"LU",
		"MC",
		"NL"
	],
	202: /* @__PURE__ */ "011.014.017.018.202.AO.BF.BI.BJ.BW.CD.CF.CG.CI.CM.CV.DJ.ER.ET.GA.GH.GM.GN.GQ.GW.IO.KE.KM.LR.LS.MG.ML.MR.MU.MW.MZ.NA.NE.NG.RE.RW.SC.SH.SL.SN.SO.SS.ST.SZ.TD.TF.TG.TZ.UG.YT.ZA.ZM.ZW".split("."),
	419: /* @__PURE__ */ "005.013.029.419.AG.AI.AR.AW.BB.BL.BO.BQ.BR.BS.BV.BZ.CL.CO.CR.CU.CW.DM.DO.EC.FK.GD.GF.GP.GS.GT.GY.HN.HT.JM.KN.KY.LC.MF.MQ.MS.MX.NI.PA.PE.PR.PY.SR.SV.SX.TC.TT.UY.VC.VE.VG.VI".split("."),
	EU: /* @__PURE__ */ "AT.BE.BG.CY.CZ.DE.DK.EE.ES.EU.FI.FR.GR.HR.HU.IE.IT.LT.LU.LV.MT.NL.PL.PT.RO.SE.SI.SK".split("."),
	EZ: [
		"AT",
		"BE",
		"CY",
		"DE",
		"EE",
		"ES",
		"EZ",
		"FI",
		"FR",
		"GR",
		"IE",
		"IT",
		"LT",
		"LU",
		"LV",
		"MT",
		"NL",
		"PT",
		"SI",
		"SK"
	],
	QO: [
		"AC",
		"AQ",
		"CP",
		"DG",
		"QO",
		"TA"
	],
	UN: /* @__PURE__ */ "AD.AE.AF.AG.AL.AM.AO.AR.AT.AU.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BN.BO.BR.BS.BT.BW.BY.BZ.CA.CD.CF.CG.CH.CI.CL.CM.CN.CO.CR.CU.CV.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.ER.ES.ET.FI.FJ.FM.FR.GA.GB.GD.GE.GH.GM.GN.GQ.GR.GT.GW.GY.HN.HR.HT.HU.ID.IE.IL.IN.IQ.IR.IS.IT.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MG.MH.MK.ML.MM.MN.MR.MT.MU.MV.MW.MX.MY.MZ.NA.NE.NG.NI.NL.NO.NP.NR.NZ.OM.PA.PE.PG.PH.PK.PL.PT.PW.PY.QA.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SI.SK.SL.SM.SN.SO.SR.SS.ST.SV.SY.SZ.TD.TG.TH.TJ.TL.TM.TN.TO.TR.TT.TV.TZ.UA.UG.UN.US.UY.UZ.VC.VE.VN.VU.WS.YE.ZA.ZM.ZW".split(".")
};
function Xo(e) {
	let t = e.split("-");
	for (let e = 1; e < t.length && t[e] !== "x"; e++) {
		if (t[e] !== "u") continue;
		let n = e + 1;
		for (; n < t.length && t[n].length > 1;) n++;
		return {
			locale: [...t.slice(0, e), ...t.slice(n)].join("-"),
			extension: "-" + t.slice(e, n).join("-")
		};
	}
	return { locale: e };
}
function Zo(e, t, n = Error) {
	if (!e) throw new n(t);
}
var Qo = 838, $o;
function es() {
	if (!$o) {
		let e = Jo.supplemental.languageMatching["written-new"][0]?.paradigmLocales?._locales.split(" "), t = Jo.supplemental.languageMatching["written-new"].slice(1, 5);
		$o = {
			matches: Jo.supplemental.languageMatching["written-new"].slice(5).map((e) => {
				let t = Object.keys(e)[0], n = e[t];
				return {
					supported: t,
					desired: n._desired,
					distance: +n._distance,
					oneway: n.oneway === "true"
				};
			}, {}),
			matchVariables: t.reduce((e, t) => {
				let n = Object.keys(t)[0], r = t[n];
				return e[n.slice(1)] = r._value.split("+"), e;
			}, {}),
			paradigmLocales: [...e, ...e.map((e) => new Intl.Locale(e.replace(/_/g, "-")).maximize().toString())]
		};
	}
	return $o;
}
function ts(e, t, n) {
	let [r, i, a] = t.split("-"), o = !0;
	if (a && a[0] === "$") {
		let t = a[1] !== "!", r = (t ? n[a.slice(1)] : n[a.slice(2)]).map((e) => Yo[e] || [e]).reduce((e, t) => [...e, ...t], []);
		o &&= r.indexOf(e.region || "") > -1 == t;
	} else o &&= !e.region || a === "*" || a === e.region;
	return o &&= !e.script || i === "*" || i === e.script, o &&= !e.language || r === "*" || r === e.language, o;
}
function ns(e) {
	return [
		e.language,
		e.script,
		e.region
	].filter(Boolean).join("-");
}
function rs(e, t, n) {
	for (let r of n.matches) {
		let i = ts(e, r.desired, n.matchVariables) && ts(t, r.supported, n.matchVariables);
		if (!r.oneway && !i && (i = ts(e, r.supported, n.matchVariables) && ts(t, r.desired, n.matchVariables)), i) {
			let i = r.distance * 10;
			return n.paradigmLocales.indexOf(ns(e)) > -1 == n.paradigmLocales.indexOf(ns(t)) > -1 ? i : i - 1;
		}
	}
	throw Error("No matching distance found");
}
function is(e, t) {
	let n = new Intl.Locale(e).maximize(), r = new Intl.Locale(t).maximize(), i = {
		language: n.language,
		script: n.script || "",
		region: n.region || ""
	}, a = {
		language: r.language,
		script: r.script || "",
		region: r.region || ""
	}, o = 0, s = es();
	return i.language !== a.language && (o += rs({
		language: n.language,
		script: "",
		region: ""
	}, {
		language: r.language,
		script: "",
		region: ""
	}, s)), i.script !== a.script && (o += rs({
		language: n.language,
		script: i.script,
		region: ""
	}, {
		language: r.language,
		script: a.script,
		region: ""
	}, s)), i.region !== a.region && (o += rs(i, a, s)), o;
}
var as = zo(is, { serializer: (e) => `${e[0]}|${e[1]}` });
function os(e) {
	let t = [], n = e;
	for (; n;) {
		t.push(n);
		let e = n.lastIndexOf("-");
		if (e === -1) break;
		n = n.substring(0, e);
	}
	return t;
}
var ss = /* @__PURE__ */ new WeakMap();
function cs(e, t, n = Qo) {
	let r = Infinity, i = {
		matchedDesiredLocale: "",
		distances: {}
	}, a = ss.get(t);
	a || (a = t.map((e) => {
		try {
			return Intl.getCanonicalLocales([e])[0] || e;
		} catch {
			return e;
		}
	}), ss.set(t, a));
	let o = new Set(a);
	for (let t = 0; t < e.length; t++) {
		let n = e[t];
		if (o.has(n)) {
			let e = 0 + t * 40;
			if (i.distances[n] = { [n]: e }, e < r && (r = e, i.matchedDesiredLocale = n, i.matchedSupportedLocale = n), t === 0) return i;
		}
	}
	for (let t = 0; t < e.length; t++) {
		let n = e[t];
		try {
			let e = new Intl.Locale(n).maximize().toString();
			if (e !== n) {
				let a = os(e);
				for (let s = 0; s < a.length; s++) {
					let c = a[s];
					if (c !== n && o.has(c)) {
						let a;
						try {
							a = new Intl.Locale(c).maximize().toString() === e ? 0 + t * 40 : s * 10 + t * 40;
						} catch {
							a = s * 10 + t * 40;
						}
						i.distances[n] || (i.distances[n] = {}), i.distances[n][c] = a, a < r && (r = a, i.matchedDesiredLocale = n, i.matchedSupportedLocale = c);
						break;
					}
				}
			}
		} catch {}
	}
	return i.matchedSupportedLocale && r === 0 ? i : (r = Infinity, e.forEach((e, n) => {
		i.distances[e] || (i.distances[e] = {}), a.forEach((a, o) => {
			let s = t[o], c = as(e, a) + 0 + n * 40;
			i.distances[e][s] = c, c < r && (r = c, i.matchedDesiredLocale = e, i.matchedSupportedLocale = s);
		});
	}), r >= n && (i.matchedDesiredLocale = void 0, i.matchedSupportedLocale = void 0), i);
}
function ls(e, t, n) {
	let r, i, a = [], o = t.reduce((e, t) => {
		let { locale: n } = Xo(t);
		return a.push(n), e[n] = t, e;
	}, {}), s = cs(a, e);
	return s.matchedSupportedLocale && s.matchedDesiredLocale && (r = s.matchedSupportedLocale, i = Xo(o[s.matchedDesiredLocale]).extension), r ? {
		locale: r,
		extension: i
	} : { locale: n() };
}
var us = {
	cn11: "cnbj",
	cn12: "cntj",
	cn13: "cnhe",
	cn14: "cnsx",
	cn15: "cnmn",
	cn21: "cnln",
	cn22: "cnjl",
	cn23: "cnhl",
	cn31: "cnsh",
	cn32: "cnjs",
	cn33: "cnzj",
	cn34: "cnah",
	cn35: "cnfj",
	cn36: "cnjx",
	cn37: "cnsd",
	cn41: "cnha",
	cn42: "cnhb",
	cn43: "cnhn",
	cn44: "cngd",
	cn45: "cngx",
	cn46: "cnhi",
	cn50: "cncq",
	cn51: "cnsc",
	cn52: "cngz",
	cn53: "cnyn",
	cn54: "cnxz",
	cn61: "cnsn",
	cn62: "cngs",
	cn63: "cnqh",
	cn64: "cnnx",
	cn65: "cnxj",
	cn71: "twzzzz",
	cn91: "hkzzzz",
	cn92: "mozzzz",
	cz10a: "cz110",
	cz10b: "cz111",
	cz10c: "cz112",
	cz10d: "cz113",
	cz10e: "cz114",
	cz10f: "cz115",
	cz611: "cz663",
	cz612: "cz632",
	cz613: "cz633",
	cz614: "cz634",
	cz615: "cz635",
	cz621: "cz641",
	cz622: "cz642",
	cz623: "cz643",
	cz624: "cz644",
	cz626: "cz646",
	cz627: "cz647",
	czjc: "cz31",
	czjm: "cz64",
	czka: "cz41",
	czkr: "cz52",
	czli: "cz51",
	czmo: "cz80",
	czol: "cz71",
	czpa: "cz53",
	czpl: "cz32",
	czpr: "cz10",
	czst: "cz20",
	czus: "cz42",
	czvy: "cz63",
	czzl: "cz72",
	fi01: "axzzzz",
	fra: "frges",
	frb: "frnaq",
	frbl: "blzzzz",
	frc: "frara",
	frcp: "cpzzzz",
	frd: "frbfc",
	fre: "frbre",
	frf: "frcvl",
	frg: "frges",
	frgf: "gfzzzz",
	frgp: "gpzzzz",
	frgua: "gpzzzz",
	frh: "frcor",
	fri: "frbfc",
	frj: "fridf",
	frk: "frocc",
	frl: "frnaq",
	frlre: "rezzzz",
	frm: "frges",
	frmay: "ytzzzz",
	frmf: "mfzzzz",
	frmq: "mqzzzz",
	frn: "frocc",
	frnc: "nczzzz",
	fro: "frhdf",
	frp: "frnor",
	frpf: "pfzzzz",
	frpm: "pmzzzz",
	frq: "frnor",
	frr: "frpdl",
	frre: "rezzzz",
	frs: "frhdf",
	frt: "frnaq",
	frtf: "tfzzzz",
	fru: "frpac",
	frv: "frara",
	frwf: "wfzzzz",
	fryt: "ytzzzz",
	laxn: "laxs",
	lud: "lucl",
	lug: "luec",
	lul: "luca",
	mrnkc: "mr13",
	nlaw: "awzzzz",
	nlcw: "cwzzzz",
	nlsx: "sxzzzz",
	no23: "no50",
	nzn: "nzauk",
	nzs: "nzcan",
	omba: "ombj",
	omsh: "omsj",
	plds: "pl02",
	plkp: "pl04",
	pllb: "pl08",
	plld: "pl10",
	pllu: "pl06",
	plma: "pl12",
	plmz: "pl14",
	plop: "pl16",
	plpd: "pl20",
	plpk: "pl18",
	plpm: "pl22",
	plsk: "pl26",
	plsl: "pl24",
	plwn: "pl28",
	plwp: "pl30",
	plzp: "pl32",
	shta: "tazzzz",
	tteto: "tttob",
	ttrcm: "ttmrc",
	ttwto: "tttob",
	twkhq: "twkhh",
	twtnq: "twtnn",
	twtpq: "twnwt",
	twtxq: "twtxg",
	usas: "aszzzz",
	usgu: "guzzzz",
	usmp: "mpzzzz",
	uspr: "przzzz",
	usum: "umzzzz",
	usvi: "vizzzz"
}, ds = {
	t: {
		d0: { name: "charname" },
		m0: {
			"beta-metsehaf": "betamets",
			"ies-jes": "iesjes",
			names: "prprname",
			"tekie-alibekit": "tekieali"
		}
	},
	u: {
		ca: {
			"ethiopic-amete-alem": "ethioaa",
			islamicc: "islamic-civil"
		},
		kb: { yes: "true" },
		kc: { yes: "true" },
		kh: { yes: "true" },
		kk: { yes: "true" },
		kn: { yes: "true" },
		ks: {
			primary: "level1",
			tertiary: "level3"
		},
		ms: { imperial: "uksystem" },
		tz: {
			aqams: "aqmcm",
			aukns: "auhba",
			caffs: "cawnp",
			camtr: "cator",
			canpg: "cator",
			capnt: "caiql",
			cathu: "cator",
			cayzf: "caedm",
			cet: "bebru",
			cnckg: "cnsha",
			cnhrb: "cnsha",
			cnkhg: "cnurc",
			cst6cdt: "uschi",
			cuba: "cuhav",
			eet: "grath",
			egypt: "egcai",
			eire: "iedub",
			est: "papty",
			est5edt: "usnyc",
			factory: "unk",
			gaza: "gazastrp",
			gmt0: "gmt",
			hongkong: "hkhkg",
			hst: "ushnl",
			iceland: "isrey",
			iran: "irthr",
			israel: "jeruslm",
			jamaica: "jmkin",
			japan: "jptyo",
			libya: "lytip",
			met: "bebru",
			mncoq: "mnuln",
			mst: "usphx",
			mst7mdt: "usden",
			mxstis: "mxtij",
			navajo: "usden",
			poland: "plwaw",
			portugal: "ptlis",
			prc: "cnsha",
			pst8pdt: "uslax",
			roc: "twtpe",
			rok: "krsel",
			turkey: "trist",
			uaozh: "uaiev",
			uauzh: "uaiev",
			uct: "utc",
			umjon: "ushnl",
			usnavajo: "usden",
			wet: "ptlis",
			zulu: "utc"
		}
	}
};
function fs(e, t) {
	Zo(e !== void 0, "ukey must be defined");
	let n = "";
	for (let e = 0; e < t.length; e++) {
		let r = t.charCodeAt(e);
		n += r >= 65 && r <= 90 ? String.fromCharCode(r + 32) : t[e];
	}
	let r = Object.prototype.hasOwnProperty.call(ds.u, e) ? ds.u[e] : void 0;
	return r && Object.prototype.hasOwnProperty.call(r, n) && (n = r[n]), (e === "rg" || e === "sd") && Object.prototype.hasOwnProperty.call(us, n) && (n = us[n]), n === "true" ? "" : n;
}
function ps(e) {
	return Intl.getCanonicalLocales(e)[0];
}
function ms(e, t, n) {
	Zo(Xo(e).extension === void 0, "Expected locale to not have a Unicode locale extension");
	let r = "-u";
	for (let e of t) r += `-${e}`;
	for (let e of n) {
		let { key: t, value: n } = e;
		r += `-${t}`, n !== "" && (r += `-${n}`);
	}
	if (r === "-u") return ps(e);
	let i = e.indexOf("-x-"), a;
	if (i === -1) a = e + r;
	else {
		let t = e.slice(0, i), n = e.slice(i);
		a = t + r + n;
	}
	return ps(a);
}
var hs = /* @__PURE__ */ new WeakMap();
function gs(e, t) {
	let n = hs.get(e);
	n || (n = new Set(e), hs.set(e, n));
	let r = t;
	for (;;) {
		if (n.has(r)) return r;
		let e = r.lastIndexOf("-");
		if (!~e) return;
		e >= 2 && r[e - 2] === "-" && (e -= 2), r = r.slice(0, e);
	}
}
function _s(e, t, n) {
	let r = { locale: "" };
	for (let n of t) {
		let { locale: t, extension: i } = Xo(n), a = gs(e, t);
		if (a) return r.locale = a, i && (r.extension = i), r;
	}
	return r.locale = n(), r;
}
function vs(e) {
	Zo(e === e.toLowerCase(), "Expected extension to be lowercase"), Zo(e.slice(0, 3) === "-u-", "Expected extension to be a Unicode locale extension");
	let t = [], n = [], r, i = e.length, a = 3;
	for (; a < i;) {
		let o = e.indexOf("-", a), s;
		s = o === -1 ? i - a : o - a;
		let c = e.slice(a, a + s);
		Zo(s >= 2, "Expected a subtag to have at least 2 characters"), r === void 0 && s != 2 ? t.indexOf(c) === -1 && t.push(c) : s === 2 ? (r = {
			key: c,
			value: ""
		}, n.find((e) => e.key === r?.key) === void 0 && n.push(r)) : r?.value === "" ? r.value = c : (Zo(r !== void 0, "Expected keyword to be defined"), r.value += "-" + c), a += s + 1;
	}
	return {
		attributes: t,
		keywords: n
	};
}
function ys(e, t, n, r, i, a) {
	let o = n.localeMatcher, s;
	s = o === "lookup" ? _s(Array.from(e), t, a) : ls(Array.from(e), t, a), s ??= {
		locale: a(),
		extension: ""
	};
	let c = s.locale, l = i[c], u = Object.create(null);
	u.locale = "en", u.dataLocale = c;
	let d, f;
	s.extension ? (d = vs(s.extension), f = d.keywords) : f = [];
	let p = [];
	for (let e of r) {
		let t = l?.[e] ?? [];
		Zo(Array.isArray(t), `keyLocaleData for ${e} must be an array`);
		let r = t[0];
		Zo(r == null || typeof r == "string", "value must be a string, null, or undefined");
		let i, a = f.find((t) => t.key === e);
		if (a) {
			let n = a.value;
			n === "" ? t.indexOf("true") > -1 && (r = "true", i = {
				key: e,
				value: r
			}) : t.indexOf(n) > -1 && (r = n, i = {
				key: e,
				value: r
			});
		}
		let o = n[e];
		Zo(o == null || typeof o == "string", "optionsValue must be a string or undefined"), typeof o == "string" && (o = fs(e.toLowerCase(), o), o === "" && (o = "true")), o !== void 0 && o !== r && t.indexOf(o) > -1 && (r = o, i = void 0), i && p.push(i), u[e] = r;
	}
	let m = [];
	return p.length > 0 && (m = [], c = ms(c, m, p)), u.locale = c, u;
}
function bs(e, t) {
	let n = [];
	for (let r of t) {
		let { locale: t } = Xo(r);
		gs(e, t) && n.push(r);
	}
	return n;
}
//#endregion
//#region node_modules/@formatjs/bigdecimal/index.js
var xs = 40;
function Ss(e, t) {
	if (e === 0n) return [0n, 0];
	for (; e % 10n == 0n;) e /= 10n, t++;
	return [e, t];
}
function Cs(e) {
	return e < 0n ? -e : e;
}
function ws(e) {
	if (e === 0n) return 1;
	e < 0n && (e = -e);
	let t = 0, n = 1000000000000000n;
	for (; e >= n;) e /= n, t += 15;
	let r = Number(e);
	for (; r >= 1;) r /= 10, t++;
	return t;
}
var Ts = 10n;
function Es(e) {
	if (e <= 0) return 1n;
	let t = 1n, n = Ts, r = e;
	for (; r > 0;) r & 1 && (t *= n), n *= n, r >>= 1;
	return t;
}
function Ds(e) {
	if (e = e.trim(), e === "NaN") return {
		mantissa: 0n,
		exponent: 0,
		special: 1,
		negativeZero: !1
	};
	if (e === "Infinity" || e === "+Infinity") return {
		mantissa: 0n,
		exponent: 0,
		special: 2,
		negativeZero: !1
	};
	if (e === "-Infinity") return {
		mantissa: 0n,
		exponent: 0,
		special: 3,
		negativeZero: !1
	};
	let t = !1, n = 0;
	e[n] === "-" ? (t = !0, n++) : e[n] === "+" && n++;
	let r = e.indexOf("e", n);
	r === -1 && (r = e.indexOf("E", n));
	let i = 0, a;
	r === -1 ? a = e.substring(n) : (i = parseInt(e.substring(r + 1), 10), a = e.substring(n, r));
	let o = a.indexOf("."), s, c;
	o === -1 ? (s = a, c = "") : (s = a.substring(0, o), c = a.substring(o + 1));
	let l = s + c, u = i - c.length;
	if (l === "" || l === "0" || /^0+$/.test(l)) return {
		mantissa: 0n,
		exponent: 0,
		special: 0,
		negativeZero: t
	};
	let d = BigInt(l);
	t && (d = -d);
	let [f, p] = Ss(d, u);
	return {
		mantissa: f,
		exponent: p,
		special: 0,
		negativeZero: !1
	};
}
var Os = class e {
	constructor(e) {
		if (typeof e == "bigint") {
			let [t, n] = Ss(e, 0);
			this._mantissa = t, this._exponent = n, this._special = 0, this._negativeZero = !1;
			return;
		}
		if (typeof e == "number") {
			if (Number.isNaN(e)) {
				this._mantissa = 0n, this._exponent = 0, this._special = 1, this._negativeZero = !1;
				return;
			}
			if (e === Infinity) {
				this._mantissa = 0n, this._exponent = 0, this._special = 2, this._negativeZero = !1;
				return;
			}
			if (e === -Infinity) {
				this._mantissa = 0n, this._exponent = 0, this._special = 3, this._negativeZero = !1;
				return;
			}
			if (e === 0) {
				this._mantissa = 0n, this._exponent = 0, this._special = 0, this._negativeZero = Object.is(e, -0);
				return;
			}
			e = String(e);
		}
		let t = Ds(e);
		this._mantissa = t.mantissa, this._exponent = t.exponent, this._special = t.special, this._negativeZero = t.negativeZero;
	}
	static _create(t, n, r, i) {
		let a = Object.create(e.prototype);
		return a._mantissa = t, a._exponent = n, a._special = r, a._negativeZero = i, a;
	}
	static _coerce(t) {
		return t instanceof e ? t : new e(t);
	}
	times(t) {
		let n = e._coerce(t);
		if (this._special || n._special) return this._specialArith(n, "times");
		if (this._mantissa === 0n || n._mantissa === 0n) {
			let t = this._isSignNegative() ? !n._isSignNegative() : n._isSignNegative();
			return e._create(0n, 0, 0, t);
		}
		let [r, i] = Ss(this._mantissa * n._mantissa, this._exponent + n._exponent);
		return e._create(r, i, 0, !1);
	}
	div(t) {
		let n = e._coerce(t);
		if (this._special || n._special) return this._specialArith(n, "div");
		if (n._mantissa === 0n) {
			if (this._mantissa === 0n) return e._create(0n, 0, 1, !1);
			let t = this._isSignNegative() !== n._isSignNegative();
			return e._create(0n, 0, t ? 3 : 2, !1);
		}
		if (this._mantissa === 0n) {
			let t = this._isSignNegative() !== n._isSignNegative();
			return e._create(0n, 0, 0, t);
		}
		let [r, i] = Ss(this._mantissa * Es(xs) / n._mantissa, this._exponent - n._exponent - xs);
		return e._create(r, i, 0, !1);
	}
	plus(t) {
		let n = e._coerce(t);
		if (this._special || n._special) return this._specialArith(n, "plus");
		if (this._mantissa === 0n && n._mantissa === 0n) {
			let t = this._negativeZero && n._negativeZero;
			return e._create(0n, 0, 0, t);
		}
		if (this._mantissa === 0n) return n;
		if (n._mantissa === 0n) return this;
		let r = this._mantissa, i = n._mantissa, a = this._exponent, o = n._exponent, s = Math.min(a, o);
		a > s && (r *= Es(a - s)), o > s && (i *= Es(o - s));
		let c = r + i;
		if (c === 0n) return e._create(0n, 0, 0, !1);
		let [l, u] = Ss(c, s);
		return e._create(l, u, 0, !1);
	}
	minus(t) {
		return this.plus(e._coerce(t).negated());
	}
	mod(t) {
		let n = e._coerce(t);
		if (this._special || n._special) {
			if (this._special === 1 || n._special === 1 || this._special === 2 || this._special === 3) return e._create(0n, 0, 1, !1);
			if (n._special === 2 || n._special === 3) return this;
		}
		if (n._mantissa === 0n) return e._create(0n, 0, 1, !1);
		if (this._mantissa === 0n) return this;
		let r = this._mantissa, i = n._mantissa, a = this._exponent, o = n._exponent, s = Math.min(a, o);
		a > s && (r *= Es(a - s)), o > s && (i *= Es(o - s));
		let c = r % i;
		if (c === 0n) return e._create(0n, 0, 0, !1);
		let [l, u] = Ss(c, s);
		return e._create(l, u, 0, !1);
	}
	abs() {
		return this._special === 1 ? this : this._special === 3 ? e._create(0n, 0, 2, !1) : e._create(Cs(this._mantissa), this._exponent, this._special, !1);
	}
	negated() {
		return this._special === 1 ? this : this._special === 2 ? e._create(0n, 0, 3, !1) : this._special === 3 ? e._create(0n, 0, 2, !1) : this._mantissa === 0n ? e._create(0n, 0, 0, !this._negativeZero) : e._create(-this._mantissa, this._exponent, 0, !1);
	}
	pow(t) {
		if (this._special === 1) return this;
		if (t === 0) return new e(1);
		if (t < 0) return new e(1).div(this.pow(-t));
		if (this._special === 2) return this;
		if (this._special === 3) return t % 2 == 0 ? e._create(0n, 0, 2, !1) : this;
		if (this._mantissa === 0n) return new e(0);
		let [n, r] = Ss(this._mantissa ** BigInt(t), this._exponent * t);
		return e._create(n, r, 0, !1);
	}
	floor() {
		if (this._special !== 0 || this._mantissa === 0n || this._exponent >= 0) return this;
		let t = Es(-this._exponent), n = this._mantissa, r = n / t;
		if (n < 0n && n % t !== 0n && (r -= 1n), r === 0n) {
			let t = this._mantissa < 0n;
			return e._create(0n, 0, 0, t);
		}
		let [i, a] = Ss(r, 0);
		return e._create(i, a, 0, !1);
	}
	ceil() {
		if (this._special !== 0 || this._mantissa === 0n || this._exponent >= 0) return this;
		let t = Es(-this._exponent), n = this._mantissa, r = n / t;
		if (n > 0n && n % t !== 0n && (r += 1n), r === 0n) return e._create(0n, 0, 0, !1);
		let [i, a] = Ss(r, 0);
		return e._create(i, a, 0, !1);
	}
	log(t) {
		if (this._special === 1) return this;
		if (this._special === 3) return e._create(0n, 0, 1, !1);
		if (this._special === 2) return e._create(0n, 0, 2, !1);
		if (this._mantissa < 0n) return e._create(0n, 0, 1, !1);
		if (this._mantissa === 0n) return e._create(0n, 0, 3, !1);
		if (t === 10) return this._log10();
		let n = this._log10(), r = new e(Math.log10(t));
		return n.div(r);
	}
	_log10() {
		let t = Cs(this._mantissa), n = ws(t), r;
		if (n <= 15) r = Math.log10(Number(t));
		else {
			let e = n - 17, i = t / Es(e);
			r = Math.log10(Number(i)) + e;
		}
		return new e(r + this._exponent);
	}
	eq(t) {
		let n = e._coerce(t);
		return this._special === 1 || n._special === 1 || this._special !== n._special ? !1 : this._special !== 0 || this._mantissa === 0n && n._mantissa === 0n || this._mantissa === n._mantissa && this._exponent === n._exponent;
	}
	_compareTo(e) {
		if (this._special === 1 || e._special === 1) return NaN;
		if (this._special === 2) return e._special === 2 ? 0 : 1;
		if (this._special === 3) return e._special === 3 ? 0 : -1;
		if (e._special === 2) return -1;
		if (e._special === 3) return 1;
		let t = this._mantissa === 0n, n = e._mantissa === 0n;
		if (t && n) return 0;
		if (t) return e._mantissa > 0n ? -1 : 1;
		if (n) return this._mantissa > 0n ? 1 : -1;
		let r = this._mantissa < 0n;
		if (r !== e._mantissa < 0n) return r ? -1 : 1;
		let i = this._mantissa, a = e._mantissa, o = this._exponent, s = e._exponent, c = Math.min(o, s);
		return o > c && (i *= Es(o - c)), s > c && (a *= Es(s - c)), i < a ? -1 : +(i > a);
	}
	lessThan(t) {
		return this._compareTo(e._coerce(t)) === -1;
	}
	greaterThan(t) {
		return this._compareTo(e._coerce(t)) === 1;
	}
	lessThanOrEqualTo(t) {
		let n = this._compareTo(e._coerce(t));
		return n === 0 || n === -1;
	}
	greaterThanOrEqualTo(t) {
		let n = this._compareTo(e._coerce(t));
		return n === 0 || n === 1;
	}
	isZero() {
		return this._special === 0 && this._mantissa === 0n;
	}
	isNaN() {
		return this._special === 1;
	}
	isFinite() {
		return this._special === 0;
	}
	isNegative() {
		return this._special === 1 ? !1 : this._special === 3 ? !0 : this._special === 2 ? !1 : this._mantissa === 0n ? this._negativeZero : this._mantissa < 0n;
	}
	isPositive() {
		return this._special === 1 ? !1 : this._special === 2 ? !0 : this._special === 3 ? !1 : this._mantissa === 0n ? !this._negativeZero : this._mantissa > 0n;
	}
	isInteger() {
		return this._special === 0 ? this._mantissa === 0n || this._exponent >= 0 : !1;
	}
	toJSON() {
		return this.toString();
	}
	toNumber() {
		return this._special === 1 ? NaN : this._special === 2 ? Infinity : this._special === 3 ? -Infinity : this._mantissa === 0n ? this._negativeZero ? -0 : 0 : Number(this.toString());
	}
	toString() {
		if (this._special === 1) return "NaN";
		if (this._special === 2) return "Infinity";
		if (this._special === 3) return "-Infinity";
		if (this._mantissa === 0n) return "0";
		let e = this._mantissa < 0n, t = Cs(this._mantissa).toString(), n = e ? "-" : "";
		if (this._exponent === 0) return n + t;
		if (this._exponent > 0) return n + t + "0".repeat(this._exponent);
		let r = -this._exponent;
		if (r < t.length) {
			let e = t.slice(0, t.length - r), i = t.slice(t.length - r);
			return n + e + "." + i;
		}
		{
			let e = r - t.length;
			return n + "0." + "0".repeat(e) + t;
		}
	}
	static pow(t, n) {
		let r = typeof n == "number" ? n : n.toNumber();
		return typeof t == "number" && t === 10 ? e._create(1n, r, 0, !1) : (t instanceof e ? t : new e(t)).pow(r);
	}
	static set(e) {}
	_isSignNegative() {
		return this._special === 3 || this._mantissa < 0n || this._mantissa === 0n && this._negativeZero;
	}
	_specialArith(t, n) {
		let r = this._special, i = t._special;
		if (r === 1 || i === 1) return e._create(0n, 0, 1, !1);
		let a = this._isSignNegative(), o = t._isSignNegative(), s = r === 2 || r === 3, c = i === 2 || i === 3;
		if (n === "times" && (s || c)) {
			if (s && t._mantissa === 0n && !c || c && this._mantissa === 0n && !s) return e._create(0n, 0, 1, !1);
			let n = a !== o;
			return e._create(0n, 0, n ? 3 : 2, !1);
		}
		if (n === "div") {
			if (s && c) return e._create(0n, 0, 1, !1);
			if (s) {
				let t = a !== o;
				return e._create(0n, 0, t ? 3 : 2, !1);
			}
			if (c) {
				let t = a !== o;
				return e._create(0n, 0, 0, t);
			}
		}
		if (n === "plus") {
			if (s && c) return a === o ? this : e._create(0n, 0, 1, !1);
			if (s) return this;
			if (c) return t;
		}
		return e._create(0n, 0, 1, !1);
	}
}, ks = /* @__PURE__ */ "adlm.ahom.arab.arabext.armn.armnlow.bali.beng.bhks.brah.cakm.cham.cyrl.deva.diak.ethi.fullwide.gara.geor.gong.gonm.grek.greklow.gujr.gukh.guru.hanidays.hanidec.hans.hansfin.hant.hantfin.hebr.hmng.hmnp.java.jpan.jpanfin.jpanyear.kali.kawi.khmr.knda.krai.lana.lanatham.laoo.latn.lepc.limb.mathbold.mathdbl.mathmono.mathsanb.mathsans.mlym.modi.mong.mroo.mtei.mymr.mymrepka.mymrpao.mymrshan.mymrtlng.nagm.newa.nkoo.olck.onao.orya.osma.outlined.rohg.roman.romanlow.saur.segment.shrd.sind.sinh.sora.sund.sunu.takr.talu.taml.tamldec.telu.thai.tibt.tirh.tnsa.tols.vaii.wara.wcho".split(".");
function As(e) {
	return /^[a-z0-9]{3,8}(-[a-z0-9]{3,8})*(?![\s\S])/i.test(e);
}
function js(e) {
	return typeof e == "function";
}
function Ms(e, t, n) {
	if (!js(e)) return !1;
	if (n?.boundTargetFunction) return t instanceof n?.boundTargetFunction;
	if (typeof t != "object") return !1;
	let r = e.prototype;
	if (typeof r != "object") throw TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
	return Object.prototype.isPrototypeOf.call(r, t);
}
function Ns(e) {
	if (e == null) throw TypeError("undefined/null cannot be converted to object");
	return Object(e);
}
function Ps(e) {
	return Intl.getCanonicalLocales(e);
}
function Fs(e, t, n, r) {
	if (e === void 0) return r;
	let i = +e;
	if (isNaN(i) || i < t || i > n) throw RangeError(`${i} is outside of range [${t}, ${n}]`);
	return Math.floor(i);
}
function Is(e, t, n, r, i) {
	let a = e[t];
	return Fs(a, n, r, i);
}
function Ls(e) {
	if (typeof e == "symbol") throw TypeError("Cannot convert a Symbol value to a string");
	return String(e);
}
function Rs(e, t, n, r, i) {
	if (e === null || typeof e != "object" && typeof e != "function") throw TypeError("Options must be an object");
	let a = e[t];
	if (a !== void 0) {
		if (n !== "boolean" && n !== "string") throw TypeError("invalid type");
		if (n === "boolean" && (a = !!a), n === "string" && (a = Ls(a)), r !== void 0 && !r.filter((e) => e == a).length) throw RangeError(`${a} is not within ${r.join(", ")}`);
		return a;
	}
	return i;
}
function zs(e, t, n) {
	return n !== void 0 && (n = Ns(n), Rs(n, "localeMatcher", "string", ["lookup", "best fit"], "best fit")), bs(Array.from(e), t);
}
function Bs(e, t) {
	let n = t && t.cache ? t.cache : Xs, r = t && t.serializer ? t.serializer : Js;
	return (t && t.strategy ? t.strategy : Gs)(e, {
		cache: n,
		serializer: r
	});
}
function Vs(e) {
	return e == null || typeof e == "number" || typeof e == "boolean";
}
function Hs(e, t, n, r) {
	let i = Vs(r) ? r : n(r), a = t.get(i);
	return a === void 0 && (a = e.call(this, r), t.set(i, a)), a;
}
function Us(e, t, n) {
	let r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
	return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
}
function Ws(e, t, n, r, i) {
	return n.bind(t, e, r, i);
}
function Gs(e, t) {
	let n = e.length === 1 ? Hs : Us;
	return Ws(e, this, n, t.cache.create(), t.serializer);
}
function Ks(e, t) {
	return Ws(e, this, Us, t.cache.create(), t.serializer);
}
function qs(e, t) {
	return Ws(e, this, Hs, t.cache.create(), t.serializer);
}
var Js = function() {
	return JSON.stringify(arguments);
}, Ys = class {
	constructor() {
		this.cache = Object.create(null);
	}
	get(e) {
		return this.cache[e];
	}
	set(e, t) {
		this.cache[e] = t;
	}
}, Xs = { create: function() {
	return new Ys();
} }, Zs = {
	variadic: Ks,
	monadic: qs
};
function Qs(e, t, n = Error) {
	if (!e) throw new n(t);
}
var $s = Bs((...e) => new Intl.NumberFormat(...e), { strategy: Zs.variadic });
Bs((...e) => new Intl.PluralRules(...e), { strategy: Zs.variadic });
var ec = Bs((...e) => new Intl.ListFormat(...e), { strategy: Zs.variadic });
function tc(e, t, n, r, i, a, o = !1) {
	let s = Rs(t, e, "string", r, void 0), c = "always";
	s === void 0 && (n === "digital" ? (s = i, e !== "hours" && e !== "minutes" && e !== "seconds" && (c = "auto")) : a === "fractional" || a === "numeric" || a === "2-digit" ? (s = "numeric", e !== "minutes" && e !== "seconds" && (c = "auto")) : (s = n, c = "auto")), s === "numeric" && (e === "milliseconds" || e === "microseconds" || e === "nanoseconds") && (s = "fractional", c = "auto");
	let l = Rs(t, `${e}Display`, "string", ["always", "auto"], c);
	if (l === "always" && s === "fractional") throw RangeError("Fractional units cannot use always display");
	if (a === "fractional" && s !== "fractional") throw RangeError("Fractional units must be followed by fractional units");
	if ((a === "numeric" || a === "2-digit") && s !== "fractional" && s !== "numeric" && s !== "2-digit") throw RangeError("Can't mix numeric and non-numeric styles");
	return o && e === "hours" && (s = "2-digit"), (e === "minutes" || e === "seconds") && (a === "numeric" || a === "2-digit") && (s = "2-digit"), {
		style: s,
		display: l
	};
}
var nc = [
	{
		valueField: "years",
		styleSlot: "years",
		displaySlot: "yearsDisplay",
		unit: "years",
		numberFormatUnit: "year"
	},
	{
		valueField: "months",
		styleSlot: "months",
		displaySlot: "monthsDisplay",
		unit: "months",
		numberFormatUnit: "month"
	},
	{
		valueField: "weeks",
		styleSlot: "weeks",
		displaySlot: "weeksDisplay",
		unit: "weeks",
		numberFormatUnit: "week"
	},
	{
		valueField: "days",
		styleSlot: "days",
		displaySlot: "daysDisplay",
		unit: "days",
		numberFormatUnit: "day"
	},
	{
		valueField: "hours",
		styleSlot: "hours",
		displaySlot: "hoursDisplay",
		unit: "hours",
		numberFormatUnit: "hour"
	},
	{
		valueField: "minutes",
		styleSlot: "minutes",
		displaySlot: "minutesDisplay",
		unit: "minutes",
		numberFormatUnit: "minute"
	},
	{
		valueField: "seconds",
		styleSlot: "seconds",
		displaySlot: "secondsDisplay",
		unit: "seconds",
		numberFormatUnit: "second"
	},
	{
		valueField: "milliseconds",
		styleSlot: "milliseconds",
		displaySlot: "millisecondsDisplay",
		unit: "milliseconds",
		numberFormatUnit: "millisecond"
	},
	{
		valueField: "microseconds",
		styleSlot: "microseconds",
		displaySlot: "microsecondsDisplay",
		unit: "microseconds",
		numberFormatUnit: "microsecond"
	},
	{
		valueField: "nanoseconds",
		styleSlot: "nanoseconds",
		displaySlot: "nanosecondsDisplay",
		unit: "nanoseconds",
		numberFormatUnit: "nanosecond"
	}
], rc = /* @__PURE__ */ new WeakMap();
function ic(e) {
	let t = rc.get(e);
	return t || (t = Object.create(null), rc.set(e, t)), t;
}
function ac(e, t) {
	let n = [], r = !1, i = !1, a = !0, o = nc.some((e) => t[e.valueField] < 0), s = ic(e), c = s.dataLocale, l = Sc.localeData[c];
	if (!l) throw TypeError("Invalid locale");
	let u = s.numberingSystem, d = l.digitalFormat[u] ?? l.digitalFormat.default;
	for (let e = 0; e < nc.length && !r; e++) {
		let c = nc[e], l = new Os(BigInt(t[c.valueField])), u = s[c.styleSlot], f = s[c.displaySlot], { unit: p, numberFormatUnit: m } = c, h = Object.create(null);
		if (p === "seconds" || p === "milliseconds" || p === "microseconds") {
			let e;
			e = p === "seconds" ? s.milliseconds : p === "milliseconds" ? s.microseconds : s.nanoseconds, (e === "numeric" || e === "fractional") && (l = p === "seconds" ? l.plus(new Os(BigInt(t.milliseconds)).div(1e3)).plus(new Os(BigInt(t.microseconds)).div(1e6)).plus(new Os(BigInt(t.nanoseconds)).div(1e9)) : p === "milliseconds" ? l.plus(new Os(BigInt(t.microseconds)).div(1e3)).plus(new Os(BigInt(t.nanoseconds)).div(1e6)) : l.plus(new Os(BigInt(t.nanoseconds)).div(1e3)), s.fractionalDigits === void 0 ? (h.maximumFractionDigits = 9, h.minimumFractionDigits = 0) : (h.maximumFractionDigits = s.fractionalDigits, h.minimumFractionDigits = s.fractionalDigits), h.roundingMode = "trunc", r = !0);
		}
		let g = p === "minutes" && i && (s.secondsDisplay === "always" || t.seconds !== 0 || t.milliseconds !== 0 || t.microseconds !== 0 || t.nanoseconds !== 0);
		if (!l.isZero() || f !== "auto" || g) {
			a ? (l.isZero() && o && (l = new Os("-0")), a = !1) : h.signDisplay = "never", h.numberingSystem = s.numberingSystem, (u === "numeric" || u === "2-digit") && (h.useGrouping = !1), u === "2-digit" && (h.minimumIntegerDigits = 2), u !== "2-digit" && u !== "numeric" && u !== "fractional" && (h.style = "unit", h.unit = m, h.unitDisplay = u);
			let e = $s(s.locale, h), t;
			i ? (t = n[n.length - 1], t.push({
				type: "literal",
				value: d
			})) : t = [], e.formatToParts(l.isZero() && l.isNegative() ? -0 : l).forEach(({ type: e, value: n }) => {
				t.push({
					type: e,
					value: n,
					unit: m
				});
			}), i || ((u === "2-digit" || u === "numeric") && (i = !0), n.push(t));
		} else i = !1;
	}
	let f = Object.create(null);
	f.type = "unit";
	let p = s.style;
	p === "digital" && (p = "short"), f.style = p;
	let m = ec(s.locale, f), h = [];
	for (let e of n) {
		let t = "";
		for (let { value: n } of e) t += n;
		h.push(t);
	}
	let g = m.formatToParts(h), _ = 0, v = n.length, y = [];
	for (let { type: e, value: t } of g) if (e === "element") {
		Qs(_ < v, "Index out of bounds");
		let e = n[_];
		for (let t of e) y.push(t);
		_++;
	} else Qs(e === "literal", "Type must be literal"), y.push({
		type: "literal",
		value: t
	});
	return y;
}
var oc = [
	"years",
	"months",
	"weeks",
	"days",
	"hours",
	"minutes",
	"seconds",
	"milliseconds",
	"microseconds",
	"nanoseconds"
];
function sc(e) {
	for (let t of oc) {
		if (e[t] < 0) return -1;
		if (e[t] > 0) return 1;
	}
	return 0;
}
function cc(e) {
	let t = sc(e);
	for (let n of oc) {
		let r = e[n];
		if (!Number.isFinite(r) || r < 0 && t > 0 || r > 0 && t < 0) return !1;
	}
	if ([
		"years",
		"months",
		"weeks"
	].some((t) => Math.abs(e[t]) >= 2 ** 32)) return !1;
	let n = BigInt(1e9), r = BigInt(e.days) * BigInt(86400) * n + BigInt(e.hours) * BigInt(3600) * n + BigInt(e.minutes) * BigInt(60) * n + BigInt(e.seconds) * n + BigInt(e.milliseconds) * BigInt(1e6) + BigInt(e.microseconds) * BigInt(1e3) + BigInt(e.nanoseconds), i = BigInt(2 ** 53) * n;
	return r > -i && r < i;
}
function lc(e) {
	return new Os(+e);
}
function uc(e) {
	let t = lc(e);
	return Qs(t.isInteger(), "Duration field is not an integer", RangeError), t.isZero() ? 0 : t.toNumber();
}
function dc(e) {
	if ((typeof e != "object" || !e) && typeof e != "function") throw typeof e == "string" ? RangeError("Invalid duration format") : TypeError("Invalid duration");
	let t = {
		years: 0,
		months: 0,
		weeks: 0,
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
		milliseconds: 0,
		microseconds: 0,
		nanoseconds: 0
	}, n = !1;
	for (let r of [
		"days",
		"hours",
		"microseconds",
		"milliseconds",
		"minutes",
		"months",
		"nanoseconds",
		"seconds",
		"weeks",
		"years"
	]) {
		let i = e[r];
		i !== void 0 && (n = !0, t[r] = uc(i));
	}
	if (!n) throw TypeError("Invalid duration format");
	if (!cc(t)) throw RangeError("Invalid duration format");
	return t;
}
var fc = globalThis.Temporal?.Duration, pc = fc?.from, mc = [
	"years",
	"months",
	"weeks",
	"days",
	"hours",
	"minutes",
	"seconds",
	"milliseconds",
	"microseconds",
	"nanoseconds"
], hc = fc && mc.map((e) => Object.getOwnPropertyDescriptor(fc.prototype, e).get);
function gc(e) {
	if (typeof e == "string" && pc && (e = pc.call(fc, e)), hc && e !== null && (typeof e == "object" || typeof e == "function")) {
		let t;
		try {
			t = hc[0].call(e);
		} catch {
			return dc(e);
		}
		let n = Object.create(null);
		n.years = t;
		for (let t = 1; t < mc.length; t++) n[mc[t]] = hc[t].call(e);
		return n;
	}
	return dc(e);
}
var _c = {
	default: ":",
	localeData: {
		aa: { nu: ["latn"] },
		"aa-DJ": { nu: ["latn"] },
		"aa-ER": { nu: ["latn"] },
		ab: { nu: ["latn"] },
		af: { nu: ["latn"] },
		"af-NA": { nu: ["latn"] },
		agq: { nu: ["latn"] },
		ak: { nu: ["latn"] },
		am: { nu: ["latn"] },
		an: { nu: ["latn"] },
		ann: { nu: ["latn"] },
		apc: { nu: ["latn"] },
		ar: { nu: ["latn", "latn"] },
		"ar-AE": { nu: ["latn", "latn"] },
		"ar-BH": { nu: ["arab", "latn"] },
		"ar-DJ": { nu: ["arab", "latn"] },
		"ar-DZ": { nu: ["latn", "latn"] },
		"ar-EG": { nu: ["arab", "latn"] },
		"ar-EH": { nu: ["latn", "latn"] },
		"ar-ER": { nu: ["arab", "latn"] },
		"ar-IL": { nu: ["arab", "latn"] },
		"ar-IQ": { nu: ["arab", "latn"] },
		"ar-JO": { nu: ["arab", "latn"] },
		"ar-KM": { nu: ["arab", "latn"] },
		"ar-KW": { nu: ["arab", "latn"] },
		"ar-LB": { nu: ["arab", "latn"] },
		"ar-LY": { nu: ["latn", "latn"] },
		"ar-MA": { nu: ["latn", "latn"] },
		"ar-MR": { nu: ["arab", "latn"] },
		"ar-OM": { nu: ["arab", "latn"] },
		"ar-PS": { nu: ["arab", "latn"] },
		"ar-QA": { nu: ["arab", "latn"] },
		"ar-SA": { nu: ["arab", "latn"] },
		"ar-SD": { nu: ["arab", "latn"] },
		"ar-SO": { nu: ["arab", "latn"] },
		"ar-SS": { nu: ["arab", "latn"] },
		"ar-SY": { nu: ["arab", "latn"] },
		"ar-TD": { nu: ["arab", "latn"] },
		"ar-TN": { nu: ["latn", "latn"] },
		"ar-YE": { nu: ["arab", "latn"] },
		arn: { nu: ["latn"] },
		as: { nu: ["beng"] },
		asa: { nu: ["latn"] },
		ast: { nu: ["latn"] },
		az: { nu: ["latn"] },
		"az-Arab": { nu: ["arabext"] },
		"az-Arab-IQ": { nu: ["arabext"] },
		"az-Arab-TR": { nu: ["arabext"] },
		"az-Cyrl": { nu: ["latn"] },
		"az-Latn": { nu: ["latn"] },
		ba: { nu: ["latn"] },
		bal: { nu: ["latn"] },
		"bal-Arab": { nu: ["latn"] },
		"bal-Latn": { nu: ["latn"] },
		bas: { nu: ["latn"] },
		be: { nu: ["latn"] },
		"be-tarask": { nu: ["latn"] },
		bem: { nu: ["latn"] },
		bew: { nu: ["latn"] },
		bez: { nu: ["latn"] },
		bg: { nu: ["latn"] },
		bgc: { nu: ["deva"] },
		bgn: { nu: ["arabext"] },
		"bgn-AE": { nu: ["arabext"] },
		"bgn-AF": { nu: ["arabext"] },
		"bgn-IR": { nu: ["arabext"] },
		"bgn-OM": { nu: ["arabext"] },
		bho: { nu: ["deva"] },
		blo: { nu: ["latn"] },
		blt: { nu: ["latn"] },
		bm: { nu: ["latn"] },
		"bm-Nkoo": { nu: ["latn"] },
		bn: { nu: ["beng"] },
		"bn-IN": { nu: ["beng"] },
		bo: { nu: ["latn"] },
		"bo-IN": { nu: ["latn"] },
		bqi: { nu: ["latn"] },
		br: { nu: ["latn"] },
		brx: { nu: ["latn"] },
		bs: { nu: ["latn"] },
		"bs-Cyrl": { nu: ["latn"] },
		"bs-Latn": { nu: ["latn"] },
		bss: { nu: ["latn"] },
		bua: { nu: ["latn"] },
		byn: { nu: ["latn"] },
		ca: { nu: ["latn"] },
		"ca-AD": { nu: ["latn"] },
		"ca-ES-valencia": { nu: ["latn"] },
		"ca-FR": { nu: ["latn"] },
		"ca-IT": { nu: ["latn"] },
		cad: { nu: ["latn"] },
		cch: { nu: ["latn"] },
		ccp: { nu: ["cakm"] },
		"ccp-IN": { nu: ["cakm"] },
		ce: { nu: ["latn"] },
		ceb: { nu: ["latn"] },
		cgg: { nu: ["latn"] },
		cho: { nu: ["latn"] },
		chr: { nu: ["latn"] },
		cic: { nu: ["latn"] },
		ckb: { nu: ["arab"] },
		"ckb-IR": { nu: ["arab"] },
		co: { nu: ["latn"] },
		cop: { nu: ["latn"] },
		cs: { nu: ["latn"] },
		csw: { nu: ["latn"] },
		cu: { nu: ["latn"] },
		cv: { nu: ["latn"] },
		cy: { nu: ["latn"] },
		da: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		"da-GL": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		dav: { nu: ["latn"] },
		de: { nu: ["latn"] },
		"de-AT": { nu: ["latn"] },
		"de-BE": { nu: ["latn"] },
		"de-CH": { nu: ["latn"] },
		"de-IT": { nu: ["latn"] },
		"de-LI": { nu: ["latn"] },
		"de-LU": { nu: ["latn"] },
		dje: { nu: ["latn"] },
		doi: { nu: ["latn"] },
		dsb: { nu: ["latn"] },
		dua: { nu: ["latn"] },
		dv: { nu: ["latn"] },
		dyo: { nu: ["latn"] },
		dz: { nu: ["tibt"] },
		ebu: { nu: ["latn"] },
		ee: { nu: ["latn"] },
		"ee-TG": { nu: ["latn"] },
		el: { nu: ["latn"] },
		"el-CY": { nu: ["latn"] },
		"el-polyton": { nu: ["latn"] },
		en: { nu: ["latn"] },
		"en-001": { nu: ["latn"] },
		"en-150": { nu: ["latn"] },
		"en-AE": { nu: ["latn"] },
		"en-AG": { nu: ["latn"] },
		"en-AI": { nu: ["latn"] },
		"en-AS": { nu: ["latn"] },
		"en-AT": { nu: ["latn"] },
		"en-AU": { nu: ["latn"] },
		"en-BB": { nu: ["latn"] },
		"en-BE": { nu: ["latn"] },
		"en-BI": { nu: ["latn"] },
		"en-BM": { nu: ["latn"] },
		"en-BS": { nu: ["latn"] },
		"en-BW": { nu: ["latn"] },
		"en-BZ": { nu: ["latn"] },
		"en-CA": { nu: ["latn"] },
		"en-CC": { nu: ["latn"] },
		"en-CH": { nu: ["latn"] },
		"en-CK": { nu: ["latn"] },
		"en-CM": { nu: ["latn"] },
		"en-CX": { nu: ["latn"] },
		"en-CY": { nu: ["latn"] },
		"en-CZ": { nu: ["latn"] },
		"en-DE": { nu: ["latn"] },
		"en-DG": { nu: ["latn"] },
		"en-DK": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		"en-DM": { nu: ["latn"] },
		"en-Dsrt": { nu: ["latn"] },
		"en-EE": { nu: ["latn"] },
		"en-ER": { nu: ["latn"] },
		"en-ES": { nu: ["latn"] },
		"en-FI": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		"en-FJ": { nu: ["latn"] },
		"en-FK": { nu: ["latn"] },
		"en-FM": { nu: ["latn"] },
		"en-FR": { nu: ["latn"] },
		"en-GB": { nu: ["latn"] },
		"en-GD": { nu: ["latn"] },
		"en-GE": { nu: ["latn"] },
		"en-GG": { nu: ["latn"] },
		"en-GH": { nu: ["latn"] },
		"en-GI": { nu: ["latn"] },
		"en-GM": { nu: ["latn"] },
		"en-GS": { nu: ["latn"] },
		"en-GU": { nu: ["latn"] },
		"en-GY": { nu: ["latn"] },
		"en-HK": { nu: ["latn"] },
		"en-HU": { nu: ["latn"] },
		"en-ID": { nu: ["latn"] },
		"en-IE": { nu: ["latn"] },
		"en-IL": { nu: ["latn"] },
		"en-IM": { nu: ["latn"] },
		"en-IN": { nu: ["latn"] },
		"en-IO": { nu: ["latn"] },
		"en-IT": { nu: ["latn"] },
		"en-JE": { nu: ["latn"] },
		"en-JM": { nu: ["latn"] },
		"en-JP": { nu: ["latn"] },
		"en-KE": { nu: ["latn"] },
		"en-KI": { nu: ["latn"] },
		"en-KN": { nu: ["latn"] },
		"en-KY": { nu: ["latn"] },
		"en-LC": { nu: ["latn"] },
		"en-LR": { nu: ["latn"] },
		"en-LS": { nu: ["latn"] },
		"en-LT": { nu: ["latn"] },
		"en-LV": { nu: ["latn"] },
		"en-MG": { nu: ["latn"] },
		"en-MH": { nu: ["latn"] },
		"en-MO": { nu: ["latn"] },
		"en-MP": { nu: ["latn"] },
		"en-MS": { nu: ["latn"] },
		"en-MT": { nu: ["latn"] },
		"en-MU": { nu: ["latn"] },
		"en-MV": { nu: ["latn"] },
		"en-MW": { nu: ["latn"] },
		"en-MY": { nu: ["latn"] },
		"en-NA": { nu: ["latn"] },
		"en-NF": { nu: ["latn"] },
		"en-NG": { nu: ["latn"] },
		"en-NL": { nu: ["latn"] },
		"en-NO": { nu: ["latn"] },
		"en-NR": { nu: ["latn"] },
		"en-NU": { nu: ["latn"] },
		"en-NZ": { nu: ["latn"] },
		"en-PG": { nu: ["latn"] },
		"en-PH": { nu: ["latn"] },
		"en-PK": { nu: ["latn"] },
		"en-PL": { nu: ["latn"] },
		"en-PN": { nu: ["latn"] },
		"en-PR": { nu: ["latn"] },
		"en-PT": { nu: ["latn"] },
		"en-PW": { nu: ["latn"] },
		"en-RO": { nu: ["latn"] },
		"en-RW": { nu: ["latn"] },
		"en-SB": { nu: ["latn"] },
		"en-SC": { nu: ["latn"] },
		"en-SD": { nu: ["latn"] },
		"en-SE": { nu: ["latn"] },
		"en-SG": { nu: ["latn"] },
		"en-SH": { nu: ["latn"] },
		"en-SI": { nu: ["latn"] },
		"en-SK": { nu: ["latn"] },
		"en-SL": { nu: ["latn"] },
		"en-SS": { nu: ["latn"] },
		"en-SX": { nu: ["latn"] },
		"en-SZ": { nu: ["latn"] },
		"en-Shaw": { nu: ["latn"] },
		"en-TC": { nu: ["latn"] },
		"en-TK": { nu: ["latn"] },
		"en-TO": { nu: ["latn"] },
		"en-TT": { nu: ["latn"] },
		"en-TV": { nu: ["latn"] },
		"en-TZ": { nu: ["latn"] },
		"en-UA": { nu: ["latn"] },
		"en-UG": { nu: ["latn"] },
		"en-UM": { nu: ["latn"] },
		"en-VC": { nu: ["latn"] },
		"en-VG": { nu: ["latn"] },
		"en-VI": { nu: ["latn"] },
		"en-VU": { nu: ["latn"] },
		"en-WS": { nu: ["latn"] },
		"en-ZA": { nu: ["latn"] },
		"en-ZM": { nu: ["latn"] },
		"en-ZW": { nu: ["latn"] },
		eo: { nu: ["latn"] },
		es: { nu: ["latn"] },
		"es-419": { nu: ["latn"] },
		"es-AR": { nu: ["latn"] },
		"es-BO": { nu: ["latn"] },
		"es-BR": { nu: ["latn"] },
		"es-BZ": { nu: ["latn"] },
		"es-CL": { nu: ["latn"] },
		"es-CO": { nu: ["latn"] },
		"es-CR": { nu: ["latn"] },
		"es-CU": { nu: ["latn"] },
		"es-DO": { nu: ["latn"] },
		"es-EA": { nu: ["latn"] },
		"es-EC": { nu: ["latn"] },
		"es-GQ": { nu: ["latn"] },
		"es-GT": { nu: ["latn"] },
		"es-HN": { nu: ["latn"] },
		"es-IC": { nu: ["latn"] },
		"es-MX": { nu: ["latn"] },
		"es-NI": { nu: ["latn"] },
		"es-PA": { nu: ["latn"] },
		"es-PE": { nu: ["latn"] },
		"es-PH": { nu: ["latn"] },
		"es-PR": { nu: ["latn"] },
		"es-PY": { nu: ["latn"] },
		"es-SV": { nu: ["latn"] },
		"es-US": { nu: ["latn"] },
		"es-UY": { nu: ["latn"] },
		"es-VE": { nu: ["latn"] },
		et: { nu: ["latn"] },
		eu: { nu: ["latn"] },
		ewo: { nu: ["latn"] },
		fa: { nu: ["arabext"] },
		"fa-AF": { nu: ["arabext"] },
		ff: { nu: ["latn"] },
		"ff-Adlm": { nu: ["adlm"] },
		"ff-Adlm-BF": { nu: ["adlm"] },
		"ff-Adlm-CM": { nu: ["adlm"] },
		"ff-Adlm-GH": { nu: ["adlm"] },
		"ff-Adlm-GM": { nu: ["adlm"] },
		"ff-Adlm-GW": { nu: ["adlm"] },
		"ff-Adlm-LR": { nu: ["adlm"] },
		"ff-Adlm-MR": { nu: ["adlm"] },
		"ff-Adlm-NE": { nu: ["adlm"] },
		"ff-Adlm-NG": { nu: ["adlm"] },
		"ff-Adlm-SL": { nu: ["adlm"] },
		"ff-Adlm-SN": { nu: ["adlm"] },
		"ff-Latn": { nu: ["latn"] },
		"ff-Latn-BF": { nu: ["latn"] },
		"ff-Latn-CM": { nu: ["latn"] },
		"ff-Latn-GH": { nu: ["latn"] },
		"ff-Latn-GM": { nu: ["latn"] },
		"ff-Latn-GN": { nu: ["latn"] },
		"ff-Latn-GW": { nu: ["latn"] },
		"ff-Latn-LR": { nu: ["latn"] },
		"ff-Latn-MR": { nu: ["latn"] },
		"ff-Latn-NE": { nu: ["latn"] },
		"ff-Latn-NG": { nu: ["latn"] },
		"ff-Latn-SL": { nu: ["latn"] },
		fi: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		fil: { nu: ["latn"] },
		fo: { nu: ["latn"] },
		"fo-DK": { nu: ["latn"] },
		fr: { nu: ["latn"] },
		"fr-BE": { nu: ["latn"] },
		"fr-BF": { nu: ["latn"] },
		"fr-BI": { nu: ["latn"] },
		"fr-BJ": { nu: ["latn"] },
		"fr-BL": { nu: ["latn"] },
		"fr-CA": { nu: ["latn"] },
		"fr-CD": { nu: ["latn"] },
		"fr-CF": { nu: ["latn"] },
		"fr-CG": { nu: ["latn"] },
		"fr-CH": { nu: ["latn"] },
		"fr-CI": { nu: ["latn"] },
		"fr-CM": { nu: ["latn"] },
		"fr-DJ": { nu: ["latn"] },
		"fr-DZ": { nu: ["latn"] },
		"fr-GA": { nu: ["latn"] },
		"fr-GF": { nu: ["latn"] },
		"fr-GN": { nu: ["latn"] },
		"fr-GP": { nu: ["latn"] },
		"fr-GQ": { nu: ["latn"] },
		"fr-HT": { nu: ["latn"] },
		"fr-KM": { nu: ["latn"] },
		"fr-LU": { nu: ["latn"] },
		"fr-MA": { nu: ["latn"] },
		"fr-MC": { nu: ["latn"] },
		"fr-MF": { nu: ["latn"] },
		"fr-MG": { nu: ["latn"] },
		"fr-ML": { nu: ["latn"] },
		"fr-MQ": { nu: ["latn"] },
		"fr-MR": { nu: ["latn"] },
		"fr-MU": { nu: ["latn"] },
		"fr-NC": { nu: ["latn"] },
		"fr-NE": { nu: ["latn"] },
		"fr-PF": { nu: ["latn"] },
		"fr-PM": { nu: ["latn"] },
		"fr-RE": { nu: ["latn"] },
		"fr-RW": { nu: ["latn"] },
		"fr-SC": { nu: ["latn"] },
		"fr-SN": { nu: ["latn"] },
		"fr-SY": { nu: ["latn"] },
		"fr-TD": { nu: ["latn"] },
		"fr-TG": { nu: ["latn"] },
		"fr-TN": { nu: ["latn"] },
		"fr-VU": { nu: ["latn"] },
		"fr-WF": { nu: ["latn"] },
		"fr-YT": { nu: ["latn"] },
		frr: { nu: ["latn"] },
		fur: { nu: ["latn"] },
		fy: { nu: ["latn"] },
		ga: { nu: ["latn"] },
		"ga-GB": { nu: ["latn"] },
		gaa: { nu: ["latn"] },
		gd: { nu: ["latn"] },
		gez: { nu: ["latn"] },
		"gez-ER": { nu: ["latn"] },
		gl: { nu: ["latn"] },
		gn: { nu: ["latn"] },
		gsw: { nu: ["latn"] },
		"gsw-FR": { nu: ["latn"] },
		"gsw-LI": { nu: ["latn"] },
		gu: { nu: ["latn"] },
		guz: { nu: ["latn"] },
		gv: { nu: ["latn"] },
		ha: { nu: ["latn"] },
		"ha-Arab": { nu: ["latn"] },
		"ha-Arab-SD": { nu: ["latn"] },
		"ha-GH": { nu: ["latn"] },
		"ha-NE": { nu: ["latn"] },
		haw: { nu: ["latn"] },
		he: { nu: ["latn"] },
		hi: { nu: ["latn"] },
		"hi-Latn": { nu: ["latn"] },
		hnj: { nu: ["hmnp", "latn"] },
		"hnj-Hmnp": { nu: ["hmnp", "latn"] },
		hr: { nu: ["latn"] },
		"hr-BA": { nu: ["latn"] },
		hsb: { nu: ["latn"] },
		ht: { nu: ["latn"] },
		hu: { nu: ["latn"] },
		hy: { nu: ["latn"] },
		ia: { nu: ["latn"] },
		id: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		ie: { nu: ["latn"] },
		ig: { nu: ["latn"] },
		ii: { nu: ["latn"] },
		io: { nu: ["latn"] },
		is: { nu: ["latn"] },
		it: { nu: ["latn"] },
		"it-CH": { nu: ["latn"] },
		"it-SM": { nu: ["latn"] },
		"it-VA": { nu: ["latn"] },
		iu: { nu: ["latn"] },
		"iu-Latn": { nu: ["latn"] },
		ja: { nu: ["latn"] },
		jbo: { nu: ["latn"] },
		jgo: { nu: ["latn"] },
		jmc: { nu: ["latn"] },
		jv: { nu: ["latn"] },
		ka: { nu: ["latn"] },
		kaa: { nu: ["latn"] },
		"kaa-Cyrl": { nu: ["latn"] },
		"kaa-Latn": { nu: ["latn"] },
		kab: { nu: ["latn"] },
		kaj: { nu: ["latn"] },
		kam: { nu: ["latn"] },
		kcg: { nu: ["latn"] },
		kde: { nu: ["latn"] },
		kea: { nu: ["latn"] },
		kek: { nu: ["latn"] },
		ken: { nu: ["latn"] },
		kgp: { nu: ["latn"] },
		khq: { nu: ["latn"] },
		ki: { nu: ["latn"] },
		kk: { nu: ["latn"] },
		"kk-Arab": { nu: ["latn"] },
		"kk-Cyrl": { nu: ["latn"] },
		"kk-KZ": { nu: ["latn"] },
		kkj: { nu: ["latn"] },
		kl: { nu: ["latn"] },
		kln: { nu: ["latn"] },
		km: { nu: ["latn"] },
		kn: { nu: ["latn"] },
		ko: { nu: ["latn"] },
		"ko-CN": { nu: ["latn"] },
		"ko-KP": { nu: ["latn"] },
		kok: { nu: ["latn"] },
		"kok-Deva": { nu: ["latn"] },
		"kok-Latn": { nu: ["latn"] },
		kpe: { nu: ["latn"] },
		"kpe-GN": { nu: ["latn"] },
		ks: { nu: ["arabext"] },
		"ks-Arab": { nu: ["arabext"] },
		"ks-Deva": { nu: ["latn"] },
		ksb: { nu: ["latn"] },
		ksf: { nu: ["latn"] },
		ksh: { nu: ["latn"] },
		ku: { nu: ["latn"] },
		"ku-Arab": { nu: ["latn"] },
		"ku-Arab-IR": { nu: ["latn"] },
		"ku-Latn": { nu: ["latn"] },
		"ku-Latn-IQ": { nu: ["latn"] },
		"ku-Latn-SY": { nu: ["latn"] },
		"ku-TR": { nu: ["latn"] },
		kw: { nu: ["latn"] },
		kxv: { nu: ["latn"] },
		"kxv-Deva": { nu: ["latn"] },
		"kxv-Latn": { nu: ["latn"] },
		"kxv-Orya": { nu: ["latn"] },
		"kxv-Telu": { nu: ["latn"] },
		ky: { nu: ["latn"] },
		la: { nu: ["latn"] },
		lag: { nu: ["latn"] },
		lb: { nu: ["latn"] },
		lg: { nu: ["latn"] },
		lij: { nu: ["latn"] },
		lkt: { nu: ["latn"] },
		lld: { nu: ["latn"] },
		lmo: { nu: ["latn"] },
		ln: { nu: ["latn"] },
		"ln-AO": { nu: ["latn"] },
		"ln-CF": { nu: ["latn"] },
		"ln-CG": { nu: ["latn"] },
		lo: { nu: ["latn"] },
		lrc: { nu: ["arabext"] },
		"lrc-IQ": { nu: ["arabext"] },
		lt: { nu: ["latn"] },
		ltg: { nu: ["latn"] },
		lu: { nu: ["latn"] },
		luo: { nu: ["latn"] },
		luy: { nu: ["latn"] },
		lv: { nu: ["latn"] },
		lzz: { nu: ["latn"] },
		mai: { nu: ["latn"] },
		mas: { nu: ["latn"] },
		"mas-TZ": { nu: ["latn"] },
		mdf: { nu: ["latn"] },
		mer: { nu: ["latn"] },
		mfe: { nu: ["latn"] },
		mg: { nu: ["latn"] },
		mgh: { nu: ["latn"] },
		mgo: { nu: ["latn"] },
		mhn: { nu: ["latn"] },
		mi: { nu: ["latn"] },
		mic: { nu: ["latn"] },
		mk: { nu: ["latn"] },
		ml: { nu: ["latn"] },
		mn: { nu: ["latn"] },
		"mn-Mong": { nu: ["latn"] },
		"mn-Mong-MN": { nu: ["latn"] },
		mni: { nu: ["beng"] },
		"mni-Beng": { nu: ["beng"] },
		"mni-Mtei": { nu: ["mtei"] },
		moh: { nu: ["latn"] },
		mr: { nu: ["deva"] },
		ms: { nu: ["latn"] },
		"ms-Arab": { nu: ["latn"] },
		"ms-Arab-BN": { nu: ["latn"] },
		"ms-BN": { nu: ["latn"] },
		"ms-ID": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		"ms-SG": { nu: ["latn"] },
		mt: { nu: ["latn"] },
		mua: { nu: ["latn"] },
		mus: { nu: ["latn"] },
		mww: { nu: ["hmnp", "latn"] },
		"mww-Hmnp": { nu: ["hmnp", "latn"] },
		my: { nu: ["mymr"] },
		myv: { nu: ["latn"] },
		mzn: { nu: ["arabext"] },
		naq: { nu: ["latn"] },
		nb: { nu: ["latn"] },
		"nb-SJ": { nu: ["latn"] },
		nd: { nu: ["latn"] },
		nds: { nu: ["latn"] },
		"nds-NL": { nu: ["latn"] },
		ne: { nu: ["deva"] },
		"ne-IN": { nu: ["deva"] },
		nl: { nu: ["latn"] },
		"nl-AW": { nu: ["latn"] },
		"nl-BE": { nu: ["latn"] },
		"nl-BQ": { nu: ["latn"] },
		"nl-CW": { nu: ["latn"] },
		"nl-SR": { nu: ["latn"] },
		"nl-SX": { nu: ["latn"] },
		nmg: { nu: ["latn"] },
		nn: { nu: ["latn"] },
		nnh: { nu: ["latn"] },
		no: { nu: ["latn"] },
		nqo: { nu: ["nkoo"] },
		nr: { nu: ["latn"] },
		nso: { nu: ["latn"] },
		nus: { nu: ["latn"] },
		nv: { nu: ["latn"] },
		ny: { nu: ["latn"] },
		nyn: { nu: ["latn"] },
		oc: { nu: ["latn"] },
		"oc-ES": { nu: ["latn"] },
		oka: { nu: ["latn"] },
		"oka-US": { nu: ["latn"] },
		om: { nu: ["latn"] },
		"om-KE": { nu: ["latn"] },
		or: { nu: ["latn"] },
		os: { nu: ["latn"] },
		"os-RU": { nu: ["latn"] },
		osa: { nu: ["latn"] },
		pa: { nu: ["latn"] },
		"pa-Arab": { nu: ["arabext"] },
		"pa-Guru": { nu: ["latn"] },
		pap: { nu: ["latn"] },
		"pap-AW": { nu: ["latn"] },
		pcm: { nu: ["latn"] },
		pi: { nu: ["latn"] },
		"pi-Latn": { nu: ["latn"] },
		pis: { nu: ["latn"] },
		pl: { nu: ["latn"] },
		pms: { nu: ["latn"] },
		prg: { nu: ["latn"] },
		ps: { nu: ["arabext"] },
		"ps-PK": { nu: ["arabext"] },
		pt: { nu: ["latn"] },
		"pt-AO": { nu: ["latn"] },
		"pt-CH": { nu: ["latn"] },
		"pt-CV": { nu: ["latn"] },
		"pt-GQ": { nu: ["latn"] },
		"pt-GW": { nu: ["latn"] },
		"pt-LU": { nu: ["latn"] },
		"pt-MO": { nu: ["latn"] },
		"pt-MZ": { nu: ["latn"] },
		"pt-PT": { nu: ["latn"] },
		"pt-ST": { nu: ["latn"] },
		"pt-TL": { nu: ["latn"] },
		qu: { nu: ["latn"] },
		"qu-BO": { nu: ["latn"] },
		"qu-EC": { nu: ["latn"] },
		quc: { nu: ["latn"] },
		raj: { nu: ["deva"] },
		rhg: { nu: ["latn"] },
		"rhg-Rohg": { nu: ["latn"] },
		"rhg-Rohg-BD": { nu: ["latn"] },
		rif: { nu: ["latn"] },
		rm: { nu: ["latn"] },
		rn: { nu: ["latn"] },
		ro: { nu: ["latn"] },
		"ro-MD": { nu: ["latn"] },
		rof: { nu: ["latn"] },
		ru: { nu: ["latn"] },
		"ru-BY": { nu: ["latn"] },
		"ru-KG": { nu: ["latn"] },
		"ru-KZ": { nu: ["latn"] },
		"ru-MD": { nu: ["latn"] },
		"ru-UA": { nu: ["latn"] },
		rw: { nu: ["latn"] },
		rwk: { nu: ["latn"] },
		sa: { nu: ["deva"] },
		sah: { nu: ["latn"] },
		saq: { nu: ["latn"] },
		sat: { nu: ["olck"] },
		"sat-Deva": { nu: ["deva"] },
		"sat-Olck": { nu: ["olck"] },
		sbp: { nu: ["latn"] },
		sc: { nu: ["latn"] },
		scn: { nu: ["latn"] },
		sd: { nu: ["arab"] },
		"sd-Arab": { nu: ["arab"] },
		"sd-Deva": { nu: ["latn"] },
		sdh: { nu: ["arab"] },
		"sdh-IQ": { nu: ["arab"] },
		se: { nu: ["latn"] },
		"se-FI": { nu: ["latn"] },
		"se-SE": { nu: ["latn"] },
		seh: { nu: ["latn"] },
		ses: { nu: ["latn"] },
		sg: { nu: ["latn"] },
		sgs: { nu: ["latn"] },
		shi: { nu: ["latn"] },
		"shi-Latn": { nu: ["latn"] },
		"shi-Tfng": { nu: ["latn"] },
		shn: { nu: ["latn"] },
		"shn-TH": { nu: ["latn"] },
		si: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		sid: { nu: ["latn"] },
		sk: { nu: ["latn"] },
		skr: { nu: ["latn"] },
		sl: { nu: ["latn"] },
		sma: { nu: ["latn"] },
		"sma-NO": { nu: ["latn"] },
		smj: { nu: ["latn"] },
		"smj-NO": { nu: ["latn"] },
		smn: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		sms: { nu: ["latn"] },
		sn: { nu: ["latn"] },
		so: { nu: ["latn"] },
		"so-DJ": { nu: ["latn"] },
		"so-ET": { nu: ["latn"] },
		"so-KE": { nu: ["latn"] },
		sq: { nu: ["latn"] },
		"sq-MK": { nu: ["latn"] },
		"sq-XK": { nu: ["latn"] },
		sr: { nu: ["latn"] },
		"sr-Cyrl": { nu: ["latn"] },
		"sr-Cyrl-BA": { nu: ["latn"] },
		"sr-Cyrl-ME": { nu: ["latn"] },
		"sr-Cyrl-XK": { nu: ["latn"] },
		"sr-Latn": { nu: ["latn"] },
		"sr-Latn-BA": { nu: ["latn"] },
		"sr-Latn-ME": { nu: ["latn"] },
		"sr-Latn-XK": { nu: ["latn"] },
		ss: { nu: ["latn"] },
		"ss-SZ": { nu: ["latn"] },
		ssy: { nu: ["latn"] },
		st: { nu: ["latn"] },
		"st-LS": { nu: ["latn"] },
		su: {
			nu: ["latn"],
			separator: { latn: "." }
		},
		"su-Latn": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		suz: { nu: ["latn"] },
		"suz-Deva": { nu: ["latn"] },
		"suz-Sunu": { nu: ["latn"] },
		sv: { nu: ["latn"] },
		"sv-AX": { nu: ["latn"] },
		"sv-FI": {
			nu: ["latn"],
			separator: { latn: "." }
		},
		sw: { nu: ["latn"] },
		"sw-CD": { nu: ["latn"] },
		"sw-KE": { nu: ["latn"] },
		"sw-UG": { nu: ["latn"] },
		syr: { nu: ["latn"] },
		"syr-SY": { nu: ["latn"] },
		szl: { nu: ["latn"] },
		ta: { nu: ["latn"] },
		"ta-LK": { nu: ["latn"] },
		"ta-MY": { nu: ["latn"] },
		"ta-SG": { nu: ["latn"] },
		te: { nu: ["latn"] },
		teo: { nu: ["latn"] },
		"teo-KE": { nu: ["latn"] },
		tg: { nu: ["latn"] },
		th: { nu: ["latn"] },
		ti: { nu: ["latn"] },
		"ti-ER": { nu: ["latn"] },
		tig: { nu: ["latn"] },
		tk: { nu: ["latn"] },
		tn: { nu: ["latn"] },
		"tn-BW": { nu: ["latn"] },
		to: { nu: ["latn"] },
		tok: { nu: ["latn"] },
		tpi: { nu: ["latn"] },
		tr: { nu: ["latn"] },
		"tr-CY": { nu: ["latn"] },
		trv: { nu: ["latn"] },
		trw: { nu: ["latn"] },
		ts: { nu: ["latn"] },
		tt: { nu: ["latn"] },
		twq: { nu: ["latn"] },
		tyv: { nu: ["latn"] },
		tzm: { nu: ["latn"] },
		ug: {
			nu: ["latn"],
			separator: { arabext: "٫" }
		},
		uk: { nu: ["latn"] },
		und: { nu: ["latn"] },
		ur: {
			nu: ["latn"],
			separator: { arabext: "٫" }
		},
		"ur-IN": {
			nu: ["arabext"],
			separator: { arabext: "٫" }
		},
		uz: { nu: ["latn"] },
		"uz-Arab": { nu: ["arabext"] },
		"uz-Cyrl": { nu: ["latn"] },
		"uz-Latn": { nu: ["latn"] },
		vai: { nu: ["latn"] },
		"vai-Latn": { nu: ["latn"] },
		"vai-Vaii": { nu: ["latn"] },
		ve: { nu: ["latn"] },
		vec: { nu: ["latn"] },
		vi: { nu: ["latn"] },
		vmw: { nu: ["latn"] },
		vo: { nu: ["latn"] },
		vun: { nu: ["latn"] },
		wa: { nu: ["latn"] },
		wae: { nu: ["latn"] },
		wal: { nu: ["latn"] },
		wbp: { nu: ["latn"] },
		wo: { nu: ["latn"] },
		xh: { nu: ["latn"] },
		xnr: { nu: ["latn"] },
		xog: { nu: ["latn"] },
		yav: { nu: ["latn"] },
		yi: { nu: ["latn"] },
		yo: { nu: ["latn"] },
		"yo-BJ": { nu: ["latn"] },
		yrl: { nu: ["latn"] },
		"yrl-CO": { nu: ["latn"] },
		"yrl-VE": { nu: ["latn"] },
		yue: { nu: ["latn"] },
		"yue-Hans": { nu: ["latn"] },
		"yue-Hant": { nu: ["latn"] },
		"yue-Hant-CN": { nu: ["latn"] },
		"yue-Hant-MO": { nu: ["latn"] },
		za: { nu: ["latn"] },
		zgh: { nu: ["latn"] },
		zh: { nu: ["latn"] },
		"zh-Hans": { nu: ["latn"] },
		"zh-Hans-HK": { nu: ["latn"] },
		"zh-Hans-MO": { nu: ["latn"] },
		"zh-Hans-MY": { nu: ["latn"] },
		"zh-Hans-SG": { nu: ["latn"] },
		"zh-Hant": { nu: ["latn"] },
		"zh-Hant-HK": { nu: ["latn"] },
		"zh-Hant-MO": { nu: ["latn"] },
		"zh-Hant-MY": { nu: ["latn"] },
		"zh-Latn": { nu: ["latn"] },
		zu: { nu: ["latn"] }
	}
}, vc = /* @__PURE__ */ new WeakMap();
function yc() {
	let e = Intl.NumberFormat, t = vc.get(e);
	return t || (t = ks.filter((t) => {
		let n = Object.create(null);
		n.numberingSystem = t;
		try {
			return new e("en", n).resolvedOptions().numberingSystem === t;
		} catch {
			return !1;
		}
	}), t.length && vc.set(e, t)), t;
}
var bc = [
	"locale",
	"numberingSystem",
	"style",
	"years",
	"yearsDisplay",
	"months",
	"monthsDisplay",
	"weeks",
	"weeksDisplay",
	"days",
	"daysDisplay",
	"hours",
	"hoursDisplay",
	"minutes",
	"minutesDisplay",
	"seconds",
	"secondsDisplay",
	"milliseconds",
	"millisecondsDisplay",
	"microseconds",
	"microsecondsDisplay",
	"nanoseconds",
	"nanosecondsDisplay",
	"fractionalDigits"
], xc = [
	{
		styleSlot: "years",
		displaySlot: "yearsDisplay",
		unit: "years",
		values: [
			"long",
			"short",
			"narrow"
		],
		digitalDefault: "short"
	},
	{
		styleSlot: "months",
		displaySlot: "monthsDisplay",
		unit: "months",
		values: [
			"long",
			"short",
			"narrow"
		],
		digitalDefault: "short"
	},
	{
		styleSlot: "weeks",
		displaySlot: "weeksDisplay",
		unit: "weeks",
		values: [
			"long",
			"short",
			"narrow"
		],
		digitalDefault: "short"
	},
	{
		styleSlot: "days",
		displaySlot: "daysDisplay",
		unit: "days",
		values: [
			"long",
			"short",
			"narrow"
		],
		digitalDefault: "short"
	},
	{
		styleSlot: "hours",
		displaySlot: "hoursDisplay",
		unit: "hours",
		values: [
			"long",
			"short",
			"narrow",
			"numeric",
			"2-digit"
		],
		digitalDefault: "numeric"
	},
	{
		styleSlot: "minutes",
		displaySlot: "minutesDisplay",
		unit: "minutes",
		values: [
			"long",
			"short",
			"narrow",
			"numeric",
			"2-digit"
		],
		digitalDefault: "numeric"
	},
	{
		styleSlot: "seconds",
		displaySlot: "secondsDisplay",
		unit: "seconds",
		values: [
			"long",
			"short",
			"narrow",
			"numeric",
			"2-digit"
		],
		digitalDefault: "numeric"
	},
	{
		styleSlot: "milliseconds",
		displaySlot: "millisecondsDisplay",
		unit: "milliseconds",
		values: [
			"long",
			"short",
			"narrow",
			"numeric"
		],
		digitalDefault: "numeric"
	},
	{
		styleSlot: "microseconds",
		displaySlot: "microsecondsDisplay",
		unit: "microseconds",
		values: [
			"long",
			"short",
			"narrow",
			"numeric"
		],
		digitalDefault: "numeric"
	},
	{
		styleSlot: "nanoseconds",
		displaySlot: "nanosecondsDisplay",
		unit: "nanoseconds",
		values: [
			"long",
			"short",
			"narrow",
			"numeric"
		],
		digitalDefault: "numeric"
	}
], Sc = class e {
	constructor(t, n) {
		if (!(this && this instanceof e && this.constructor)) throw TypeError("Intl.DurationFormat must be called with 'new'");
		let r = Ps(t), i = Object.create(null), a = n === void 0 ? Object.create(null) : Ns(n), o = Rs(a, "localeMatcher", "string", ["best fit", "lookup"], "best fit"), s = Rs(a, "numberingSystem", "string", void 0, void 0);
		if (s !== void 0 && !As(s)) throw RangeError(`Invalid numberingSystems: ${s}`);
		i.nu = s, i.localeMatcher = o;
		let { localeData: c, availableLocales: l } = e, u = ys(l, r, i, ["nu"], c, e.getDefaultLocale), d = u.locale, f = ic(this);
		f.initializedDurationFormat = !0, f.locale = d, f.numberingSystem = u.nu;
		let p = Rs(a, "style", "string", [
			"long",
			"short",
			"narrow",
			"digital"
		], "short");
		f.style = p, f.dataLocale = u.dataLocale;
		let m = "";
		xc.forEach((e) => {
			let { styleSlot: t, displaySlot: n, unit: r, values: i, digitalDefault: o } = e, s = tc(r, a, p, i, o, m);
			f[t] = s.style, f[n] = s.display, (r === "hours" || r === "minutes" || r === "seconds" || r === "milliseconds" || r === "microseconds") && (m = s.style);
		}), f.fractionalDigits = Is(a, "fractionalDigits", 0, 9, void 0);
	}
	resolvedOptions() {
		if (typeof this != "object" || !Ms(e, this)) throw TypeError("Method Intl.DurationFormat.prototype.resolvedOptions called on incompatible receiver");
		let t = ic(this), n = {};
		for (let e of bc) {
			let r = t[e];
			if (e === "fractionalDigits") {
				if (r === void 0) continue;
				r = Number(r);
			} else r === "fractional" ? r = "numeric" : Qs(r !== void 0, `Missing internal slot ${e}`);
			n[e] = r;
		}
		return n;
	}
	formatToParts(e) {
		if (ic(this).initializedDurationFormat === void 0) throw TypeError("Error uninitialized locale");
		let t = gc(e), n = ac(this, t), r = [];
		for (let { type: e, unit: t, value: i } of n) {
			let n = {
				type: e,
				value: i
			};
			t && (n.unit = t), r.push(n);
		}
		return r;
	}
	format(e) {
		if (ic(this).initializedDurationFormat === void 0) throw TypeError("Error uninitialized locale");
		let t = gc(e), n = ac(this, t), r = "";
		for (let { value: e } of n) r += e;
		return r;
	}
	static supportedLocalesOf(t, n) {
		return zs(e.availableLocales, Ps(t), n);
	}
	static {
		this.__defaultLocale = "en";
	}
	static {
		this.availableLocales = /* @__PURE__ */ new Set();
	}
	static {
		this.localeData = Object.keys(_c.localeData).reduce((t, n) => (e.availableLocales.add(n), t[n] = {
			get nu() {
				let e = _c.localeData[n].nu;
				return [.../* @__PURE__ */ new Set([...e, ...yc()])];
			},
			digitalFormat: {
				default: _c.default,
				..._c.localeData[n].separator
			}
		}, t), {});
	}
	static {
		this.getDefaultLocale = () => e.__defaultLocale;
	}
	static {
		this.polyfilled = !0;
	}
};
Object.defineProperty(Sc, "length", {
	value: 0,
	configurable: !0
}), Object.defineProperty(Sc.supportedLocalesOf, "length", {
	value: 1,
	configurable: !0
}), Object.defineProperty(Sc.prototype, Symbol.toStringTag, {
	value: "Intl.DurationFormat",
	configurable: !0
}), Intl.DurationFormat;
function Cc(e) {
	return Lo.Now.plainDateTimeISO().add(e);
}
function wc(e) {
	return new Date(e.toZonedDateTime(Lo.Now.timeZoneId()).epochMilliseconds);
}
function Tc(e) {
	return new Date(Lo.Now.zonedDateTimeISO().add(e).epochMilliseconds);
}
//#endregion
export { s as a, Lo as i, Tc as n, wc as r, Cc as t };
